import * as i0 from '@angular/core';
import { Component, Injectable, signal, computed, EventEmitter, Input, Output, input, ViewChild, Pipe, InjectionToken, Inject, NgModule, HostListener, ContentChild, inject, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import * as i5 from '@angular/common';
import { CommonModule, DOCUMENT, registerLocaleData, PercentPipe } from '@angular/common';
import * as i2 from '@ngx-translate/core';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import * as i1$1 from '@angular/router';
import { NavigationEnd, RouterModule, Router } from '@angular/router';
import { BehaviorSubject, switchMap, skipWhile, map as map$1, NEVER, of, tap as tap$1, from, Subject, firstValueFrom, fromEvent, merge, noop, catchError, throwError, forkJoin } from 'rxjs';
import * as i1 from '@angular/common/http';
import { HttpParams, HttpHeaders, HttpStatusCode, HttpErrorResponse, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { map, tap, debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import dayjs from 'dayjs';
import * as i3 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule, FormControl, FormArray, FormGroup } from '@angular/forms';
import * as i5$1 from 'primeng/editor';
import { EditorModule } from 'primeng/editor';
import { Md5 } from 'ts-md5';
import { toSignal } from '@angular/core/rxjs-interop';
import * as Sentry from '@sentry/angular';
import { getFeedback } from '@sentry/angular';
import * as i2$1 from 'keycloak-angular';
import { KeycloakEventType, KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { strings } from 'ngx-timeago/language-strings/en';
import { strings as strings$1 } from 'ngx-timeago/language-strings/de';
import * as i3$1 from 'ngx-timeago';
import { TimeagoModule, TimeagoIntl, TimeagoCustomFormatter, TimeagoFormatter, TimeagoPipe } from 'ngx-timeago';
import * as i4 from 'ngx-bootstrap/alert';
import { AlertModule } from 'ngx-bootstrap/alert';
import * as i1$2 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i4$1 from '@angular/platform-browser';
import * as i1$3 from 'ngx-bootstrap/modal';
import * as i7 from '@angular/material/paginator';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import * as i8 from '@angular/material/sort';
import { MatSort, MatSortModule } from '@angular/material/sort';
import * as i6 from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import * as i10 from 'angular2-ladda';
import { LaddaModule } from 'angular2-ladda';
import { MatInputModule } from '@angular/material/input';
import * as i4$2 from 'ngx-bootstrap/datepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MarkdownModule } from 'ngx-markdown';
import Quill, { Parchment } from 'quill';
import ImageResizor from 'quill-image-resizor';
import { AlignStyle } from 'quill/formats/align';
import { BackgroundStyle } from 'quill/formats/background';
import { ColorStyle } from 'quill/formats/color';
import { DirectionStyle } from 'quill/formats/direction';
import { FontStyle } from 'quill/formats/font';
import * as de from '@angular/common/locales/de';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import 'dayjs/locale/de';

class P404Component {
    constructor(location) {
        this.location = location;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: P404Component, deps: [{ token: i5.Location }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: P404Component, selector: "app-p404", ngImport: i0, template: "<div class=\"page\">\n  <img class=\"scanner\" src=\"./assets/img/scanner.png\">\n  <p class=\"error\">404</p>\n  <p translate>page_not_found</p>\n  <button class=\"button\" (click)=\"location.back()\" translate>go_back</button>\n  <img class=\"img-fluid nimmsta-logo\" src=\"./assets/img/logo.png\">\n</div>\n", styles: [".page{font-family:Axis;display:flex;flex-direction:column;align-items:center;color:#0090bd;height:100%;padding-top:12%;padding-bottom:5%}.page p{font-size:500%;margin:1rem 5%;text-align:center}.page img.scanner{max-height:25%}.page img.nimmsta-logo{max-height:10%;margin-top:auto}.page .error{margin-bottom:0}.page .button{width:25%;font-size:125%;padding:1rem 0;border-radius:0;border:1px solid #0090bd;background-color:transparent;color:#0090bd;transition:all .3s ease-in-out}.page .button:hover{background-color:#0090bd;color:#fff}@media (max-width: 992px){.page p{font-size:350%}.page .button{width:35%;font-size:120%}}@media (max-width: 768px){.page{padding-top:20%}.page p{font-size:280%}.page .button{width:50%;font-size:100%}}\n"], dependencies: [{ kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: P404Component, decorators: [{
            type: Component,
            args: [{ selector: 'app-p404', template: "<div class=\"page\">\n  <img class=\"scanner\" src=\"./assets/img/scanner.png\">\n  <p class=\"error\">404</p>\n  <p translate>page_not_found</p>\n  <button class=\"button\" (click)=\"location.back()\" translate>go_back</button>\n  <img class=\"img-fluid nimmsta-logo\" src=\"./assets/img/logo.png\">\n</div>\n", styles: [".page{font-family:Axis;display:flex;flex-direction:column;align-items:center;color:#0090bd;height:100%;padding-top:12%;padding-bottom:5%}.page p{font-size:500%;margin:1rem 5%;text-align:center}.page img.scanner{max-height:25%}.page img.nimmsta-logo{max-height:10%;margin-top:auto}.page .error{margin-bottom:0}.page .button{width:25%;font-size:125%;padding:1rem 0;border-radius:0;border:1px solid #0090bd;background-color:transparent;color:#0090bd;transition:all .3s ease-in-out}.page .button:hover{background-color:#0090bd;color:#fff}@media (max-width: 992px){.page p{font-size:350%}.page .button{width:35%;font-size:120%}}@media (max-width: 768px){.page{padding-top:20%}.page p{font-size:280%}.page .button{width:50%;font-size:100%}}\n"] }]
        }], ctorParameters: () => [{ type: i5.Location }] });

class P500Component {
    constructor(location) {
        this.location = location;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: P500Component, deps: [{ token: i5.Location }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: P500Component, selector: "app-p500", ngImport: i0, template: "<div class=\"page\">\n  <img class=\"scanner\" src=\"./assets/img/scanner.png\">\n  <p class=\"error\">500</p>\n  <p translate>internal_server_error</p>\n  <button class=\"button\" (click)=\"location.back()\" translate>go_back</button>\n  <img class=\"img-fluid nimmsta-logo\" src=\"./assets/img/logo.png\">\n</div>\n", styles: [".page{font-family:Axis;display:flex;flex-direction:column;align-items:center;color:#0090bd;height:100%;padding-top:12%;padding-bottom:5%}.page p{font-size:500%;margin:1rem 5%;text-align:center}.page img.scanner{max-height:25%}.page img.nimmsta-logo{max-height:10%;margin-top:auto}.page .error{margin-bottom:0}.page .button{width:25%;font-size:125%;padding:1rem 0;border-radius:0;border:1px solid #0090bd;background-color:transparent;color:#0090bd;transition:all .3s ease-in-out}.page .button:hover{background-color:#0090bd;color:#fff}@media (max-width: 992px){.page p{font-size:350%}.page .button{width:35%;font-size:120%}}@media (max-width: 768px){.page{padding-top:20%}.page p{font-size:280%}.page .button{width:50%;font-size:100%}}\n"], dependencies: [{ kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: P500Component, decorators: [{
            type: Component,
            args: [{ selector: 'app-p500', template: "<div class=\"page\">\n  <img class=\"scanner\" src=\"./assets/img/scanner.png\">\n  <p class=\"error\">500</p>\n  <p translate>internal_server_error</p>\n  <button class=\"button\" (click)=\"location.back()\" translate>go_back</button>\n  <img class=\"img-fluid nimmsta-logo\" src=\"./assets/img/logo.png\">\n</div>\n", styles: [".page{font-family:Axis;display:flex;flex-direction:column;align-items:center;color:#0090bd;height:100%;padding-top:12%;padding-bottom:5%}.page p{font-size:500%;margin:1rem 5%;text-align:center}.page img.scanner{max-height:25%}.page img.nimmsta-logo{max-height:10%;margin-top:auto}.page .error{margin-bottom:0}.page .button{width:25%;font-size:125%;padding:1rem 0;border-radius:0;border:1px solid #0090bd;background-color:transparent;color:#0090bd;transition:all .3s ease-in-out}.page .button:hover{background-color:#0090bd;color:#fff}@media (max-width: 992px){.page p{font-size:350%}.page .button{width:35%;font-size:120%}}@media (max-width: 768px){.page{padding-top:20%}.page p{font-size:280%}.page .button{width:50%;font-size:100%}}\n"] }]
        }], ctorParameters: () => [{ type: i5.Location }] });

var Environment;
(function (Environment) {
    Environment["PROD"] = "prod";
    Environment["LOCAL"] = "local";
    Environment["DEV"] = "dev";
    Environment["STAGING"] = "stage";
})(Environment || (Environment = {}));
var ServiceType;
(function (ServiceType) {
    ServiceType["MANAGEMENT"] = "management";
    ServiceType["CLOUD"] = "cloud";
})(ServiceType || (ServiceType = {}));
class NimmstaCommonsModuleConfiguration {
    constructor(config) {
        this.apiUrls = config.apiUrls;
        this.applicationUrls = config.applicationUrls;
        this.environment = config.environment;
        this.serviceType = config.serviceType;
        this.defaultPageSizeOptions = config.defaultPageSizeOptions;
        this.defaultPageSize = config.defaultPageSize;
        this.USER_KEY = config.USER_KEY;
        this.keycloakUrl = config.keycloakUrl;
        this.keycloakRealm = config.keycloakRealm;
        this.keycloakClientId = config.keycloakClientId;
        this.defaultConfigurationVersion = config.defaultConfigurationVersion;
        this.androidAppSoftwareId = config.androidAppSoftwareId;
        this.translationFiles = config.translationFiles;
        this.maintenanceInfoSource = config.maintenanceInfoSource;
    }
}

class OfflineService {
    constructor() {
        this.offlineObservable = new BehaviorSubject({});
    }
    setOffline(serverUrl, offline = true) {
        this.offlineObservable.next({ [serverUrl]: offline });
    }
    isOffline(serverUrl) {
        return this.offlineObservable.value[serverUrl] ?? false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OfflineService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OfflineService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OfflineService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

const RETRY_INTERVAL_MS = 4000;
class OfflineToastComponent {
    constructor(offlineService, http, configuration) {
        this.offlineService = offlineService;
        this.http = http;
        this.configuration = configuration;
        this.offlineStates = signal({});
        this.showToast = computed(() => Object.values(this.offlineStates()).some((offline) => offline));
        this.intervals = [];
    }
    ngOnInit() {
        this.offlineService.offlineObservable.subscribe((notification) => {
            const changed = Object.keys(notification) !== Object.keys(this.offlineStates())
                || Object.keys(notification).some((key) => this.offlineStates()[key] !== notification[key]);
            if (changed) {
                this.offlineStates.set(notification);
                if (this.configuration.environment === Environment.LOCAL) {
                    // Don't reload the page in local environment as services won't run on default
                    return;
                }
                this.intervals.forEach((interval) => clearInterval(interval));
                Object.entries(this.offlineStates()).forEach(([serviceUrl, offline]) => {
                    if (offline) {
                        this.intervals.push(setInterval(() => {
                            this.tryAgain(serviceUrl);
                        }, RETRY_INTERVAL_MS, []));
                    }
                });
            }
        });
    }
    tryAgain(serviceUrl) {
        this.http.get(`${serviceUrl}/actuator/health`).subscribe({
            next: () => {
                this.offlineService.setOffline(serviceUrl, false);
                this.offlineStates.set({ ...this.offlineStates(), [serviceUrl]: false });
                this.conditionalReload();
            },
        });
    }
    /**
     * Reload the page if all services are back online
     */
    conditionalReload() {
        if (!Object.values(this.offlineStates()).some((offline) => offline)) {
            window.location.reload();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OfflineToastComponent, deps: [{ token: OfflineService }, { token: i1.HttpClient }, { token: NimmstaCommonsModuleConfiguration }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: OfflineToastComponent, selector: "app-offline-toast", ngImport: i0, template: "<div [class.show]=\"showToast()\" style=\"z-index: 9999;\" class=\"toast align-items-center text-bg-danger border-0 bottom-0 end-0 position-absolute me-2 mb-2\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\">\n  <div class=\"d-flex\">\n    <div class=\"toast-body\" translate>\n      server_offline\n    </div>\n    <button type=\"button\" class=\"btn-close btn-close-white me-2 m-auto\" data-bs-dismiss=\"toast\" aria-label=\"Close\"></button>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OfflineToastComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-offline-toast', template: "<div [class.show]=\"showToast()\" style=\"z-index: 9999;\" class=\"toast align-items-center text-bg-danger border-0 bottom-0 end-0 position-absolute me-2 mb-2\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\">\n  <div class=\"d-flex\">\n    <div class=\"toast-body\" translate>\n      server_offline\n    </div>\n    <button type=\"button\" class=\"btn-close btn-close-white me-2 m-auto\" data-bs-dismiss=\"toast\" aria-label=\"Close\"></button>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: OfflineService }, { type: i1.HttpClient }, { type: NimmstaCommonsModuleConfiguration }] });

const LARGE_BREAKPOINT = 992;
class DefaultLayoutComponent {
    constructor(router, configuration) {
        this.router = router;
        this.configuration = configuration;
        this.collapsed = true;
        this.mobileExpanded = false;
        this.environment = signal(undefined);
        this.Environment = Environment;
        this.serviceType = this.configuration.serviceType;
        this.ServiceType = ServiceType;
        this.showEnvironment = computed(() => { const env = this.environment(); return !!env && env !== Environment.PROD; });
        this.collapseState = new EventEmitter();
        this.mobileExpandedState = new EventEmitter();
    }
    ngOnInit() {
        const observer = new ResizeObserver(() => {
            // Ignore the fact that there might be multiple change elements. We check for the current state only anyway.
            this.checkCollapse();
        });
        observer.observe(document.querySelector('body'));
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.hideMobileNav();
            }
        });
        this.checkCollapse();
        // force initialisation of the collapse state
        this.collapseState.emit(this.collapsed);
        this.environment.set(this.configuration.environment);
    }
    checkCollapse() {
        const newCollapsed = window.innerWidth < LARGE_BREAKPOINT;
        if (this.collapsed !== newCollapsed) {
            this.setCollapseState(newCollapsed);
        }
    }
    setCollapseState(collapsed) {
        this.collapsed = collapsed;
        this.collapseState.emit(collapsed);
    }
    toggleCollapse() {
        this.setCollapseState(!this.collapsed);
    }
    hideMobileNav() {
        if (this.mobileExpanded) {
            this.toggleMobileNav();
        }
    }
    toggleMobileNav() {
        this.mobileExpanded = !this.mobileExpanded;
        this.mobileExpandedState.emit(this.mobileExpanded);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DefaultLayoutComponent, deps: [{ token: i1$1.Router }, { token: NimmstaCommonsModuleConfiguration }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: DefaultLayoutComponent, selector: "app-default-layout", inputs: { frontendVersion: "frontendVersion", backendVersion: "backendVersion" }, outputs: { collapseState: "collapseState", mobileExpandedState: "mobileExpandedState" }, ngImport: i0, template: "<div class=\"side-bar-container d-flex\">\n  <div class=\"side-bar collapsed\" [class.collapsed]=\"collapsed\">\n    <div class=\"inner\">\n      <div class=\"logo-holder\">\n        <a [routerLink]=\"['/dashboard']\">\n          <img src=\"./assets/img/logo.png\" class=\"logo\" />\n          <img src=\"./assets/img/logo_small.png\" class=\"logo-small\" />\n        </a>\n      </div>\n      <nav [class.prod-margin]=\"environment() === Environment.PROD && serviceType === ServiceType.CLOUD\">\n        <ng-content select=\"[slot=sidebar]\"></ng-content>\n      </nav>\n      <a class=\"btn text-dark toggle\" (click)=\"toggleCollapse()\">\n        <span class=\"icon material-icons-outlined\"></span>\n      </a>\n    </div>\n  </div>\n  <nav class=\"mobile-nav position-fixed\" [class.expanded]=\"mobileExpanded\">\n    <div class=\"d-flex flex-column h-100\">\n      <div class=\"bg-white mobile-header\">\n        <div (click)=\"toggleMobileNav()\" class=\"menu-icon material-symbols-outlined\">menu</div>\n        <div class=\"d-flex flex-grow-1 justify-content-center\">\n          <img [routerLink]=\"['/dashboard']\" routerLinkActive=\"active\" src=\"./assets/img/logo.png\" class=\"logo\" />\n        </div>\n      </div>\n      <ng-content select=\"[slot=mobile]\"></ng-content>\n      <div class=\"overlay\" [class.expanded]=\"mobileExpanded\" (click)=\"toggleMobileNav()\"></div>\n    </div>\n  </nav>\n  <div id=\"content\" [style.height]=\"showEnvironment() ? 'calc(100% - 20px - 14px)' : 'calc(100% - 14px)'\">\n    @if (showEnvironment()) {\n    <div class=\"d-flex justify-content-end pe-1\" style=\"color: red; font-size: 0.9em; height: 20px;\">\n      <span class=\"fw-bold\">Backend: {{environment()}}</span>\n    </div>\n    }\n    <div class=\"root-container\">\n      <router-outlet></router-outlet>\n    </div>\n    <div class=\"fw-light d-flex gap-1 justify-content-end pe-1\"\n      style=\"right: 0.2rem; color: gray; font-size: 0.6em; height: 14px;\">\n      <a [href]=\"'imprint.url' | translate\" translate target=\"_blank\">imprint.label</a>\n      <span>\u25E6</span>\n      <a [href]=\"'privacy.url' | translate\" translate target=\"_blank\">privacy.label</a>\n      <span>\u25E6</span>\n      <a [href]=\"'terms.url' | translate\" translate target=\"_blank\">terms.label</a>\n      <span>\u25E6</span>\n      <a [routerLink]=\"['/licenses']\" translate>licenses.title</a>\n      @if (frontendVersion || backendVersion) {\n      <span>|</span>\n      }\n      @if (frontendVersion) {\n      <span>F.{{frontendVersion.tag ? frontendVersion.tag : frontendVersion.hash}}</span>\n      }\n      @if (frontendVersion && backendVersion) {\n      <span>\u25E6</span>\n      }\n      @if (backendVersion) {\n      <span>B.{{backendVersion.tag ? backendVersion.tag : backendVersion.hash}}</span>\n      }\n    </div>\n  </div>\n</div>\n\n<app-offline-toast></app-offline-toast>\n", styles: [".side-bar-container{height:100%}.side-bar{position:relative;flex-shrink:0;width:310px;background-color:#fff;transition:.5s;overflow-y:scroll;overflow-x:hidden}.side-bar .inner{padding-top:48px;height:100%;display:flex;flex-direction:column}.side-bar .logo-holder{position:relative;margin-left:22px;margin-right:22px}.side-bar .logo-holder .logo{width:266px;margin-bottom:48px;transition:opacity .4s ease-out}.side-bar .logo-holder .logo-small{position:absolute;top:0;left:0;margin-bottom:48px;width:43px}.side-bar nav{padding-top:1.5rem}.side-bar nav.prod-margin{margin-bottom:62px}.side-bar .toggle{transition:.5s;width:100%;text-align:end;padding-right:2rem;margin-top:auto}.side-bar .toggle:active{border:none}.side-bar .toggle .icon:before{content:\"keyboard_double_arrow_left\"}.side-bar.collapsed{width:92px}.side-bar.collapsed .logo{opacity:0}.side-bar.collapsed .logo-small{display:block}.side-bar.collapsed .toggle .icon:before{content:\"keyboard_double_arrow_right\"}.mobile-nav{display:none;position:absolute;z-index:999;width:100%}.mobile-nav app-menu{z-index:9999}.mobile-nav .overlay{flex-grow:1;background:#000;opacity:0;visibility:hidden;transition:all .5s ease}.mobile-nav .overlay.expanded{visibility:visible;opacity:.5}.root-container{padding:0 1rem}#content{width:calc(100% - 310px);transition:.5s}.collapsed~#content{width:calc(100% - 92px)}@media (min-width: 992px){.root-container{padding:0 45px}}@media (max-width: 575.98px){.mobile-nav{display:block}.mobile-nav.expanded{height:100%}#content{width:100%!important}.side-bar{display:none}.mobile-header{display:block}.mobile-header .menu-icon{margin:8px;font-size:2.5rem;position:absolute}.mobile-header .logo{height:48px;margin:4px auto}.overlay{display:block;flex-grow:1;background:#000;opacity:0;visibility:hidden;transition:all .5s ease}.overlay.expanded{visibility:visible;opacity:.5}}\n"], dependencies: [{ kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "directive", type: i1$1.RouterOutlet, selector: "router-outlet", inputs: ["name"], outputs: ["activate", "deactivate", "attach", "detach"], exportAs: ["outlet"] }, { kind: "directive", type: i1$1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i1$1.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "ariaCurrentWhenActive", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }, { kind: "component", type: OfflineToastComponent, selector: "app-offline-toast" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DefaultLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-default-layout', template: "<div class=\"side-bar-container d-flex\">\n  <div class=\"side-bar collapsed\" [class.collapsed]=\"collapsed\">\n    <div class=\"inner\">\n      <div class=\"logo-holder\">\n        <a [routerLink]=\"['/dashboard']\">\n          <img src=\"./assets/img/logo.png\" class=\"logo\" />\n          <img src=\"./assets/img/logo_small.png\" class=\"logo-small\" />\n        </a>\n      </div>\n      <nav [class.prod-margin]=\"environment() === Environment.PROD && serviceType === ServiceType.CLOUD\">\n        <ng-content select=\"[slot=sidebar]\"></ng-content>\n      </nav>\n      <a class=\"btn text-dark toggle\" (click)=\"toggleCollapse()\">\n        <span class=\"icon material-icons-outlined\"></span>\n      </a>\n    </div>\n  </div>\n  <nav class=\"mobile-nav position-fixed\" [class.expanded]=\"mobileExpanded\">\n    <div class=\"d-flex flex-column h-100\">\n      <div class=\"bg-white mobile-header\">\n        <div (click)=\"toggleMobileNav()\" class=\"menu-icon material-symbols-outlined\">menu</div>\n        <div class=\"d-flex flex-grow-1 justify-content-center\">\n          <img [routerLink]=\"['/dashboard']\" routerLinkActive=\"active\" src=\"./assets/img/logo.png\" class=\"logo\" />\n        </div>\n      </div>\n      <ng-content select=\"[slot=mobile]\"></ng-content>\n      <div class=\"overlay\" [class.expanded]=\"mobileExpanded\" (click)=\"toggleMobileNav()\"></div>\n    </div>\n  </nav>\n  <div id=\"content\" [style.height]=\"showEnvironment() ? 'calc(100% - 20px - 14px)' : 'calc(100% - 14px)'\">\n    @if (showEnvironment()) {\n    <div class=\"d-flex justify-content-end pe-1\" style=\"color: red; font-size: 0.9em; height: 20px;\">\n      <span class=\"fw-bold\">Backend: {{environment()}}</span>\n    </div>\n    }\n    <div class=\"root-container\">\n      <router-outlet></router-outlet>\n    </div>\n    <div class=\"fw-light d-flex gap-1 justify-content-end pe-1\"\n      style=\"right: 0.2rem; color: gray; font-size: 0.6em; height: 14px;\">\n      <a [href]=\"'imprint.url' | translate\" translate target=\"_blank\">imprint.label</a>\n      <span>\u25E6</span>\n      <a [href]=\"'privacy.url' | translate\" translate target=\"_blank\">privacy.label</a>\n      <span>\u25E6</span>\n      <a [href]=\"'terms.url' | translate\" translate target=\"_blank\">terms.label</a>\n      <span>\u25E6</span>\n      <a [routerLink]=\"['/licenses']\" translate>licenses.title</a>\n      @if (frontendVersion || backendVersion) {\n      <span>|</span>\n      }\n      @if (frontendVersion) {\n      <span>F.{{frontendVersion.tag ? frontendVersion.tag : frontendVersion.hash}}</span>\n      }\n      @if (frontendVersion && backendVersion) {\n      <span>\u25E6</span>\n      }\n      @if (backendVersion) {\n      <span>B.{{backendVersion.tag ? backendVersion.tag : backendVersion.hash}}</span>\n      }\n    </div>\n  </div>\n</div>\n\n<app-offline-toast></app-offline-toast>\n", styles: [".side-bar-container{height:100%}.side-bar{position:relative;flex-shrink:0;width:310px;background-color:#fff;transition:.5s;overflow-y:scroll;overflow-x:hidden}.side-bar .inner{padding-top:48px;height:100%;display:flex;flex-direction:column}.side-bar .logo-holder{position:relative;margin-left:22px;margin-right:22px}.side-bar .logo-holder .logo{width:266px;margin-bottom:48px;transition:opacity .4s ease-out}.side-bar .logo-holder .logo-small{position:absolute;top:0;left:0;margin-bottom:48px;width:43px}.side-bar nav{padding-top:1.5rem}.side-bar nav.prod-margin{margin-bottom:62px}.side-bar .toggle{transition:.5s;width:100%;text-align:end;padding-right:2rem;margin-top:auto}.side-bar .toggle:active{border:none}.side-bar .toggle .icon:before{content:\"keyboard_double_arrow_left\"}.side-bar.collapsed{width:92px}.side-bar.collapsed .logo{opacity:0}.side-bar.collapsed .logo-small{display:block}.side-bar.collapsed .toggle .icon:before{content:\"keyboard_double_arrow_right\"}.mobile-nav{display:none;position:absolute;z-index:999;width:100%}.mobile-nav app-menu{z-index:9999}.mobile-nav .overlay{flex-grow:1;background:#000;opacity:0;visibility:hidden;transition:all .5s ease}.mobile-nav .overlay.expanded{visibility:visible;opacity:.5}.root-container{padding:0 1rem}#content{width:calc(100% - 310px);transition:.5s}.collapsed~#content{width:calc(100% - 92px)}@media (min-width: 992px){.root-container{padding:0 45px}}@media (max-width: 575.98px){.mobile-nav{display:block}.mobile-nav.expanded{height:100%}#content{width:100%!important}.side-bar{display:none}.mobile-header{display:block}.mobile-header .menu-icon{margin:8px;font-size:2.5rem;position:absolute}.mobile-header .logo{height:48px;margin:4px auto}.overlay{display:block;flex-grow:1;background:#000;opacity:0;visibility:hidden;transition:all .5s ease}.overlay.expanded{visibility:visible;opacity:.5}}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.Router }, { type: NimmstaCommonsModuleConfiguration }], propDecorators: { collapseState: [{
                type: Output
            }], mobileExpandedState: [{
                type: Output
            }], frontendVersion: [{
                type: Input
            }], backendVersion: [{
                type: Input
            }] } });

const IMPERSONATION_SESSION_STORAGE_KEY = 'sessionImpersonation';
const IMPERSONATION_SESSION_ENDED = 'sessionImpersonationEnded';

class DataTableModuleConfiguration {
    constructor(config) {
        this.defaultPageSizeOptions = config.defaultPageSizeOptions;
        this.defaultPageSize = config.defaultPageSize;
        this.apiUrls = config.apiUrls;
    }
}

class AbstractDataService {
    get apiEndpoint() {
        return this._apiEndpoint;
    }
    set apiEndpoint(value) {
        this._apiEndpoint = value;
    }
    constructor(http, configuration, baseUrl) {
        this.http = http;
        this.configuration = configuration;
        this.baseUrl = baseUrl;
        this.defaultSFSOptions = {
            search: '',
            filter: [],
            sortColumn: '',
            sortOrder: 'asc',
            pageNumber: 0,
            pageSize: this.configuration.defaultPageSize,
        };
    }
    list(options = {}) {
        const params = this.getParams(options);
        return this.http.get(this.baseUrl + this.apiEndpoint, {
            params,
        }).pipe(map((page) => {
            // eslint-disable-next-line no-param-reassign
            page.content = page.content.map(this.loadedDataTransform);
            return page;
        }));
    }
    getParams(partialOptions) {
        const options = {
            ...this.defaultSFSOptions,
            ...partialOptions,
        }; // fields can (still) be undefined
        let params = new HttpParams();
        if (options.search !== undefined && options.search !== '') {
            params = params.append('search', options.search);
        }
        if (options.filter && options.filter.length > 0) {
            options.filter.forEach((f) => {
                params = params.append('filters', f);
            });
        }
        if (options.sortColumn !== undefined && options.sortColumn !== '') {
            // Hot-fix, because Spring does not support property names with _ in them.
            // (e.g. given_name, will be treated as given)
            params = params.append('sort', `${options.sortColumn.replace('_', '')},${options.sortOrder}`);
        }
        if (options.pageNumber !== undefined) {
            params = params.append('page', options.pageNumber.toString());
        }
        if (options.pageSize !== undefined) {
            params = params.append('size', options.pageSize.toString());
        }
        if (options.additionalQueryParams) {
            options.additionalQueryParams.keys().forEach((key) => {
                params = params.append(key, `${options.additionalQueryParams.get(key)}`);
            });
        }
        return params;
    }
    get(id) {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/${id}`).pipe(map(this.loadedDataTransform));
    }
    createOrUpdate(object) {
        if (!object.id) {
            return this.create(object);
        }
        return this.update(object);
    }
    create(object) {
        return this.http.post(this.baseUrl + this.apiEndpoint, object, { headers: this.getHeades() }).pipe(map(this.loadedDataTransform));
    }
    update(object) {
        return this.http.put(`${this.baseUrl + this.apiEndpoint}/${object.id}`, object, { headers: this.getHeades() }).pipe(map(this.loadedDataTransform));
    }
    delete(object) {
        return this.http.delete(`${this.baseUrl + this.apiEndpoint}/${object.id}`);
    }
    loadedDataTransform(data) {
        /* eslint-disable no-param-reassign */
        data.createdAt = data.createdAt ? dayjs(data.createdAt) : data.createdAt;
        data.lastUpdatedAt = data.lastUpdatedAt ? dayjs(data.lastUpdatedAt) : data.lastUpdatedAt;
        return data;
    }
    getHeades() {
        const impersonationDataJson = sessionStorage.getItem(IMPERSONATION_SESSION_STORAGE_KEY);
        if (impersonationDataJson !== null) {
            const impersonationData = JSON.parse(impersonationDataJson);
            return new HttpHeaders({
                'X-ACTING-USER': impersonationData.actor,
            });
        }
        return new HttpHeaders();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AbstractDataService, deps: "invalid", target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AbstractDataService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AbstractDataService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: DataTableModuleConfiguration }, { type: undefined }] });

class WorkflowDataService extends AbstractDataService {
    constructor(http, configuration) {
        if (!configuration.apiUrls.workflow) {
            throw new Error('Workflow API URL is not configured');
        }
        super(http, configuration, `${configuration.apiUrls.workflow}/api/v1`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkflowDataService, deps: [{ token: i1.HttpClient }, { token: DataTableModuleConfiguration }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkflowDataService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkflowDataService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: DataTableModuleConfiguration }] });

class ContentsService extends WorkflowDataService {
    get apiEndpoint() {
        return '/content';
    }
    getTree() {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/tree`);
    }
    getSignedUploadUrl(filename, contentType) {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/upload-url`, { params: { filename, contentType } });
    }
    getForView(id) {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/${id}/view`);
    }
    getTreeOfParent(id) {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/${id}/tree`);
    }
    getTreeForManagement() {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/tree?showFull`);
    }
    getChildren(id) {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/${id}/children`);
    }
    sort(id, sortedIds) {
        return this.http.put(`${this.baseUrl + this.apiEndpoint}/${id}/sort`, sortedIds);
    }
    hide(id) {
        return this.http.patch(`${this.baseUrl + this.apiEndpoint}/${id}/hide`, null);
    }
    show(id) {
        return this.http.patch(`${this.baseUrl + this.apiEndpoint}/${id}/show`, null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ContentsService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ContentsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ContentsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class EditorComponent {
    constructor(contentsService, http) {
        this.contentsService = contentsService;
        this.http = http;
        this.inline = input(true);
        this.allowPdf = input(false);
        this.table = input(false);
        this.editorConfig = input();
        this.modules = computed(() => {
            const config = this.editorConfig();
            if (!config || !config['toolbar']) {
                return config;
            }
            const allowPdf = this.allowPdf();
            const inline = this.inline();
            // Allow PDF usage only if it gets uploaded
            const handlers = {};
            if (!inline && allowPdf) {
                handlers['pdf'] = () => this.pdf();
            }
            if (!inline) {
                handlers['image'] = () => this.image();
            }
            if (this.table()) {
                config['table'] = true;
                handlers['table_insert'] = () => this.tableInsert();
                handlers['table_append_row'] = () => this.tableAppendRow();
                handlers['table_append_column'] = () => this.tableAppendColumn();
                handlers['table_delete_row'] = () => this.tableDeleteRow();
                handlers['table_delete_column'] = () => this.tableDeleteColumn();
                handlers['table_delete_table'] = () => this.tableDeleteTable();
            }
            if (Object.keys(handlers).length > 0) {
                if (Array.isArray(config['toolbar'])) {
                    config['toolbar'] = {
                        container: config['toolbar'],
                        handlers,
                    };
                }
                else {
                    config['toolbar'] = {
                        container: config.container,
                        handlers,
                    };
                }
            }
            return config;
        });
        this.contentChange = new EventEmitter(); // Emit changes to parent
    }
    pdf() {
        if (this.inline() || !this.allowPdf()) {
            return;
        }
        const fileInput = document.createElement('input');
        fileInput.setAttribute('type', 'file');
        fileInput.setAttribute('accept', 'application/pdf');
        fileInput.click();
        fileInput.onchange = async () => {
            const file = fileInput?.files?.[0];
            this.runUpload('pdf', file);
        };
    }
    image() {
        if (this.inline()) {
            return;
        }
        const fileInput = document.createElement('input');
        fileInput.setAttribute('type', 'file');
        fileInput.setAttribute('accept', 'image/*');
        fileInput.click();
        fileInput.onchange = async () => {
            const file = fileInput?.files?.[0];
            return this.runUpload('image', file);
        };
    }
    runUpload(embedType, file) {
        if (!file) {
            return;
        }
        const range = this.quillInstance.getSelection();
        if (!range) {
            return;
        }
        const contentType = file.type;
        const fileName = file.name;
        this.contentsService.getSignedUploadUrl(fileName, contentType).pipe(tap(({ key }) => {
            const fullSrc = URL.createObjectURL(file);
            this.quillInstance.insertEmbed(range.index, embedType, { src: fullSrc, key }, 'user');
        }), switchMap(({ url }) => this.http.put(url, file))).subscribe();
    }
    tableInsert() {
        const range = this.quillInstance.getSelection();
        if (!range) {
            return;
        }
        const table = this.quillInstance.getModule('table');
        table.insertTable(2, 2);
    }
    tableAppendRow() {
        const range = this.quillInstance.getSelection();
        if (!range) {
            return;
        }
        const table = this.quillInstance.getModule('table');
        table.insertRowBelow();
    }
    tableAppendColumn() {
        const range = this.quillInstance.getSelection();
        if (!range) {
            return;
        }
        const table = this.quillInstance.getModule('table');
        table.insertColumnRight();
    }
    tableDeleteRow() {
        const range = this.quillInstance.getSelection();
        if (!range) {
            return;
        }
        const table = this.quillInstance.getModule('table');
        table.deleteRow();
    }
    tableDeleteColumn() {
        const range = this.quillInstance.getSelection();
        if (!range) {
            return;
        }
        const table = this.quillInstance.getModule('table');
        table.deleteColumn();
    }
    tableDeleteTable() {
        const range = this.quillInstance.getSelection();
        if (!range) {
            return;
        }
        const table = this.quillInstance.getModule('table');
        table.deleteTable();
    }
    onEditorCreated(event) {
        this.quillInstance = event.editor;
    }
    onContentChanged(event) {
        this.contentChange.emit(event.htmlValue);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: EditorComponent, deps: [{ token: ContentsService }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.13", type: EditorComponent, selector: "app-editor", inputs: { value: { classPropertyName: "value", publicName: "value", isSignal: false, isRequired: false, transformFunction: null }, inline: { classPropertyName: "inline", publicName: "inline", isSignal: true, isRequired: false, transformFunction: null }, allowPdf: { classPropertyName: "allowPdf", publicName: "allowPdf", isSignal: true, isRequired: false, transformFunction: null }, table: { classPropertyName: "table", publicName: "table", isSignal: true, isRequired: false, transformFunction: null }, ngClass: { classPropertyName: "ngClass", publicName: "ngClass", isSignal: false, isRequired: false, transformFunction: null }, editorConfig: { classPropertyName: "editorConfig", publicName: "editorConfig", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { contentChange: "contentChange" }, viewQueries: [{ propertyName: "editorRef", first: true, predicate: ["editorRef"], descendants: true }], ngImport: i0, template: "<p-editor\n  #editorRef\n  [ngClass]=\"ngClass\"\n  [ngModel]=\"value\"\n  [modules]=\"modules()\"\n  (onInit)=\"onEditorCreated($event)\"\n  (onTextChange)=\"onContentChanged($event)\">\n</p-editor>\n", styles: ["::ng-deep .p-editor .p-editor-toolbar{display:none}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i5$1.Editor, selector: "p-editor", inputs: ["style", "styleClass", "placeholder", "formats", "modules", "bounds", "scrollingContainer", "debug", "readonly"], outputs: ["onInit", "onTextChange", "onSelectionChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: EditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-editor', template: "<p-editor\n  #editorRef\n  [ngClass]=\"ngClass\"\n  [ngModel]=\"value\"\n  [modules]=\"modules()\"\n  (onInit)=\"onEditorCreated($event)\"\n  (onTextChange)=\"onContentChanged($event)\">\n</p-editor>\n", styles: ["::ng-deep .p-editor .p-editor-toolbar{display:none}\n"] }]
        }], ctorParameters: () => [{ type: ContentsService }, { type: i1.HttpClient }], propDecorators: { editorRef: [{
                type: ViewChild,
                args: ['editorRef']
            }], value: [{
                type: Input
            }], ngClass: [{
                type: Input
            }], contentChange: [{
                type: Output
            }] } });

var DateTimeFormat;
(function (DateTimeFormat) {
    DateTimeFormat["DATE"] = "L";
    DateTimeFormat["DATE_TIME_SHORT"] = "L LT";
    DateTimeFormat["DATE_TIME_LONG"] = "L LTS";
})(DateTimeFormat || (DateTimeFormat = {}));
class DateTimePipe {
    transform(value, format = DateTimeFormat.DATE_TIME_SHORT) {
        let date;
        if (typeof value === 'number' && value < 10000000000) {
            date = dayjs(value * 1000);
        }
        else if (typeof value === 'string' && /^\d+$/.test(value)) {
            date = dayjs(Number.parseInt(value, 10));
        }
        else if (value) {
            date = dayjs(value);
        }
        return date?.locale(dayjs.locale()).format(format) || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DateTimePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: DateTimePipe, name: "dateTime" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DateTimePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTime',
                }]
        }] });

const NAV_ITEM_SERVICE = new InjectionToken('NavItemService');

marker('ADMIN');
marker('MANAGER');
marker('WORKER');
var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["MANAGER"] = "MANAGER";
})(UserRole || (UserRole = {}));
const LOWEST_USER_ROLE = UserRole.MANAGER;
var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["INACTIVE"] = "INACTIVE";
})(UserStatus || (UserStatus = {}));

class CustomValidators {
    static patternValidator(regex, error) {
        return (control) => {
            if (!control.value) {
                // if control is empty return no error
                return null;
            }
            // test the value of the control against the regexp supplied
            const valid = regex.test(control.value);
            // if true, return no error (no error), else return error passed in the second parameter
            return valid ? null : error;
        };
    }
    static sameEmail(fg) {
        const email = fg.get('email');
        const emailRepeat = fg.get('email_repeat');
        if (emailRepeat && email?.value !== emailRepeat?.value) {
            emailRepeat.setErrors({ not_the_same: true });
            return { not_the_same: true };
        }
        else {
            emailRepeat?.setErrors(null);
        }
        return null;
    }
    static samePassword(fg) {
        const password = fg.get('password');
        const passwordRepeat = fg.get('password_repeat');
        if (password?.value && password?.value !== passwordRepeat?.value) {
            if (passwordRepeat) {
                passwordRepeat.setErrors({ not_matching: true });
            }
            else {
                return { not_matching: true };
            }
        }
        return null;
    }
}

var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag[FeatureFlag["FEATURE_B2B_ACCESS"] = 0] = "FEATURE_B2B_ACCESS";
})(FeatureFlag || (FeatureFlag = {}));

class OrganizationService extends WorkflowDataService {
    get apiEndpoint() {
        return '/organization';
    }
    getApiKey() {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/self/api-key`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class AuthService {
    static { this.pwdValidators = [
        Validators.minLength(8),
        Validators.maxLength(255),
        CustomValidators.patternValidator(/\d/, { hasNumber: true }),
        CustomValidators.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        CustomValidators.patternValidator(/[a-z]/, { hasSmallCase: true }),
        CustomValidators.patternValidator(/[!@#$%^&*(),.?":{}|<>']/, {
            hasSpecialCharacters: true,
        }),
    ]; }
    constructor(http, keycloakService, orgService, configuration) {
        this.http = http;
        this.keycloakService = keycloakService;
        this.orgService = orgService;
        this.configuration = configuration;
        if (!this.configuration.apiUrls.workflow) {
            throw new Error('No workflow API URL configured');
        }
        this.baseUrl = `${this.configuration.apiUrls.workflow}/api/v1/auth`;
        this.currentUserSubject = new BehaviorSubject(null);
        this.currentUser = this.currentUserSubject.asObservable();
        // Subscribe to keycloak events
        keycloakService.keycloakEvents$.subscribe({
            next: (event) => {
                switch (event.type) {
                    case KeycloakEventType.OnAuthSuccess:
                        this.loadCurrentUser();
                        break;
                    case KeycloakEventType.OnAuthRefreshError:
                        this.logout(window.location.href);
                        break;
                    case KeycloakEventType.OnAuthError:
                    case KeycloakEventType.OnAuthLogout:
                        this.currentUserSubject.next(null);
                        break;
                    default:
                        break;
                }
            },
        });
    }
    async logout(returnUrl) {
        localStorage.removeItem(this.configuration.USER_KEY);
        sessionStorage.removeItem(IMPERSONATION_SESSION_STORAGE_KEY);
        Sentry.setUser(null);
        return this.keycloakService.logout(returnUrl);
    }
    getCurrentUser() {
        return this.currentUser.pipe(skipWhile((user) => user == null), // wait until user is not null
        map$1((user) => user));
    }
    loadCurrentUser() {
        if (!this.keycloakService.isLoggedIn()) {
            return NEVER;
        }
        const idToken = this.keycloakService.getKeycloakInstance().idTokenParsed;
        if (!idToken) {
            throw new Error('Cannot parse user from id token. Id token is missing.');
        }
        return of(idToken).pipe(map$1(this.parseRole.bind(this)), map$1(this.parseFeatureFlags.bind(this)), switchMap((user) => this.orgService.get(this.getOrganizationId(user)).pipe(map$1((organization) => ({ ...user, organization })))), tap$1((user) => {
            localStorage.setItem(this.configuration.USER_KEY, JSON.stringify(user));
            this.currentUserSubject.next(user);
            this.initializeSentryContext(user);
        }));
    }
    initializeSentryContext(user) {
        Sentry.setUser({
            id: user?.id,
            email: user?.email,
            username: `${user?.given_name} ${user?.family_name}`,
            firstName: user?.given_name,
            lastName: user?.family_name,
            organization: `${user?.organization?.name} (${user?.organization?.id})`,
            role: user?.role,
        });
    }
    forgotPassword(email) {
        let params = new HttpParams();
        params = params.append('email', email);
        return this.http.get(`${this.baseUrl}/forgot-password`, { params });
    }
    resetPassword(code, username, password) {
        const body = {
            code,
            username,
            newPassword: password,
        };
        return this.http.put(`${this.baseUrl}/reset-password`, body);
    }
    add2FADevice() {
        return this.keycloakService.login({ action: 'CONFIGURE_TOTP' });
    }
    remove2FADevice(id) {
        if (!id) {
            throw new Error('No id provided');
        }
        return this.keycloakService.login({ action: `delete_credential:${id}` });
    }
    updatePassword() {
        return this.keycloakService.login({ action: 'UPDATE_PASSWORD' });
    }
    updateProfile() {
        return this.keycloakService.login({ action: 'UPDATE_PROFILE' });
    }
    getCredentials() {
        return this.http.get(`${this.configuration.keycloakUrl}/realms/${this.configuration.keycloakRealm}/account/credentials`);
    }
    resendVerification(email) {
        return this.http.put(`${this.configuration.apiUrls.workflow}/api/v1/user/resend-verification-email`, {}, { params: { email } });
    }
    requestAccess(verificationCode, email, givenName, familyName, organizationName) {
        const body = {
            email,
            givenName,
            familyName,
            organizationName,
        };
        const params = new HttpParams().set('code', verificationCode);
        return this.http.post(`${this.configuration.apiUrls.workflow}/api/v1/user/access-request`, body, { params });
    }
    impersonate(email) {
        return from(this.keycloakService.getToken())
            .pipe(map$1((token) => ({
            body: new HttpParams()
                .set('client_id', this.configuration.keycloakClientId)
                .set('grant_type', 'urn:ietf:params:oauth:grant-type:token-exchange')
                .set('subject_token', token)
                // urn:ietf:params:oauth:token-type:access_token does not include refresh_token
                .set('requested_token_type', 'urn:ietf:params:oauth:token-type:refresh_token')
                .set('audience', this.configuration.keycloakClientId)
                .set('requested_subject', email),
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
        })), switchMap(({ body, headers }) => this.http.post(`${this.configuration.keycloakUrl}/realms/${this.configuration.keycloakRealm}/protocol/openid-connect/token`, body.toString(), { headers })));
    }
    parseRole(user) {
        // extract role from access token
        const accessToken = this.keycloakService.getKeycloakInstance().tokenParsed;
        if (!accessToken) {
            throw new Error('Cannot parse role from access token. Access token is missing.');
        }
        // Try to get roles from resource_access, if not found set to default role
        const roles = accessToken.resource_access?.[this.configuration.keycloakClientId]?.roles;
        const role = roles?.find((r) => Object.keys(UserRole).includes(r.toUpperCase())) ?? LOWEST_USER_ROLE;
        // copy user object and set role
        const userCopy = { ...user };
        userCopy.role = UserRole[role.toUpperCase()];
        return userCopy;
    }
    parseFeatureFlags(user) {
        const accessToken = this.keycloakService.getKeycloakInstance().tokenParsed;
        if (!accessToken) {
            throw new Error('Cannot parse feature flags from access token. Access token is missing.');
        }
        const featureFlags = accessToken.resource_access?.[this.configuration.keycloakClientId]?.roles;
        const userCopy = { ...user };
        if (!featureFlags) {
            userCopy.featureFlags = [];
            return userCopy;
        }
        userCopy.featureFlags = featureFlags.filter((r) => Object.keys(FeatureFlag).includes(r.toUpperCase()))
            .map((flag) => FeatureFlag[flag.toUpperCase()]);
        return userCopy;
    }
    getOrganizationId(user) {
        // user.groups = [/[a-zA-Z0-9-], /ROLE_..]
        const regex = /^[a-zA-Z0-9-]+$/g;
        return user.group
            .filter((group) => group.split('/').length === 2)
            .map((group) => group.slice(1)).find((group) => regex.test(group));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthService, deps: [{ token: i1.HttpClient }, { token: i2$1.KeycloakService }, { token: OrganizationService }, { token: NimmstaCommonsModuleConfiguration }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i2$1.KeycloakService }, { type: OrganizationService }, { type: NimmstaCommonsModuleConfiguration }] });

class KeycloakSessionService {
    constructor(http, configuration) {
        this.http = http;
        this.sessionEndpoint = `${configuration.keycloakUrl}/realms/${configuration.keycloakRealm}/account/sessions`;
    }
    getActiveDevices() {
        return this.http.get(`${this.sessionEndpoint}/devices`);
    }
    terminate(sessionId) {
        return this.http.delete(`${this.sessionEndpoint}/${sessionId}`);
    }
    terminateAll() {
        return this.http.delete(`${this.sessionEndpoint}`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: KeycloakSessionService, deps: [{ token: i1.HttpClient }, { token: NimmstaCommonsModuleConfiguration }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: KeycloakSessionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: KeycloakSessionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: NimmstaCommonsModuleConfiguration }] });

class LanguageService {
    constructor(configuration, translate, timeIntl, authService, http) {
        this.configuration = configuration;
        this.translate = translate;
        this.timeIntl = timeIntl;
        this.authService = authService;
        this.http = http;
        this.LANGUAGE_KEY = 'language';
        this.languageChange = new Subject();
        this.user = null;
        this.allowedLanguages = ['en', 'de'];
        this.translate.setDefaultLang('en');
        this.authService.getCurrentUser().subscribe((user) => {
            this.user = user;
        });
    }
    changeLanguage(language, savePreferred = false) {
        if (!this.allowedLanguages.includes(language)) {
            throw new Error(`Language ${language} is not allowed`);
        }
        if (savePreferred && this.user) {
            // Manipulate the User Language by using the Keycloak Account API
            // (User self-service, unducumented, built-in Keycloak feature)
            // See https://auth.dev.nimmsta-test.de/realms/productivity-cloud/account/
            // eslint-disable-next-line max-len
            // https://github.com/keycloak/keycloak/blob/main/services/src/main/java/org/keycloak/services/resources/account/AccountRestService.java#L153
            // Authentification is done by the Authorization header with the access token
            // of the current user, will only modify the current user
            this.http.post(`${this.configuration.keycloakUrl}/realms/${this.configuration.keycloakRealm}/account`, {
                attributes: {
                    locale: [language],
                },
                firstName: this.user.given_name, // Required, validation error if not set
                lastName: this.user.family_name, // Required, validation error if not set
            }).subscribe({
                next: this.applyLanguage.bind(this, language),
                error: () => {
                    this.applyLanguage(language);
                },
            });
        }
        else {
            this.applyLanguage(language);
        }
    }
    applyLanguage(language) {
        this.translate.use(language);
        dayjs.locale(language);
        switch (language) {
            case 'de':
                this.timeIntl.strings = strings$1;
                break;
            default:
                this.timeIntl.strings = strings;
                break;
        }
        this.timeIntl.changes.next();
        this.languageChange.next(language);
    }
    getPreferredLanguage() {
        return this.user?.locale || this.translate.getBrowserLang() || 'en';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LanguageService, deps: [{ token: NimmstaCommonsModuleConfiguration }, { token: i2.TranslateService }, { token: i3$1.TimeagoIntl }, { token: AuthService }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LanguageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LanguageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: NimmstaCommonsModuleConfiguration }, { type: i2.TranslateService }, { type: i3$1.TimeagoIntl }, { type: AuthService }, { type: i1.HttpClient }] });

class LanguageSwitcherComponent {
    constructor(languageService) {
        this.languageService = languageService;
        this.languages = [
            { name: 'Deutsch', code: 'de' },
            { name: 'English', code: 'en' },
        ];
        this.selected = { name: 'English', code: 'en' };
    }
    ngOnInit() {
        this.selected = this.languages.find((lang) => lang.code === this.languageService.getPreferredLanguage());
    }
    changeLanguage(code) {
        this.languageService.changeLanguage(code, true);
        this.selected = this.languages.find((lang) => lang.code === code);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LanguageSwitcherComponent, deps: [{ token: LanguageService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: LanguageSwitcherComponent, selector: "app-language-switcher", viewQueries: [{ propertyName: "languageCollapse", first: true, predicate: ["languageCollapse"], descendants: true }], ngImport: i0, template: "<!-- <div class=\"dropstart\">\n  <a role=\"button\" class=\"dropdown-toggle\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n    <span translate class=\"fw-normal me-2\">profile.language</span>\n    <span class=\"fi\" [ngClass]=\"'fi-' + selected.code\"></span>\n  </a>\n  <ul class=\"dropdown-menu\" style=\"border-bottom-right-radius: 0; border-top-right-radius: 0; right: 64px;\">\n    @for (lang of languages; track $index) {\n      <li>\n        <a class=\"dropdown-item\" href=\"#\" (click)=\"changeLanguage(lang.code)\">\n          <span class=\"fi me-2\" [ngClass]=\"'fi-' + lang.code\"></span>\n          <span>{{lang.name}}</span>\n        </a>\n      </li>\n    }\n  </ul>\n</div> -->\n\n<a #languageCollapse class=\"dropdown-item\" role=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#lang\"\n  aria-expanded=\"false\">\n  <span translate class=\"fw-normal me-2\">language</span>\n  <!-- <span class=\"fi float-end\" style=\"margin-top: 4px;\" [ngClass]=\"'fi-' + selected.code\"></span> -->\n</a>\n<div id=\"lang\" class=\"collapse\">\n  <div class=\"lang-body\">\n    @for (lang of languages; track $index) {\n    <span data-bs-toggle=\"collapse\" data-bs-target=\"#lang\">\n      <a class=\"dropdown-item ps-4\" (click)=\"changeLanguage(lang.code)\">\n        <!-- <span class=\"fi me-2\" [ngClass]=\"'fi-' + lang.code\"></span> -->\n        <span>{{lang.name}}</span>\n      </a>\n    </span>\n    }\n  </div>\n</div>\n", styles: [".dropdown-toggle:before{display:none}.dropdown-item:active{color:var(--bs-dropdown-link-active-color)!important}.lang-body{border-top:1px solid var(--bs-border-color-translucent);border-bottom:1px solid var(--bs-border-color-translucent)}\n"], dependencies: [{ kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LanguageSwitcherComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-language-switcher', template: "<!-- <div class=\"dropstart\">\n  <a role=\"button\" class=\"dropdown-toggle\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n    <span translate class=\"fw-normal me-2\">profile.language</span>\n    <span class=\"fi\" [ngClass]=\"'fi-' + selected.code\"></span>\n  </a>\n  <ul class=\"dropdown-menu\" style=\"border-bottom-right-radius: 0; border-top-right-radius: 0; right: 64px;\">\n    @for (lang of languages; track $index) {\n      <li>\n        <a class=\"dropdown-item\" href=\"#\" (click)=\"changeLanguage(lang.code)\">\n          <span class=\"fi me-2\" [ngClass]=\"'fi-' + lang.code\"></span>\n          <span>{{lang.name}}</span>\n        </a>\n      </li>\n    }\n  </ul>\n</div> -->\n\n<a #languageCollapse class=\"dropdown-item\" role=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#lang\"\n  aria-expanded=\"false\">\n  <span translate class=\"fw-normal me-2\">language</span>\n  <!-- <span class=\"fi float-end\" style=\"margin-top: 4px;\" [ngClass]=\"'fi-' + selected.code\"></span> -->\n</a>\n<div id=\"lang\" class=\"collapse\">\n  <div class=\"lang-body\">\n    @for (lang of languages; track $index) {\n    <span data-bs-toggle=\"collapse\" data-bs-target=\"#lang\">\n      <a class=\"dropdown-item ps-4\" (click)=\"changeLanguage(lang.code)\">\n        <!-- <span class=\"fi me-2\" [ngClass]=\"'fi-' + lang.code\"></span> -->\n        <span>{{lang.name}}</span>\n      </a>\n    </span>\n    }\n  </div>\n</div>\n", styles: [".dropdown-toggle:before{display:none}.dropdown-item:active{color:var(--bs-dropdown-link-active-color)!important}.lang-body{border-top:1px solid var(--bs-border-color-translucent);border-bottom:1px solid var(--bs-border-color-translucent)}\n"] }]
        }], ctorParameters: () => [{ type: LanguageService }], propDecorators: { languageCollapse: [{
                type: ViewChild,
                args: ['languageCollapse']
            }] } });

class MaintenanceInfoService {
    constructor(http, configuration) {
        this.http = http;
        this.configuration = configuration;
    }
    getMaintenanceInfo() {
        if (this.infoCache) {
            return of(this.infoCache);
        }
        if (!this.configuration.maintenanceInfoSource) {
            return of();
        }
        return this.http.get(this.configuration.maintenanceInfoSource).pipe(map$1((data) => {
            if (this.isValidMaintenanceFile(data)) {
                this.infoCache = data;
                return data;
            }
            return [];
        }));
    }
    isValidMaintenanceFile(maintenanceInfo) {
        if (!maintenanceInfo) {
            // eslint-disable-next-line no-console
            console.error('Maintenance info is null or undefined');
            return false;
        }
        if (maintenanceInfo.length === 0) {
            return true;
        }
        const errors = {};
        maintenanceInfo.forEach((elem, index) => {
            const errorBuffer = [];
            if (!elem) {
                errorBuffer.push('Maintenance info element is null or undefined');
            }
            if (!elem.from || !elem.to) {
                errorBuffer.push('from or to is null or undefined');
            }
            if (elem.from && elem.to && elem.from >= elem.to) {
                errorBuffer.push('from is greater than or equal to to');
            }
            if (elem.title && (!elem.title.de || !elem.title.en)) {
                errorBuffer.push('title translations are missing');
            }
            if (!elem.text || !elem.text.de || !elem.text.en) {
                errorBuffer.push('text is null or undefined or the translations are missing');
            }
            if (!elem.type) {
                errorBuffer.push('type is null or undefined');
            }
            if (errorBuffer.length) {
                errors[index] = errorBuffer;
            }
        });
        if (Object.keys(errors).length) {
            // eslint-disable-next-line no-console
            console.error('Maintenance info is invalid', errors);
        }
        return Object.keys(errors).length === 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: MaintenanceInfoService, deps: [{ token: i1.HttpClient }, { token: NimmstaCommonsModuleConfiguration }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: MaintenanceInfoService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: MaintenanceInfoService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: NimmstaCommonsModuleConfiguration }] });

class DateEvalPipe {
    constructor(cd) {
        this.cd = cd;
        this.showElement = false;
    }
    transform(value) {
        if (!value || !value.from || !value.to) {
            this.clear();
            return false;
        }
        this.value = { from: dayjs(value.from), to: dayjs(value.to) };
        const now = dayjs();
        // If `to` has already passed, it will never be true in the future
        if (!this.value || !this.value.from || !this.value.to || this.value.to.isBefore(now)) {
            this.clear();
            return false;
        }
        this.runInnerCheck();
        return this.showElement;
    }
    clear() {
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
        if (this.intervalRef) {
            clearInterval(this.intervalRef);
        }
    }
    runInnerCheck() {
        if (!this.value) {
            return;
        }
        const visible = this.isVisible();
        if (visible !== this.showElement) {
            this.showElement = visible;
            this.cd.detectChanges();
            return;
        }
        const now = dayjs();
        const fromDiff = this.value.from.diff(now, 'millisecond');
        const toDiff = this.value.to.diff(now, 'millisecond');
        const fromPassed = (fromDiff === 0 || now.isAfter(this.value.from));
        this.showElement = this.isVisible();
        // If `from` has already passed, we need to check if `to` is in the far future, or we need to wait for the status switch
        if (fromPassed && toDiff >= 5000) {
            this.scheduleTimeout(toDiff - 5000);
        }
        else if (fromPassed) {
            this.scheduleInterval();
        }
        // If `from` is in the future, we need to check if it's in the far future, or we need to wait for the status switch
        if (now.isBefore(this.value.from) && fromDiff >= 5000) {
            this.scheduleTimeout(fromDiff - 5000);
        }
        else if (now.isBefore(this.value.from)) {
            this.scheduleInterval();
        }
    }
    ngOnDestroy() {
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
        if (this.intervalRef) {
            clearInterval(this.intervalRef);
        }
    }
    isVisible() {
        if (!this.value || !this.value.from || !this.value.to) {
            return false;
        }
        const now = dayjs();
        return (now.isSame(this.value.from) || now.isSame(this.value.to))
            || (now.isAfter(this.value.from) && now.isBefore(this.value.to));
    }
    scheduleInterval() {
        if (!this.intervalRef) {
            this.intervalRef = setInterval(() => {
                const visible = this.isVisible();
                if (visible !== this.showElement) {
                    this.showElement = visible;
                    clearInterval(this.intervalRef);
                    this.runInnerCheck();
                }
            }, 500);
        }
    }
    scheduleTimeout(ms) {
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
        this.timeoutRef = setTimeout(() => {
            this.runInnerCheck();
        }, ms);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DateEvalPipe, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: DateEvalPipe, name: "dateEval", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DateEvalPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateEval',
                    pure: false,
                }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }] });

class MaintenanceInfoComponent {
    constructor(infoService, translationService) {
        this.infoService = infoService;
        this.translationService = translationService;
        this.info = [];
        this.language = 'en';
        this.typeToIconMap = {
            info: 'info',
            warning: 'warning',
            danger: 'report',
            success: 'check_circle',
        };
        this.dayjs = dayjs;
    }
    ngOnInit() {
        this.infoService.getMaintenanceInfo().subscribe((info) => {
            this.info = info;
        });
        this.language = this.translationService.currentLang;
        this.translationService.onLangChange.subscribe((event) => {
            this.language = event.lang;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: MaintenanceInfoComponent, deps: [{ token: MaintenanceInfoService }, { token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: MaintenanceInfoComponent, selector: "app-maintenance-info", ngImport: i0, template: "@for (element of info; track element) {\n  @if (element | dateEval) {\n  <alert [type]=\"element.type\">\n    <div class=\"d-flex flex-row justify-content-start gap-2\">\n      <span class=\"material-symbols-outlined\" [ngClass]=\"{h4: element.title}\">{{typeToIconMap[element.type]}}</span>\n      <div>\n      @if (element.title) {\n        @if(language === 'de') {\n          <h4>{{ element.title.de }}</h4>\n        } @else {\n          <h4>{{ element.title.en }}</h4>\n        }\n      }\n      @if(language === 'de') {\n        <p [innerHTML]=\"element.text.de\"></p>\n      } @else {\n        <p [innerHTML]=\"element.text.en\"></p>\n      }\n      </div>\n    </div>\n  </alert>\n  }\n}\n", dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i4.AlertComponent, selector: "alert,bs-alert", inputs: ["type", "dismissible", "dismissOnTimeout", "isOpen"], outputs: ["onClose", "onClosed"] }, { kind: "pipe", type: DateEvalPipe, name: "dateEval" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: MaintenanceInfoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-maintenance-info', template: "@for (element of info; track element) {\n  @if (element | dateEval) {\n  <alert [type]=\"element.type\">\n    <div class=\"d-flex flex-row justify-content-start gap-2\">\n      <span class=\"material-symbols-outlined\" [ngClass]=\"{h4: element.title}\">{{typeToIconMap[element.type]}}</span>\n      <div>\n      @if (element.title) {\n        @if(language === 'de') {\n          <h4>{{ element.title.de }}</h4>\n        } @else {\n          <h4>{{ element.title.en }}</h4>\n        }\n      }\n      @if(language === 'de') {\n        <p [innerHTML]=\"element.text.de\"></p>\n      } @else {\n        <p [innerHTML]=\"element.text.en\"></p>\n      }\n      </div>\n    </div>\n  </alert>\n  }\n}\n" }]
        }], ctorParameters: () => [{ type: MaintenanceInfoService }, { type: i2.TranslateService }] });

class OrdinalDatePipe {
    constructor(translate) {
        this.translate = translate;
        this.daysDe = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
        this.monthsDe = [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'July',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
        ];
        this.daysEn = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        this.monthsEn = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
    }
    transform(value) {
        if (!value) {
            return '';
        }
        if (this.translate.currentLang === 'de') {
            return `${this.daysDe[value.day()]}, ${value.date()}. ${this.monthsDe[value.month()]} ${value.format('HH:mm:ss')}`;
        }
        else {
            return `${this.daysEn[value.day()]}, ${value.date()}${this.nth(value.date())} ${this.monthsEn[value.month()]} ${value.format('HH:mm:ss')}`;
        }
    }
    nth(d) {
        if (d > 3 && d < 21)
            return 'th';
        switch (d % 10) {
            case 1:
                return 'st';
            case 2:
                return 'nd';
            case 3:
                return 'rd';
            default:
                return 'th';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrdinalDatePipe, deps: [{ token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: OrdinalDatePipe, name: "ordinalDate" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrdinalDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'ordinalDate',
                }]
        }], ctorParameters: () => [{ type: i2.TranslateService }] });

class HeaderBarComponent {
    constructor(authService, keycloakService, sessionService, location, navService) {
        this.authService = authService;
        this.keycloakService = keycloakService;
        this.sessionService = sessionService;
        this.location = location;
        this.title = '';
        this.showDefaultBackButton = false;
        this.date = undefined;
        this.user = signal(undefined);
        this.sessionId = signal(undefined);
        this.profileImg = null;
        this.impersonationSessionEnded = sessionStorage.getItem(IMPERSONATION_SESSION_ENDED) === 'true';
        this.profileName = computed(() => {
            const user = this.user();
            if (user && user.given_name && user.family_name) {
                return `${user.given_name} ${user.family_name}`;
            }
            else if (user && user.given_name) {
                return `${user.given_name}`;
            }
            else if (user && user.family_name) {
                return `${user.family_name}`;
            }
            else if (user) {
                return user.email;
            }
            return 'profile';
        });
        this.organizationName = computed(() => {
            const user = this.user();
            if (user && user.organization?.name) {
                return user.organization.name;
            }
            return '';
        });
        this.DateTimeFormat = DateTimeFormat;
        this.isImpersonating = sessionStorage.getItem(IMPERSONATION_SESSION_STORAGE_KEY) !== null;
        this.navItems = toSignal(navService.getHeaderBarNavItems(), { initialValue: [], rejectErrors: true });
    }
    ngOnInit() {
        this.authService.getCurrentUser().subscribe((user) => {
            this.user.set(user);
            this.profileImg = `https://www.gravatar.com/avatar/${Md5.hashStr(user?.email ?? '')}`;
            // Get the session ID (SID) from the token
            this.keycloakService.getToken()
                .then((token) => {
                if (!token) {
                    return;
                }
                const sessionId = JSON.parse(atob(token.split('.')[1])).sid;
                this.sessionId.set(sessionId);
            });
        });
    }
    ngAfterViewInit() {
        const feedback = getFeedback();
        if (feedback) {
            feedback.attachTo(this.sentryReportButton.nativeElement);
        }
    }
    navigateBack() {
        this.location.back();
    }
    async logout() {
        await this.authService.logout();
    }
    async endImpersonation() {
        const exit = () => {
            // Close the current tab
            sessionStorage.removeItem(IMPERSONATION_SESSION_STORAGE_KEY);
            window.close();
            // Reload the current page if closing the tab fails (Scripts may close only the windows that were opened by them.)
            window.location.reload();
        };
        const sessionId = this.sessionId();
        if (sessionId) {
            firstValueFrom(this.sessionService.terminate(sessionId))
                .finally(exit);
        }
        else {
            exit();
        }
    }
    dismissImpersonationEndedWarning() {
        sessionStorage.removeItem(IMPERSONATION_SESSION_ENDED);
        this.impersonationSessionEnded = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: HeaderBarComponent, deps: [{ token: AuthService }, { token: i2$1.KeycloakService }, { token: KeycloakSessionService }, { token: i5.Location }, { token: NAV_ITEM_SERVICE }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: HeaderBarComponent, selector: "app-header-bar", inputs: { title: "title", backRoute: "backRoute", showDefaultBackButton: "showDefaultBackButton", date: "date" }, viewQueries: [{ propertyName: "sentryReportButton", first: true, predicate: ["sentryButton"], descendants: true }], ngImport: i0, template: "<div class=\"header-bar mt-5 d-lg-flex flex-row-reverse justify-content-between w-100\">\n  <div class=\"justify-content-between d-flex pb-3 pb-lg-0 gap-2 align-items-center\">\n    <span class=\"align-middle pe-4 py-2\">{{organizationName()}}</span>\n\n    <div class=\"dropdown\">\n      <a class=\"btn btn-nav d-flex align-items-center\" #sentryButton>\n        <span class=\"material-symbols-outlined text-primary\" style=\"font-size: 22px;\">\n          campaign\n        </span>\n        <span translate class=\"d-none d-sm-inline\">report_issue</span>\n      </a>\n    </div>\n\n    @if (navItems().length > 0) {\n      <div class=\"dropdown\">\n        <a data-bs-toggle=\"dropdown\" data-bs-auto-close=\"outside\" aria-expanded=\"false\" class=\"btn btn-nav\">\n          <span class=\"material-symbols-outlined text-primary\" style=\"font-size: 22px;\">\n            tune\n          </span>\n        </a>\n        <ul class=\"dropdown-menu dropdown-menu-end\">\n          @for (item of navItems(); track item) {\n            @if (item.items) {\n              @if (item.isVisible(user())) {\n                <li>\n                  <a class=\"dropdown-item d-flex align-items-center justify-content-between\" role=\"button\" data-bs-toggle=\"collapse\"\n                    [attr.data-bs-target]=\"'#' + item.title\" [attr.aria-expanded]=\"item.expanded\"\n                    (click)=\"item.expanded = !item.expanded\"\n                  >\n                    <span class=\"material-symbols-outlined text-primary me-1\">\n                      {{ item.icon}}\n                    </span>\n                    <span translate class=\"fw-normal me-2\">{{ item.title }}</span>\n                    <span class=\"material-symbols-outlined transition float-end\" [ngClass]=\"{'rotate-90': item.expanded}\">\n                      chevron_right\n                    </span>\n                  </a>\n                  <div id=\"{{item.title}}\" class=\"collapse\" [ngClass]=\"{'show': item.expanded}\">\n                      @for (nestedItem of item.items; track nestedItem) {\n                        @if (nestedItem.isVisible(user())) {\n                          <a class=\"dropdown-item ps-4\" [routerLink]=\"['/' + nestedItem.url]\" routerLinkActive=\"current-page\"\n                            translate>\n                            <span class=\"material-symbols-outlined text-primary me-1\">\n                              {{ nestedItem.icon}}\n                            </span>\n                            {{ nestedItem.title}}\n                          </a>\n                        }\n                      }\n                  </div>\n                </li>\n              }\n            }\n            @else {\n              @if (item.isVisible(user())) {\n                <li>\n                  <a class=\"dropdown-item\" [routerLink]=\"['/' + item.url]\" routerLinkActive=\"current-page\" translate>\n                    <span class=\"material-symbols-outlined text-primary me-1\">\n                      {{ item.icon }}\n                    </span>\n                    {{ item.title }}\n                  </a>\n                </li>\n              }\n            }\n          }\n        </ul>\n      </div>\n    }\n\n    <div class=\"dropdown\">\n      <a data-bs-toggle=\"dropdown\" data-bs-auto-close=\"outside\" aria-expanded=\"false\" class=\"btn btn-nav d-flex align-items-center gap-1\">\n        <img [src]=\"profileImg\" class=\"profile-img\" />\n        <div style=\"margin-left: 0.9rem;\">\n          <span translate [ngClass]=\"{'me-2': isImpersonating}\" class=\"d-none d-sm-inline\">{{profileName()}}</span>\n          <span *ngIf=\"isImpersonating\" class=\"material-symbols-outlined\" style=\"font-size: 22px;\">\n            swap_horiz\n          </span>\n        </div>\n      </a>\n      <ul class=\"dropdown-menu dropdown-menu-end\">\n        <li><a class=\"dropdown-item\" [routerLink]=\"['/profile']\" [routerLinkActiveOptions]=\"{exact: true}\"\n            routerLinkActive=\"current-page\" translate>profile</a></li>\n        <li>\n          <app-language-switcher></app-language-switcher>\n        </li>\n        <li *ngIf=\"user()?.organization\">\n          <a class=\"dropdown-item\" [routerLink]=\"['/organizations/'+user()!.organization!.id+'/settings']\" [routerLinkActiveOptions]=\"{exact: true}\"\n              routerLinkActive=\"current-page\" translate>organizations.settings</a>\n        </li>\n        <li><a class=\"dropdown-item\" [routerLink]=\"['/profile/sessions']\" [routerLinkActiveOptions]=\"{exact: true}\"\n            routerLinkActive=\"current-page\" translate>sessions</a></li>\n        <li *ngIf=\"!isImpersonating\"><a class=\"dropdown-item\" (click)=\"logout()\" translate>logout</a></li>\n        <li *ngIf=\"isImpersonating\"><a class=\"dropdown-item\" (click)=\"endImpersonation()\"\n            translate>end_impersonation</a></li>\n      </ul>\n    </div>\n  </div>\n\n  @if (impersonationSessionEnded) {\n  <div class=\"alert alert-warning d-flex align-items-center justify-content-between p-3 position-relative\"\n    role=\"alert\">\n    <div class=\"d-flex align-items-center gap-2\">\n      <span class=\"material-symbols-outlined\">warning</span>\n      <span translate>Your impersonation session has ended.</span>\n    </div>\n    <button type=\"button\" class=\"btn-close btn-sm\" aria-label=\"Close\"\n      (click)=\"dismissImpersonationEndedWarning()\"></button>\n  </div>\n  }\n\n  <h1 class=\"d-flex flex-row align-items-baseline gap-2\">\n    @if (backRoute) {\n    <a [routerLink]=\"[backRoute]\"><span class=\"material-symbols-outlined fs-1\">arrow_back</span></a>\n    } @else if (showDefaultBackButton) {\n    <a (click)=\"navigateBack()\"><span class=\"material-symbols-outlined fs-1\">arrow_back</span></a>\n    }\n    <span>{{title | translate}}</span>\n  </h1>\n</div>\n@if (date !== undefined) {\n<div class=\"date mt-2 mb-2\">{{date | ordinalDate }}</div>\n}\n\n<app-maintenance-info></app-maintenance-info>\n", styles: [".profile-img{height:2.25rem;width:auto;margin:-.75rem -.9rem -.6rem;padding:2px;border-radius:50%}.current-page{font-weight:700}@media (max-width: 576px){h1{justify-content:center}}.transition{transition:transform .2s ease-in-out}.rotate-90{transform:rotate(90deg);transition:transform .2s ease-in-out}.rotate-180{transform:rotate(180deg);transition:transform .2s ease-in-out}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "directive", type: i1$1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i1$1.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "ariaCurrentWhenActive", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }, { kind: "component", type: LanguageSwitcherComponent, selector: "app-language-switcher" }, { kind: "component", type: MaintenanceInfoComponent, selector: "app-maintenance-info" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }, { kind: "pipe", type: OrdinalDatePipe, name: "ordinalDate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: HeaderBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-header-bar', template: "<div class=\"header-bar mt-5 d-lg-flex flex-row-reverse justify-content-between w-100\">\n  <div class=\"justify-content-between d-flex pb-3 pb-lg-0 gap-2 align-items-center\">\n    <span class=\"align-middle pe-4 py-2\">{{organizationName()}}</span>\n\n    <div class=\"dropdown\">\n      <a class=\"btn btn-nav d-flex align-items-center\" #sentryButton>\n        <span class=\"material-symbols-outlined text-primary\" style=\"font-size: 22px;\">\n          campaign\n        </span>\n        <span translate class=\"d-none d-sm-inline\">report_issue</span>\n      </a>\n    </div>\n\n    @if (navItems().length > 0) {\n      <div class=\"dropdown\">\n        <a data-bs-toggle=\"dropdown\" data-bs-auto-close=\"outside\" aria-expanded=\"false\" class=\"btn btn-nav\">\n          <span class=\"material-symbols-outlined text-primary\" style=\"font-size: 22px;\">\n            tune\n          </span>\n        </a>\n        <ul class=\"dropdown-menu dropdown-menu-end\">\n          @for (item of navItems(); track item) {\n            @if (item.items) {\n              @if (item.isVisible(user())) {\n                <li>\n                  <a class=\"dropdown-item d-flex align-items-center justify-content-between\" role=\"button\" data-bs-toggle=\"collapse\"\n                    [attr.data-bs-target]=\"'#' + item.title\" [attr.aria-expanded]=\"item.expanded\"\n                    (click)=\"item.expanded = !item.expanded\"\n                  >\n                    <span class=\"material-symbols-outlined text-primary me-1\">\n                      {{ item.icon}}\n                    </span>\n                    <span translate class=\"fw-normal me-2\">{{ item.title }}</span>\n                    <span class=\"material-symbols-outlined transition float-end\" [ngClass]=\"{'rotate-90': item.expanded}\">\n                      chevron_right\n                    </span>\n                  </a>\n                  <div id=\"{{item.title}}\" class=\"collapse\" [ngClass]=\"{'show': item.expanded}\">\n                      @for (nestedItem of item.items; track nestedItem) {\n                        @if (nestedItem.isVisible(user())) {\n                          <a class=\"dropdown-item ps-4\" [routerLink]=\"['/' + nestedItem.url]\" routerLinkActive=\"current-page\"\n                            translate>\n                            <span class=\"material-symbols-outlined text-primary me-1\">\n                              {{ nestedItem.icon}}\n                            </span>\n                            {{ nestedItem.title}}\n                          </a>\n                        }\n                      }\n                  </div>\n                </li>\n              }\n            }\n            @else {\n              @if (item.isVisible(user())) {\n                <li>\n                  <a class=\"dropdown-item\" [routerLink]=\"['/' + item.url]\" routerLinkActive=\"current-page\" translate>\n                    <span class=\"material-symbols-outlined text-primary me-1\">\n                      {{ item.icon }}\n                    </span>\n                    {{ item.title }}\n                  </a>\n                </li>\n              }\n            }\n          }\n        </ul>\n      </div>\n    }\n\n    <div class=\"dropdown\">\n      <a data-bs-toggle=\"dropdown\" data-bs-auto-close=\"outside\" aria-expanded=\"false\" class=\"btn btn-nav d-flex align-items-center gap-1\">\n        <img [src]=\"profileImg\" class=\"profile-img\" />\n        <div style=\"margin-left: 0.9rem;\">\n          <span translate [ngClass]=\"{'me-2': isImpersonating}\" class=\"d-none d-sm-inline\">{{profileName()}}</span>\n          <span *ngIf=\"isImpersonating\" class=\"material-symbols-outlined\" style=\"font-size: 22px;\">\n            swap_horiz\n          </span>\n        </div>\n      </a>\n      <ul class=\"dropdown-menu dropdown-menu-end\">\n        <li><a class=\"dropdown-item\" [routerLink]=\"['/profile']\" [routerLinkActiveOptions]=\"{exact: true}\"\n            routerLinkActive=\"current-page\" translate>profile</a></li>\n        <li>\n          <app-language-switcher></app-language-switcher>\n        </li>\n        <li *ngIf=\"user()?.organization\">\n          <a class=\"dropdown-item\" [routerLink]=\"['/organizations/'+user()!.organization!.id+'/settings']\" [routerLinkActiveOptions]=\"{exact: true}\"\n              routerLinkActive=\"current-page\" translate>organizations.settings</a>\n        </li>\n        <li><a class=\"dropdown-item\" [routerLink]=\"['/profile/sessions']\" [routerLinkActiveOptions]=\"{exact: true}\"\n            routerLinkActive=\"current-page\" translate>sessions</a></li>\n        <li *ngIf=\"!isImpersonating\"><a class=\"dropdown-item\" (click)=\"logout()\" translate>logout</a></li>\n        <li *ngIf=\"isImpersonating\"><a class=\"dropdown-item\" (click)=\"endImpersonation()\"\n            translate>end_impersonation</a></li>\n      </ul>\n    </div>\n  </div>\n\n  @if (impersonationSessionEnded) {\n  <div class=\"alert alert-warning d-flex align-items-center justify-content-between p-3 position-relative\"\n    role=\"alert\">\n    <div class=\"d-flex align-items-center gap-2\">\n      <span class=\"material-symbols-outlined\">warning</span>\n      <span translate>Your impersonation session has ended.</span>\n    </div>\n    <button type=\"button\" class=\"btn-close btn-sm\" aria-label=\"Close\"\n      (click)=\"dismissImpersonationEndedWarning()\"></button>\n  </div>\n  }\n\n  <h1 class=\"d-flex flex-row align-items-baseline gap-2\">\n    @if (backRoute) {\n    <a [routerLink]=\"[backRoute]\"><span class=\"material-symbols-outlined fs-1\">arrow_back</span></a>\n    } @else if (showDefaultBackButton) {\n    <a (click)=\"navigateBack()\"><span class=\"material-symbols-outlined fs-1\">arrow_back</span></a>\n    }\n    <span>{{title | translate}}</span>\n  </h1>\n</div>\n@if (date !== undefined) {\n<div class=\"date mt-2 mb-2\">{{date | ordinalDate }}</div>\n}\n\n<app-maintenance-info></app-maintenance-info>\n", styles: [".profile-img{height:2.25rem;width:auto;margin:-.75rem -.9rem -.6rem;padding:2px;border-radius:50%}.current-page{font-weight:700}@media (max-width: 576px){h1{justify-content:center}}.transition{transition:transform .2s ease-in-out}.rotate-90{transform:rotate(90deg);transition:transform .2s ease-in-out}.rotate-180{transform:rotate(180deg);transition:transform .2s ease-in-out}\n"] }]
        }], ctorParameters: () => [{ type: AuthService }, { type: i2$1.KeycloakService }, { type: KeycloakSessionService }, { type: i5.Location }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NAV_ITEM_SERVICE]
                }] }], propDecorators: { title: [{
                type: Input
            }], backRoute: [{
                type: Input
            }], showDefaultBackButton: [{
                type: Input
            }], date: [{
                type: Input
            }], sentryReportButton: [{
                type: ViewChild,
                args: ['sentryButton']
            }] } });

class LoadingIndicatorComponent {
    constructor() {
        this.loading = input(false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LoadingIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: LoadingIndicatorComponent, selector: "app-loading-indicator", inputs: { loading: { classPropertyName: "loading", publicName: "loading", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0, template: "@if (loading()) {\n  <div class=\"position-relative w-100\" style=\"height: 48px;\">\n    <div style=\"position: absolute; left: calc(50% - 25px); top: 0.5rem;\">\n      <mat-spinner [diameter]=\"25\"></mat-spinner>\n    </div>\n  </div>\n}\n", dependencies: [{ kind: "component", type: i1$2.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LoadingIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-loading-indicator', template: "@if (loading()) {\n  <div class=\"position-relative w-100\" style=\"height: 48px;\">\n    <div style=\"position: absolute; left: calc(50% - 25px); top: 0.5rem;\">\n      <mat-spinner [diameter]=\"25\"></mat-spinner>\n    </div>\n  </div>\n}\n" }]
        }] });

class DefaultMenuComponent {
    constructor(authService, router, navService) {
        this.authService = authService;
        this.router = router;
        this.mobileExpanded = false;
        this.collapsed = false;
        this.navItems = signal([]);
        firstValueFrom(navService.getSidebarNavItems()).then((items) => {
            this.navItems.set(items);
            this.checkActiveItem();
        });
    }
    ngOnInit() {
        this.authService.getCurrentUser().subscribe((user) => {
            if (user) {
                this.user = user;
            }
        });
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.checkActiveItem();
            }
        });
    }
    ngOnChanges() {
        this.checkActiveItem();
    }
    checkActiveItem() {
        // Get first part of the url and set active item
        const url = this.router.url.split('?')[0].substring(1).split('/')[0];
        if (url) {
            const path = url;
            this.navItems().forEach((item) => {
                item.setActive(path);
            });
        }
    }
    navigate(url) {
        if (this.router.url.split('?')[0].substring(1) !== url) {
            this.router.navigate([url]);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DefaultMenuComponent, deps: [{ token: AuthService }, { token: i1$1.Router }, { token: NAV_ITEM_SERVICE }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: DefaultMenuComponent, selector: "app-default-menu", inputs: { mobileExpanded: "mobileExpanded", collapsed: "collapsed" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"nav-items\" [ngClass]=\"{expanded: mobileExpanded, collapsed: collapsed}\">\n  @for (item of navItems(); track item) {\n    @if (item.items) {\n      @if (item.isVisible(user)) {\n        <div class=\"accordion\">\n          <a class=\"accordion-button collapsed menu-item\" id=\"{{item.title}}\"\n             data-bs-toggle=\"collapse\" [attr.data-bs-target]=\"'#' + item.icon\" aria-expanded=\"true\" [attr.aria-controls]=\"item.icon\">\n            <span class=\"indicator\"></span>\n            <span class=\"material-symbols-outlined nav-icon\"\n                  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"{{item.title | translate}}\">{{item.icon}}</span>\n            <span class=\"text\" translate>{{item.title}}</span>\n          </a>\n          <div id=\"{{item.icon}}\" class=\"accordion-collapse collapse\" data-bs-parent=\"#accordionExample\">\n            <div class=\"accordion-body\">\n              <ul>\n                @for (nestedItem of item.items; track nestedItem) {\n                  <li>\n                    @if (nestedItem.isVisible(user)) {\n                      <a href=\"\"\n                         [routerLink]=\"[nestedItem.url]\"\n                         routerLinkActive=\"active\"\n                         [ngClass]=\"{active: item.active}\"\n                         data-bs-toggle=\"tooltip\"\n                         data-bs-placement=\"top\"\n                         id=\"{{nestedItem.title}}\"\n                         title=\"{{nestedItem.title | translate}}\"\n                         class=\"menu-item\"\n                      >\n                        <span class=\"material-symbols-outlined nav-icon\">{{nestedItem.icon}}</span>\n                        <span class=\"text\" translate>{{nestedItem.title}}</span>\n                      </a>\n                    }\n                  </li>\n                }\n              </ul>\n            </div>\n          </div>\n        </div>\n      }\n    } @else {\n      @if (item.isVisible(user)) {\n        <a\n          class=\"menu-item\"\n          [routerLink]=\"[item.url]\"\n          [ngClass]=\"{active: item.active}\"\n          data-bs-toggle=\"tooltip\"\n          data-bs-placement=\"top\"\n          id=\"{{item.title}}\"\n          title=\"{{item.title | translate}}\"\n        >\n          <span class=\"indicator\"></span>\n          <span class=\"material-symbols-outlined nav-icon\">{{item.icon}}</span>\n          <span class=\"text\" translate>{{item.title}}</span>\n        </a>\n      }\n    }\n  }\n</div>\n", styles: ["a.menu-item{display:flex;height:64px;margin-bottom:8px;color:#5d666f;font-weight:400;font-size:20px;text-decoration:none;transition:padding .5s;overflow:hidden;white-space:nowrap;padding-left:0}a.menu-item:focus,a.menu-item.active{color:#000;font-weight:700}a.menu-item.hide{display:none}a.menu-item:hover{color:#000;cursor:pointer}a.menu-item span{display:flex;align-items:center;justify-content:center}a.menu-item .nav-icon{width:24px}a.menu-item .text{margin-left:1rem;transition:opacity .5s ease-out,width}a.menu-item .indicator{padding-left:8px;margin-right:8px;transition:margin .5s}a.menu-item.active .indicator{border-radius:0 4px 4px 0;background:var(--action-primary, #000)}.nav-items.collapsed a.active{padding-left:0}.nav-items.collapsed a .text{opacity:0}.nav-items.collapsed .accordion-body a.active{padding-left:.75rem}.nav-items.collapsed a .indicator{margin-right:24px}.nav-items.collapsed a.active .indicator{padding-left:8px}.accordion-button{border:none;box-shadow:none}.accordion-body{padding:0 0 0 2rem}ul{padding:0;list-style:none;margin-bottom:0}@media (max-width: 575.98px){.indicator{display:none!important}.nav-items{padding-left:0;margin:0;max-height:0;border-top:1px solid #eaebeb;z-index:9999;transition:max-height .4s ease-in;overflow:scroll}.nav-items.expanded{max-height:calc(100vh - 48px);transition:max-height .5s ease-in-out}.nav-items a.menu-item{padding:8px 0 8px 12px;border-bottom:1px solid #eaebeb;background-color:#fff;margin-bottom:0;color:#000;font-weight:700;height:auto}.nav-items a.menu-item.active{color:#0090bd}.nav-items a.menu-item .text{margin-left:1rem;line-height:24px;font-size:16px}.nav-items a:has(>.accordion){padding-left:0;padding-bottom:0}.nav-items a:last-child{border-bottom:none!important}.nav-items .accordion a{padding-left:12px;padding-bottom:8px}.nav-items .accordion-button{padding:0}.nav-items .accordion-button:after{margin-right:12px}.nav-items .accordion-body{padding:0}.nav-items .accordion-body a{background-color:#f8f9fa}}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "directive", type: i1$1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i1$1.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "ariaCurrentWhenActive", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DefaultMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-default-menu', template: "<div class=\"nav-items\" [ngClass]=\"{expanded: mobileExpanded, collapsed: collapsed}\">\n  @for (item of navItems(); track item) {\n    @if (item.items) {\n      @if (item.isVisible(user)) {\n        <div class=\"accordion\">\n          <a class=\"accordion-button collapsed menu-item\" id=\"{{item.title}}\"\n             data-bs-toggle=\"collapse\" [attr.data-bs-target]=\"'#' + item.icon\" aria-expanded=\"true\" [attr.aria-controls]=\"item.icon\">\n            <span class=\"indicator\"></span>\n            <span class=\"material-symbols-outlined nav-icon\"\n                  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"{{item.title | translate}}\">{{item.icon}}</span>\n            <span class=\"text\" translate>{{item.title}}</span>\n          </a>\n          <div id=\"{{item.icon}}\" class=\"accordion-collapse collapse\" data-bs-parent=\"#accordionExample\">\n            <div class=\"accordion-body\">\n              <ul>\n                @for (nestedItem of item.items; track nestedItem) {\n                  <li>\n                    @if (nestedItem.isVisible(user)) {\n                      <a href=\"\"\n                         [routerLink]=\"[nestedItem.url]\"\n                         routerLinkActive=\"active\"\n                         [ngClass]=\"{active: item.active}\"\n                         data-bs-toggle=\"tooltip\"\n                         data-bs-placement=\"top\"\n                         id=\"{{nestedItem.title}}\"\n                         title=\"{{nestedItem.title | translate}}\"\n                         class=\"menu-item\"\n                      >\n                        <span class=\"material-symbols-outlined nav-icon\">{{nestedItem.icon}}</span>\n                        <span class=\"text\" translate>{{nestedItem.title}}</span>\n                      </a>\n                    }\n                  </li>\n                }\n              </ul>\n            </div>\n          </div>\n        </div>\n      }\n    } @else {\n      @if (item.isVisible(user)) {\n        <a\n          class=\"menu-item\"\n          [routerLink]=\"[item.url]\"\n          [ngClass]=\"{active: item.active}\"\n          data-bs-toggle=\"tooltip\"\n          data-bs-placement=\"top\"\n          id=\"{{item.title}}\"\n          title=\"{{item.title | translate}}\"\n        >\n          <span class=\"indicator\"></span>\n          <span class=\"material-symbols-outlined nav-icon\">{{item.icon}}</span>\n          <span class=\"text\" translate>{{item.title}}</span>\n        </a>\n      }\n    }\n  }\n</div>\n", styles: ["a.menu-item{display:flex;height:64px;margin-bottom:8px;color:#5d666f;font-weight:400;font-size:20px;text-decoration:none;transition:padding .5s;overflow:hidden;white-space:nowrap;padding-left:0}a.menu-item:focus,a.menu-item.active{color:#000;font-weight:700}a.menu-item.hide{display:none}a.menu-item:hover{color:#000;cursor:pointer}a.menu-item span{display:flex;align-items:center;justify-content:center}a.menu-item .nav-icon{width:24px}a.menu-item .text{margin-left:1rem;transition:opacity .5s ease-out,width}a.menu-item .indicator{padding-left:8px;margin-right:8px;transition:margin .5s}a.menu-item.active .indicator{border-radius:0 4px 4px 0;background:var(--action-primary, #000)}.nav-items.collapsed a.active{padding-left:0}.nav-items.collapsed a .text{opacity:0}.nav-items.collapsed .accordion-body a.active{padding-left:.75rem}.nav-items.collapsed a .indicator{margin-right:24px}.nav-items.collapsed a.active .indicator{padding-left:8px}.accordion-button{border:none;box-shadow:none}.accordion-body{padding:0 0 0 2rem}ul{padding:0;list-style:none;margin-bottom:0}@media (max-width: 575.98px){.indicator{display:none!important}.nav-items{padding-left:0;margin:0;max-height:0;border-top:1px solid #eaebeb;z-index:9999;transition:max-height .4s ease-in;overflow:scroll}.nav-items.expanded{max-height:calc(100vh - 48px);transition:max-height .5s ease-in-out}.nav-items a.menu-item{padding:8px 0 8px 12px;border-bottom:1px solid #eaebeb;background-color:#fff;margin-bottom:0;color:#000;font-weight:700;height:auto}.nav-items a.menu-item.active{color:#0090bd}.nav-items a.menu-item .text{margin-left:1rem;line-height:24px;font-size:16px}.nav-items a:has(>.accordion){padding-left:0;padding-bottom:0}.nav-items a:last-child{border-bottom:none!important}.nav-items .accordion a{padding-left:12px;padding-bottom:8px}.nav-items .accordion-button{padding:0}.nav-items .accordion-button:after{margin-right:12px}.nav-items .accordion-body{padding:0}.nav-items .accordion-body a{background-color:#f8f9fa}}\n"] }]
        }], ctorParameters: () => [{ type: AuthService }, { type: i1$1.Router }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NAV_ITEM_SERVICE]
                }] }], propDecorators: { mobileExpanded: [{
                type: Input
            }], collapsed: [{
                type: Input
            }] } });

class NavItem {
    constructor(url, title, icon, allowedRoles, requiredFeatureFlags, items, alternativeUrls, expanded) {
        this.active = true;
        this.url = url;
        this.title = title;
        this.icon = icon;
        this.allowedRoles = allowedRoles;
        this.requiredFeatureFlags = requiredFeatureFlags;
        this.items = items;
        this.alternativeUrls = alternativeUrls;
        this.expanded = expanded;
    }
    setActive(url) {
        if (url === this.url) {
            this.active = true;
            return;
        }
        if (this.alternativeUrls && this.alternativeUrls.includes(url)) {
            this.active = true;
            return;
        }
        this.active = false;
    }
    isVisible(user) {
        if (!this.allowedRoles && !this.requiredFeatureFlags) {
            return true;
        }
        if (!user) {
            return false;
        }
        return (!this.allowedRoles || this.allowedRoles.includes(user.role))
            && (!this.requiredFeatureFlags || this.requiredFeatureFlags.every((flag) => user.featureFlags.includes(flag)));
    }
}

marker('error.UsernameExistsException');
marker('error.FailedAuthenticationException');
marker('error.CodeDeliveryFailureException');
marker('error.LimitExceededException');
marker('error.InvalidPasswordException');
marker('error.InvalidPasswordFormatException');
marker('error.InternalErrorException');
marker('error.AWSCognitoIdentityProviderException');
marker('error.ForbiddenException');
marker('error.PasswordResetRequiredException');
marker('error.PreconditionNotMetException');
marker('error.UnauthorizedException');
marker('error.UserNotConfirmedException');
marker('error.AccessDeniedException');
marker('error.NoSuchElementException');
marker('error.ResourceNotFoundException');
marker('error.ResourceAlreadyExists');
marker('error.MailSendException');
marker('error.ConstraintViolationException');
marker('error.BadRequestException');
marker('error.IllegalArgumentException');
marker('error.UserNotFoundException');
marker('error.JsonParseException');
marker('error.UnsupportedDataTypeException');
marker('error.MethodNotAllowedException');
marker('error.JiraServiceDeskException');
marker('error.MultipleUsersFoundException');
marker('error.UserCreationException');
marker('error.KeycloakException');
marker('error.MailException');
marker('error.custom.no_active_job');
marker('error.custom.cannot_delete_self');
marker('error.custom.cannot_delete_admin');
marker('error.custom.cannot_change_admin_role');
marker('error.custom.cannot_change_email');
marker('error.custom.email_already_exists');
marker('error.custom.email_already_verified');
marker('error.custom.user_or_org_not_verified');
marker('error.custom.invalid_activation_code');
marker('error.WorkflowIdentifierAlreadyExists');
marker('httperror.0');
marker('httperror.400');
marker('httperror.401');
marker('httperror.403');
marker('httperror.404');
marker('httperror.405');
marker('httperror.406');
marker('httperror.407');
marker('httperror.408');
marker('httperror.409');
marker('httperror.410');
marker('httperror.411');
marker('httperror.412');
marker('httperror.413');
marker('httperror.414');
marker('httperror.415');
marker('httperror.416');
marker('httperror.417');
marker('httperror.418');
marker('httperror.419');
marker('httperror.420');
marker('httperror.422');
marker('httperror.500');
marker('httperror.501');
marker('httperror.503');
marker('httperror.502');
class ErrorComponent {
    constructor() {
        this.error = input();
        this.errorObject = computed(() => {
            if (this.error()?.error?.error !== undefined) {
                return {
                    status: this.error().status.toString(),
                    message: this.error().error.error,
                    validationErrors: this.error().error.validationErrors || '',
                };
            }
            else if (this.error()?.status !== undefined) {
                return {
                    status: this.error().status.toString(),
                    message: `httperror.${this.error().status}`,
                };
            }
            else if (this.error()?.message !== undefined) {
                return {
                    status: '',
                    message: this.error().message,
                };
            }
            else {
                return {
                    status: '',
                    message: 'error.unknown',
                };
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ErrorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: ErrorComponent, selector: "app-error", inputs: { error: { classPropertyName: "error", publicName: "error", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0, template: "@if (error()) {\n  <div class=\"alert alert-danger mt-3 text-break\">\n    <span class=\"material-icons-outlined me-2\">error</span>\n    @if (errorObject()!.status && errorObject()!.status !== '0'  && !errorObject()!.message) {\n      <strong>{{ errorObject()!.status }}:</strong>\n    }\n    <span>&nbsp;</span>\n    <span translate>{{ errorObject()!.message }}</span>\n    <br />\n    @if (errorObject()!.validationErrors?.length) {\n      <span class=\"mt-2\"> <strong translate>Validation Errors:</strong>&nbsp;{{ errorObject()!.validationErrors }} </span>\n    }\n  </div>\n}\n", styles: [""], dependencies: [{ kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-error', template: "@if (error()) {\n  <div class=\"alert alert-danger mt-3 text-break\">\n    <span class=\"material-icons-outlined me-2\">error</span>\n    @if (errorObject()!.status && errorObject()!.status !== '0'  && !errorObject()!.message) {\n      <strong>{{ errorObject()!.status }}:</strong>\n    }\n    <span>&nbsp;</span>\n    <span translate>{{ errorObject()!.message }}</span>\n    <br />\n    @if (errorObject()!.validationErrors?.length) {\n      <span class=\"mt-2\"> <strong translate>Validation Errors:</strong>&nbsp;{{ errorObject()!.validationErrors }} </span>\n    }\n  </div>\n}\n" }]
        }] });

class BooleanIconPipe {
    transform(value) {
        if (value) {
            return '<span class="material-symbols-outlined text-success">check</span>';
        }
        else {
            return '<span class="material-symbols-outlined text-danger">close</span>';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BooleanIconPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: BooleanIconPipe, name: "toBooleanIcon" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BooleanIconPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'toBooleanIcon',
                }]
        }] });

class CountdownTimerPipe {
    transform(timeRemaining) {
        if (!timeRemaining) {
            return '';
        }
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
        let minutesStr = minutes.toString();
        let secondsStr = seconds.toString();
        if (minutes < 10) {
            minutesStr = `0${minutesStr}`;
        }
        if (seconds < 10) {
            secondsStr = `0${secondsStr}`;
        }
        return `${minutesStr}:${secondsStr}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CountdownTimerPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: CountdownTimerPipe, name: "countdownTimer" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CountdownTimerPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'countdownTimer',
                }]
        }] });

const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB'];
const FILE_SIZE_UNITS_LONG = ['Bytes', 'Kilobytes', 'Megabytes', 'Gigabytes'];
class FileSizePipe {
    transform(sizeInBytes, longForm) {
        if (Number.isNaN(sizeInBytes)) {
            return 'n/a';
        }
        const units = longForm ? FILE_SIZE_UNITS_LONG : FILE_SIZE_UNITS;
        let power = Math.round(Math.log(sizeInBytes) / Math.log(2048));
        power = Math.max(Math.min(power, units.length - 1), 0);
        const size = sizeInBytes / 1024 ** power;
        const formattedSize = Math.round(size * 100) / 100;
        const unit = units[power];
        return `${formattedSize} ${unit}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FileSizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: FileSizePipe, name: "fileSize" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FileSizePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fileSize',
                }]
        }] });

class StatusBadgePipe {
    constructor(translate) {
        this.translate = translate;
    }
    transform(value) {
        if (!value) {
            return '';
        }
        const text = this.translate.instant(value);
        return (`<div class="badge rounded-pill text-bg-light" translate><div class="dot ${value.toLowerCase()}"></div>${text}</div>`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: StatusBadgePipe, deps: [{ token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: StatusBadgePipe, name: "toStatusBadge" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: StatusBadgePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'toStatusBadge',
                }]
        }], ctorParameters: () => [{ type: i2.TranslateService }] });

class NimmstaTimeAgoPipe {
    constructor(translate, datePipe, timeAgoPipe, sanitizer) {
        this.translate = translate;
        this.datePipe = datePipe;
        this.timeAgoPipe = timeAgoPipe;
        this.sanitizer = sanitizer;
    }
    transform(value) {
        if (!value) {
            return this.translate.instant('timeago.never');
        }
        else {
            let date;
            if (typeof value === 'number' && value < 10000000000) {
                date = dayjs(value * 1000);
            }
            else if (typeof value === 'string' && /^\d+$/.test(value)) {
                date = dayjs(Number.parseInt(value, 10));
            }
            else if (value) {
                date = dayjs(value);
            }
            const tooltip = this.datePipe.transform(value);
            const timeAgo = this.timeAgoPipe.transform(date);
            return this.sanitizer.bypassSecurityTrustHtml(`
        <span data-bs-toggle="tooltip" data-bs-placement="top" title="${tooltip}">
          ${timeAgo}
        </span>`);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NimmstaTimeAgoPipe, deps: [{ token: i2.TranslateService }, { token: DateTimePipe }, { token: i3$1.TimeagoPipe }, { token: i4$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: NimmstaTimeAgoPipe, name: "timeAgo", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NimmstaTimeAgoPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'timeAgo',
                    pure: false,
                }]
        }], ctorParameters: () => [{ type: i2.TranslateService }, { type: DateTimePipe }, { type: i3$1.TimeagoPipe }, { type: i4$1.DomSanitizer }] });

class DatePipe {
    constructor(dateTimePipe) {
        this.dateTimePipe = dateTimePipe;
    }
    transform(value) {
        return this.dateTimePipe.transform(value, DateTimeFormat.DATE);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DatePipe, deps: [{ token: DateTimePipe }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: DatePipe, name: "datePipe" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'datePipe',
                }]
        }], ctorParameters: () => [{ type: DateTimePipe }] });

class TimePipe {
    transform(value, format = DateTimeFormat.DATE_TIME_LONG) {
        let date;
        if (typeof value === 'number' && value < 10000000000) {
            date = dayjs(value * 1000);
        }
        else if (typeof value === 'string' && /^\d+$/.test(value)) {
            date = dayjs(Number.parseInt(value, 10));
        }
        else if (value) {
            date = dayjs(value);
        }
        return date?.locale(dayjs.locale()).format(format) || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TimePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: TimePipe, name: "nimmstaTime" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TimePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'nimmstaTime',
                }]
        }] });

class BasicCommonsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BasicCommonsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: BasicCommonsModule, declarations: [BooleanIconPipe,
            CountdownTimerPipe,
            DatePipe,
            DateTimePipe,
            FileSizePipe,
            StatusBadgePipe,
            NimmstaTimeAgoPipe,
            TimePipe,
            OrdinalDatePipe,
            DateEvalPipe], imports: [CommonModule,
            TranslateModule,
            MatProgressSpinnerModule,
            FormsModule], exports: [CommonModule,
            TranslateModule,
            MatProgressSpinnerModule,
            FormsModule,
            BooleanIconPipe,
            CountdownTimerPipe,
            DatePipe,
            DateTimePipe,
            FileSizePipe,
            StatusBadgePipe,
            NimmstaTimeAgoPipe,
            TimePipe,
            OrdinalDatePipe,
            DateEvalPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BasicCommonsModule, imports: [CommonModule,
            TranslateModule,
            MatProgressSpinnerModule,
            FormsModule, CommonModule,
            TranslateModule,
            MatProgressSpinnerModule,
            FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BasicCommonsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule,
                        MatProgressSpinnerModule,
                        FormsModule,
                    ],
                    declarations: [
                        BooleanIconPipe,
                        CountdownTimerPipe,
                        DatePipe,
                        DateTimePipe,
                        FileSizePipe,
                        StatusBadgePipe,
                        NimmstaTimeAgoPipe,
                        TimePipe,
                        OrdinalDatePipe,
                        DateEvalPipe,
                    ],
                    exports: [
                        CommonModule,
                        TranslateModule,
                        MatProgressSpinnerModule,
                        FormsModule,
                        BooleanIconPipe,
                        CountdownTimerPipe,
                        DatePipe,
                        DateTimePipe,
                        FileSizePipe,
                        StatusBadgePipe,
                        NimmstaTimeAgoPipe,
                        TimePipe,
                        OrdinalDatePipe,
                        DateEvalPipe,
                    ],
                }]
        }] });

class WaitingListComponent {
    constructor(authService, sessionService, keycloakClient) {
        this.authService = authService;
        this.sessionService = sessionService;
        this.keycloakClient = keycloakClient;
        this.sessionId = signal(undefined);
        this.isImpersonating = sessionStorage.getItem(IMPERSONATION_SESSION_STORAGE_KEY) !== null;
    }
    ngOnInit() {
        this.authService.getCurrentUser() // ensure user is loaded
            .pipe(switchMap(this.keycloakClient.getToken)).subscribe((token) => {
            // parse token
            const sessionId = JSON.parse(atob(token.split('.')[1])).sid;
            this.sessionId.set(sessionId);
        });
    }
    async logout() {
        await this.authService.logout(window.location.origin);
    }
    async endImpersonation() {
        const exit = () => {
            // Close the current tab
            sessionStorage.removeItem(IMPERSONATION_SESSION_STORAGE_KEY);
            window.close();
            // Reload the current page if closing the tab fails (Scripts may close only the windows that were opened by them.)
            window.location.reload();
        };
        const sessionId = this.sessionId();
        if (sessionId) {
            firstValueFrom(this.sessionService.terminate(sessionId))
                .finally(exit);
        }
        else {
            exit();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WaitingListComponent, deps: [{ token: AuthService }, { token: KeycloakSessionService }, { token: i2$1.KeycloakService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: WaitingListComponent, selector: "app-waiting-list", ngImport: i0, template: "<div class=\"blocker-page\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-2\">\n        <div>\n          <img src=\"./assets/img/logo.png\" class=\"w-100 m-5\" alt=\"Nimmsta Logo\" />\n        </div>\n      </div>\n      <div class=\"row rounded  p-4 blocker-page-content\">\n        <div class=\"col-8\">\n          <h1 translate>waiting-list.title</h1>\n          <br />\n          <p translate>waiting-list.top-text</p>\n          <br />\n          <p translate>waiting-list.support-text</p>\n          <p><a href=\"mailto:support@nimmsta.com\">support&#64;nimmsta.com</a></p>\n          <br />\n          <p translate>waiting-list.thanks-message</p>\n          <p>NIMMSTA GmbH.</p>\n        </div>\n      </div>\n      <div class=\"row mt-4\">\n        <button *ngIf=\"!isImpersonating\"\n          class=\"btn btn-primary w-25 mt-4 mb-5 position-absolute start-50 translate-middle\" (click)=\"logout()\"\n          translate>logout</button>\n        <button *ngIf=\"isImpersonating\"\n          class=\"btn btn-primary w-25 mt-4 mb-5 position-absolute start-50 translate-middle\"\n          (click)=\"endImpersonation()\" translate>end_impersonation</button>\n      </div>\n    </div>\n  </div>\n", styles: [".blocker-page{background-color:var(--blue-gray, #e5eaed);width:100%;height:100%}.blocker-page-content{background-color:#fff}\n"], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WaitingListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-waiting-list', template: "<div class=\"blocker-page\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-2\">\n        <div>\n          <img src=\"./assets/img/logo.png\" class=\"w-100 m-5\" alt=\"Nimmsta Logo\" />\n        </div>\n      </div>\n      <div class=\"row rounded  p-4 blocker-page-content\">\n        <div class=\"col-8\">\n          <h1 translate>waiting-list.title</h1>\n          <br />\n          <p translate>waiting-list.top-text</p>\n          <br />\n          <p translate>waiting-list.support-text</p>\n          <p><a href=\"mailto:support@nimmsta.com\">support&#64;nimmsta.com</a></p>\n          <br />\n          <p translate>waiting-list.thanks-message</p>\n          <p>NIMMSTA GmbH.</p>\n        </div>\n      </div>\n      <div class=\"row mt-4\">\n        <button *ngIf=\"!isImpersonating\"\n          class=\"btn btn-primary w-25 mt-4 mb-5 position-absolute start-50 translate-middle\" (click)=\"logout()\"\n          translate>logout</button>\n        <button *ngIf=\"isImpersonating\"\n          class=\"btn btn-primary w-25 mt-4 mb-5 position-absolute start-50 translate-middle\"\n          (click)=\"endImpersonation()\" translate>end_impersonation</button>\n      </div>\n    </div>\n  </div>\n", styles: [".blocker-page{background-color:var(--blue-gray, #e5eaed);width:100%;height:100%}.blocker-page-content{background-color:#fff}\n"] }]
        }], ctorParameters: () => [{ type: AuthService }, { type: KeycloakSessionService }, { type: i2$1.KeycloakService }] });

class ConfirmationDialogComponent {
    constructor(bsModalRef) {
        this.bsModalRef = bsModalRef;
        this.title = 'default-confirm-title';
        this.message = 'default-confirm-message';
        this.result = false;
    }
    ngAfterViewInit() {
        this.bsModalRef.setClass('modal-dialog-centered');
    }
    dismiss() {
        this.bsModalRef.hide();
    }
    confirm() {
        this.bsModalRef.hide();
        this.bsModalRef.content.result = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfirmationDialogComponent, deps: [{ token: i1$3.BsModalRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: ConfirmationDialogComponent, selector: "app-confirmation-dialog", ngImport: i0, template: "<div class=\"modal-header\">\n  <h4 class=\"modal-title\" translate>{{title}}</h4>\n  <button type=\"button\" class=\"btn-close close pull-right\" aria-label=\"Close\" (click)=\"dismiss()\">\n    <span aria-hidden=\"true\" class=\"visually-hidden\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p translate>{{message}}</p>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"dismiss()\" translate>cancel</button>\n  <button type=\"button\" class=\"btn btn-warning\" (click)=\"confirm()\" translate>leave</button>\n</div>", dependencies: [{ kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfirmationDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-confirmation-dialog', template: "<div class=\"modal-header\">\n  <h4 class=\"modal-title\" translate>{{title}}</h4>\n  <button type=\"button\" class=\"btn-close close pull-right\" aria-label=\"Close\" (click)=\"dismiss()\">\n    <span aria-hidden=\"true\" class=\"visually-hidden\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p translate>{{message}}</p>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"dismiss()\" translate>cancel</button>\n  <button type=\"button\" class=\"btn btn-warning\" (click)=\"confirm()\" translate>leave</button>\n</div>" }]
        }], ctorParameters: () => [{ type: i1$3.BsModalRef }] });

class ComponentsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ComponentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: ComponentsModule, declarations: [P404Component,
            P500Component,
            HeaderBarComponent,
            LanguageSwitcherComponent,
            LoadingIndicatorComponent,
            ErrorComponent,
            WaitingListComponent,
            OfflineToastComponent,
            DefaultLayoutComponent,
            DefaultMenuComponent,
            ConfirmationDialogComponent,
            EditorComponent,
            MaintenanceInfoComponent], imports: [BasicCommonsModule,
            RouterModule,
            EditorModule,
            ReactiveFormsModule,
            AlertModule], exports: [P404Component,
            P500Component,
            HeaderBarComponent,
            LanguageSwitcherComponent,
            LoadingIndicatorComponent,
            ErrorComponent,
            WaitingListComponent,
            OfflineToastComponent,
            DefaultLayoutComponent,
            DefaultMenuComponent,
            ConfirmationDialogComponent,
            EditorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ComponentsModule, imports: [BasicCommonsModule,
            RouterModule,
            EditorModule,
            ReactiveFormsModule,
            AlertModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ComponentsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        BasicCommonsModule,
                        RouterModule,
                        EditorModule,
                        ReactiveFormsModule,
                        AlertModule,
                    ],
                    declarations: [
                        P404Component,
                        P500Component,
                        HeaderBarComponent,
                        LanguageSwitcherComponent,
                        LoadingIndicatorComponent,
                        ErrorComponent,
                        WaitingListComponent,
                        OfflineToastComponent,
                        DefaultLayoutComponent,
                        DefaultMenuComponent,
                        ConfirmationDialogComponent,
                        EditorComponent,
                        MaintenanceInfoComponent,
                    ],
                    exports: [
                        P404Component,
                        P500Component,
                        HeaderBarComponent,
                        LanguageSwitcherComponent,
                        LoadingIndicatorComponent,
                        ErrorComponent,
                        WaitingListComponent,
                        OfflineToastComponent,
                        DefaultLayoutComponent,
                        DefaultMenuComponent,
                        ConfirmationDialogComponent,
                        EditorComponent,
                    ],
                }]
        }] });

class B2bDataService extends AbstractDataService {
    constructor(http, configuration) {
        if (!configuration.apiUrls.b2b) {
            throw new Error('B2B API URL is not configured');
        }
        super(http, configuration, `${configuration.apiUrls.b2b}/api`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: B2bDataService, deps: [{ token: i1.HttpClient }, { token: DataTableModuleConfiguration }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: B2bDataService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: B2bDataService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: DataTableModuleConfiguration }] });

class ConfigurationDataService extends AbstractDataService {
    constructor(http, configuration) {
        if (!configuration.apiUrls.configurations) {
            throw new Error('Configuration API URL is not configured');
        }
        super(http, configuration, configuration.apiUrls.configurations);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationDataService, deps: [{ token: i1.HttpClient }, { token: DataTableModuleConfiguration }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationDataService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationDataService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: DataTableModuleConfiguration }] });

class Column {
    constructor(displayedProperty, name, config) {
        this.displayedProperty = displayedProperty;
        this.name = name;
        this.pipe = config?.pipe;
        this.asyncPipe = config?.asyncPipe;
        this.translateHeader = config?.translateHeader ?? true;
        this.translate = config?.translate ?? false;
        this.sortable = config?.sortable ?? false;
        this.sortingName = config?.sortingName ?? displayedProperty;
        this.invertSorting = config?.invertSorting ?? false;
    }
}

class CustomAction {
    constructor(text, primaryAction = false, isDelete = false, checkActive) {
        this.primaryAction = false;
        this.isDelete = false;
        this.loading = false;
        this.btnClass = 'btn-outline-secondary';
        this._text = text;
        this.action = new EventEmitter();
        this.primaryAction = primaryAction;
        this.isDelete = isDelete;
        this.checkActive = checkActive;
    }
    // Argument is not used in this class, but it enabled other customActions to
    // determine the text based on the item or the items state
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getText(_) {
        return this._text;
    }
    // Argument is not used in this class, but it enabled other customActions to
    // determine the text based on the item or the items state
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isEnabled(_) {
        return of(true);
    }
    // Argument is not used in this class, but it enabled other customActions to
    // determine the class based on the item or the items state
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getClass(_) {
        return this.btnClass;
    }
    subscribe(fn) {
        this.action.subscribe(fn);
    }
    emit(id) {
        this.action.emit(id);
    }
}

class CustomTableAction extends CustomAction {
    constructor(text, icon = '') {
        super(text, false);
        this.icon = icon;
    }
}

/* eslint-disable no-param-reassign */
/**
 * Data Table can be used to display data in a table.
 */
class DataTableComponent {
    constructor(modalService, router, route, configuration, languageService) {
        this.modalService = modalService;
        this.router = router;
        this.route = route;
        this.configuration = configuration;
        this.languageService = languageService;
        this.columns = [];
        this.actionNew = true;
        this.customActions = input([]);
        this.iconActions = input([]);
        this.btnClass = 'primary';
        this.customTableActions = input([]);
        // Secondary tables should for example not update query parameters overwriting the main table's parameters
        this.isMainTable = input(true);
        this.loadOnInit = true;
        this.searchEnabled = true;
        this.showPagination = true;
        this.showEvent = new EventEmitter();
        this.newEvent = new EventEmitter();
        this.customTableActionsText = computed(() => this.customTableActions().map((action) => action.getText()));
        this.actualDisplayedColumns = signal([]);
        this.headerDef = computed(() => this.actualDisplayedColumns().map((c) => c.displayedProperty));
        this.processedData = {};
        this.customActionActivationMap = {};
        this.customActionVisibilityMap = {};
        this.hasActivatedCustomNonPrimaryMap = {};
        this.iconActionActivationMap = {};
        this.iconActionVisibilityMap = {};
        this.customActionTextMap = {};
        this.iconActionTextMap = {};
        this.customActionClassMap = {};
        this.iconActionClassMap = {};
        this.asyncColumns = [];
        this.syncColumns = [];
        this.storageKeyAppendix = '_table_sort_page_filter';
        this.sortParamKey = 'sort';
        this.directionParamKey = 'dir';
        this.pageSizeParamKey = 'pageSize';
        this.pageParamKey = 'page';
        this.clickActionBlacklist = ['a', 'button'];
    }
    ngOnInit() {
        this.checkWidth();
        this.paginator.pageSizeOptions = this.configuration.defaultPageSizeOptions;
        this.paginator.pageSize = this.defaultPageSize ?? this.configuration.defaultPageSize;
        this.loadSortPageFilterSearch();
        if (this.loadOnInit) {
            this.loadDataPage();
        }
        this.asyncColumns = this.columns.filter((c) => !c.pipe && c.asyncPipe);
        this.syncColumns = this.columns.filter((c) => c.pipe || !c.asyncPipe);
        this.languageService.languageChange.subscribe(() => {
            this.setUpProcessedDataMirror();
        });
    }
    checkWidth() {
        if (window.innerWidth < 550) {
            this.actualDisplayedColumns.set([this.columns[0]]);
        }
        else {
            this.actualDisplayedColumns.set(Object.assign([], this.columns));
        }
        const columns = this.actualDisplayedColumns();
        columns.push(new Column('actions'));
        this.actualDisplayedColumns.set(columns);
    }
    ngAfterViewInit() {
        fromEvent(this.input.nativeElement, 'keyup')
            .pipe(debounceTime(250), distinctUntilChanged(), tap(() => {
            this.paginator.pageIndex = 0;
            this.saveSortPageFilterSearch();
            this.changeQueryParams();
            this.loadDataPage();
        })).subscribe();
        // Search reset emits the 'search' event, why I don't know.
        // Never gets fired otherwise
        fromEvent(this.input.nativeElement, 'search')
            .pipe(debounceTime(250), distinctUntilChanged(), tap(() => {
            this.paginator.pageIndex = 0;
            this.saveSortPageFilterSearch();
            this.changeQueryParams();
            this.loadDataPage();
        })).subscribe();
        this.sort.sortChange.subscribe(() => {
            this.paginator.pageIndex = 0;
            this.saveSortPageFilterSearch();
            this.changeQueryParams();
        });
        this.paginator.page.subscribe(() => {
            this.saveSortPageFilterSearch();
            this.changeQueryParams();
        });
        this.loadSub = merge(this.paginator.page, this.sort.sortChange)
            .pipe(tap(() => {
            this.loadDataPage();
        })).subscribe();
    }
    findSortingName(active) {
        const column = this.columns.find((c) => c.displayedProperty === active);
        return column?.sortingName ?? active;
    }
    ngOnDestroy() {
        this.loadSub.unsubscribe();
        if (this.reloadTimeout) {
            clearTimeout(this.reloadTimeout);
        }
    }
    loadDataPage(removeDataOnLoad = false, isPostErrorLoad = false) {
        if (this.reloadTimeout) {
            clearTimeout(this.reloadTimeout);
        }
        this.dataSource
            .loadData({
            search: this.input.nativeElement.value,
            filter: [],
            sortColumn: this.findSortingName(this.sort.active),
            sortOrder: this.getSort(),
            pageNumber: this.paginator.pageIndex,
            pageSize: this.paginator.pageSize,
            removeDataOnLoad,
        })
            .subscribe({
            next: () => {
                this.setUpActionMaps();
                this.setUpProcessedDataMirror();
                this.changeQueryParams();
                this.checkWidth();
                this.paginator.length = this.dataSource.count;
                if (this.reloadInterval) {
                    this.reloadTimeout = setTimeout(() => {
                        this.loadDataPage();
                    }, this.reloadInterval);
                }
            },
            error: (e) => {
                const lowercaseMessage = e?.error?.message?.toLowerCase();
                if (e.status === 500 && !isPostErrorLoad && lowercaseMessage
                    && lowercaseMessage.includes('no property') && lowercaseMessage.includes('found for type')) {
                    this.resetQuery();
                    return;
                }
                this.error = e;
            },
        });
    }
    setUpActionMaps() {
        this.customActionActivationMap = {};
        this.customActionVisibilityMap = {};
        this.customActionTextMap = {};
        this.customActionClassMap = {};
        this.iconActionActivationMap = {};
        this.iconActionTextMap = {};
        this.iconActionClassMap = {};
        this.hasActivatedCustomNonPrimaryMap = {};
        this.dataSource.data.content.forEach((element) => {
            this.customActionVisibilityMap[element.id] = this.customActions().map((action) => {
                const newSignal = signal(false);
                action.isEnabled(element).subscribe((enabled) => {
                    newSignal.set(enabled);
                });
                return newSignal;
            });
            this.customActionActivationMap[element.id] = this.customActions().map((action) => signal(action.checkActive ? action.checkActive(element.id) : true));
            this.customActionTextMap[element.id] = this.customActions().map((action) => action.getText(element));
            this.customActionClassMap[element.id] = this.customActions().map((action) => action.getClass(element));
            this.iconActionVisibilityMap[element.id] = this.iconActions().map((action) => {
                const newSignal = signal(false);
                action.isEnabled(element).subscribe((enabled) => {
                    newSignal.set(enabled);
                });
                return newSignal;
            });
            this.iconActionActivationMap[element.id] = this.iconActions().map((action) => signal(action.checkActive ? action.checkActive(element.id) : true));
            this.iconActionTextMap[element.id] = this.iconActions().map((action) => action.getText(element));
            this.iconActionClassMap[element.id] = this.iconActions().map((action) => action.getClass(element));
            this.hasActivatedCustomNonPrimaryMap[element.id] = computed(() => {
                const actions = this.customActions();
                return actions.some((action, index) => !action.primaryAction
                    && this.customActionActivationMap[element.id][index]()
                    && this.customActionVisibilityMap[element.id][index]());
            });
        });
    }
    setUpProcessedDataMirror() {
        if (!this.dataSource.count) {
            this.processedData = {};
            return;
        }
        const dataCopy = this.dataSource.data.content.slice();
        dataCopy.forEach((element) => {
            // Load sync values directly
            const syncValues = this.syncColumns
                .reduce((valueObject, column) => Object.assign(valueObject, {
                [column.displayedProperty]: signal(this.getSyncDataAsString(element, column)),
            }), {});
            // Prepare async values as undefined
            this.processedData[element.id] = this.asyncColumns
                .reduce((valueObject, column) => Object.assign(valueObject, {
                [column.displayedProperty]: signal(undefined),
            }), syncValues);
        });
        // load async values
        this.asyncColumns.forEach((column) => {
            dataCopy.forEach((element) => {
                this.getAsyncDataByString(element, column).subscribe((data) => {
                    this.setProcessedValue(element.id, column.displayedProperty, data);
                });
            });
        });
    }
    setProcessedValue(id, displayedProperty, value) {
        if (!this.processedData[id]) {
            // eslint-disable-next-line no-console
            console.error(`No processed data object found for id: ${id}`);
            return;
        }
        this.processedData[id][displayedProperty].set(value);
    }
    saveSortPageFilterSearch() {
        if (this.identifier) {
            const sortPageFilterState = {
                sort: this.sort.active,
                direction: this.sort.direction,
                pageSize: this.paginator.pageSize,
                page: this.paginator.pageIndex,
                search: this.input.nativeElement.value,
            };
            localStorage.setItem(this.identifier + this.storageKeyAppendix, JSON.stringify(sortPageFilterState));
        }
    }
    resetQuery() {
        if (this.identifier) {
            localStorage.removeItem(this.identifier + this.storageKeyAppendix);
            this.sort.active = '';
            this.sort.direction = '';
            const queryParams = this.route.snapshot.queryParams;
            delete queryParams[this.sortParamKey];
            delete queryParams[this.directionParamKey];
            delete queryParams[this.pageSizeParamKey];
            delete queryParams[this.pageParamKey];
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams,
                replaceUrl: true,
            });
            this.loadSortPageFilterSearch();
            this.loadDataPage(undefined, true);
        }
    }
    getSort() {
        const column = this.columns.find((c) => c.displayedProperty === this.sort.active);
        if (!column || !column.invertSorting) {
            return this.sort.direction;
        }
        return this.sort.direction === 'asc' ? 'desc' : 'asc';
    }
    loadSortPageFilterSearch() {
        const params = this.route.snapshot.queryParams;
        const sort = this.isMainTable() ? params[this.sortParamKey] : undefined;
        const direction = this.isMainTable() ? params[this.directionParamKey] : undefined;
        const pageSize = this.isMainTable() ? params[this.pageSizeParamKey] : undefined;
        const page = this.isMainTable() ? params[this.pageParamKey] : undefined;
        const backupSort = this.defaultSortName ?? this.columns.filter((c) => c.sortable)?.[0]?.sortingName ?? 'id';
        const backupDirection = this.defaultSortDirection ?? 'asc';
        if (this.isMainTable()) {
            if (sort) {
                this.sort.active = sort;
            }
            if (direction) {
                this.sort.direction = direction;
            }
            if (pageSize) {
                this.paginator.pageSize = pageSize;
            }
            if (page) {
                this.paginator.pageIndex = page;
                this.paginator.page.emit();
            }
        }
        if (this.identifier) {
            const sortPageFilterStateJson = localStorage.getItem(this.identifier + this.storageKeyAppendix);
            if (sortPageFilterStateJson) {
                const sortPageFilterState = JSON.parse(sortPageFilterStateJson);
                if (sortPageFilterState) {
                    this.sort.active = sort ?? sortPageFilterState.sort;
                    this.sort.direction = direction ?? sortPageFilterState.direction;
                    this.paginator.pageSize = pageSize ?? sortPageFilterState.pageSize;
                    this.paginator.pageIndex = page ?? sortPageFilterState.page;
                    if (this.searchEnabled && sortPageFilterState.search) {
                        this.input.nativeElement.value = sortPageFilterState.search;
                    }
                }
            }
        }
        if (!this.sort.active) {
            this.sort.active = backupSort;
        }
        if (!this.sort.direction) {
            this.sort.direction = backupDirection;
        }
        this.sort.sortChange.emit();
        this.saveSortPageFilterSearch();
    }
    changeQueryParams(changeLocation = true) {
        if (this.identifier && this.isMainTable()) {
            const queryParams = {};
            queryParams[this.sortParamKey] = this.sort.active;
            queryParams[this.directionParamKey] = this.sort.direction;
            queryParams[this.pageSizeParamKey] = this.paginator.pageSize;
            queryParams[this.pageParamKey] = this.paginator.pageIndex;
            if (changeLocation) {
                this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams,
                    queryParamsHandling: 'merge',
                    replaceUrl: true,
                });
            }
            else {
                this.router.navigate([], {
                    queryParams,
                    replaceUrl: true,
                });
            }
        }
    }
    getSyncDataAsString(o, column) {
        const data = this.getRawDataByString(o, column);
        if (column.pipe) {
            return column.pipe.transform(data);
        }
        else {
            return data;
        }
    }
    getAsyncDataByString(o, column) {
        if (!column.asyncPipe) {
            // eslint-disable-next-line no-console
            console.error(`No asyncPipe found for column: ${column.displayedProperty}`);
            return of(undefined);
        }
        const data = this.getRawDataByString(o, column);
        return column.asyncPipe.transform(data);
    }
    getRawDataByString(o, column) {
        let s = column.displayedProperty;
        s = s.replace(/\[(\w+)]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, ''); // strip a leading dot
        const a = s.split('.');
        for (let i = 0, n = a.length; i < n; ++i) {
            const k = a[i];
            if (o && typeof o === 'object' && k in o) {
                o = o[k];
            }
            else {
                return undefined;
            }
        }
        return o;
    }
    emitAction(action, id) {
        if (action.isDelete) {
            this.deleteConfirmation(id, action.action);
        }
        else {
            action.emit(id);
        }
    }
    show(event, id) {
        if (event.target instanceof HTMLElement && this.clickActionBlacklist.indexOf(event.target.tagName.toLowerCase()) > -1) {
            return;
        }
        this.showEvent.emit(id);
    }
    new() {
        this.newEvent.emit();
    }
    deleteConfirmation(deleteId, deleteEvent) {
        this.deleteEvent = deleteEvent;
        this.deleteId = deleteId;
        this.modalRef = this.modalService.show(this.deleteModal);
    }
    delete() {
        if (this.modalRef) {
            this.modalRef.hide();
        }
        this.deleteEvent?.emit(this.deleteId);
    }
    hasShowListener() {
        return this.showEvent.observed;
    }
    setLoadInterval(interval) {
        if (interval < 1000) {
            interval = 1000;
        }
        this.reloadInterval = interval;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DataTableComponent, deps: [{ token: i1$3.BsModalService }, { token: i1$1.Router }, { token: i1$1.ActivatedRoute }, { token: DataTableModuleConfiguration }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: DataTableComponent, selector: "app-datatable", inputs: { dataSource: { classPropertyName: "dataSource", publicName: "dataSource", isSignal: false, isRequired: false, transformFunction: null }, columns: { classPropertyName: "columns", publicName: "columns", isSignal: false, isRequired: false, transformFunction: null }, identifier: { classPropertyName: "identifier", publicName: "identifier", isSignal: false, isRequired: false, transformFunction: null }, actionNew: { classPropertyName: "actionNew", publicName: "actionNew", isSignal: false, isRequired: false, transformFunction: null }, customActions: { classPropertyName: "customActions", publicName: "customActions", isSignal: true, isRequired: false, transformFunction: null }, iconActions: { classPropertyName: "iconActions", publicName: "iconActions", isSignal: true, isRequired: false, transformFunction: null }, btnClass: { classPropertyName: "btnClass", publicName: "btnClass", isSignal: false, isRequired: false, transformFunction: null }, customTableActions: { classPropertyName: "customTableActions", publicName: "customTableActions", isSignal: true, isRequired: false, transformFunction: null }, isMainTable: { classPropertyName: "isMainTable", publicName: "isMainTable", isSignal: true, isRequired: false, transformFunction: null }, loadOnInit: { classPropertyName: "loadOnInit", publicName: "loadOnInit", isSignal: false, isRequired: false, transformFunction: null }, searchEnabled: { classPropertyName: "searchEnabled", publicName: "searchEnabled", isSignal: false, isRequired: false, transformFunction: null }, showPagination: { classPropertyName: "showPagination", publicName: "showPagination", isSignal: false, isRequired: false, transformFunction: null }, defaultPageSize: { classPropertyName: "defaultPageSize", publicName: "defaultPageSize", isSignal: false, isRequired: false, transformFunction: null }, defaultSortName: { classPropertyName: "defaultSortName", publicName: "defaultSortName", isSignal: false, isRequired: false, transformFunction: null }, defaultSortDirection: { classPropertyName: "defaultSortDirection", publicName: "defaultSortDirection", isSignal: false, isRequired: false, transformFunction: null } }, outputs: { showEvent: "showEvent", newEvent: "newEvent" }, viewQueries: [{ propertyName: "paginator", first: true, predicate: MatPaginator, descendants: true, static: true }, { propertyName: "sort", first: true, predicate: MatSort, descendants: true, static: true }, { propertyName: "input", first: true, predicate: ["input"], descendants: true, static: true }, { propertyName: "deleteModal", first: true, predicate: ["deleteModal"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"mb-4 mt-2\">\n  <div class=\"buttons float-end\">\n    <button *ngIf=\"actionNew\" class=\"btn btn-nav\" (click)=\"new()\">\n      <span class=\"material-symbols-outlined\">\n        add_box\n      </span>\n      <span translate>\n        new\n      </span>\n    </button>\n\n    <button *ngFor=\"let action of customTableActions(); index as i\" class=\"btn btn-nav ms-3\"\n            (click)=\"action.action.emit()\" [ladda]=\"action.loading\" data-spinner-color=\"#000000\">\n      <span class=\"material-symbols-outlined\">\n      {{ action.icon }}\n      </span>\n      <span translate>\n        {{ customTableActionsText()[i] }}\n      </span>\n    </button>\n  </div>\n  <div [ngClass]=\"{'d-none': !searchEnabled}\" class=\"float-start search\">\n    <input class=\"form-control\" type=\"search\" placeholder=\"{{ 'search' | translate }}\" #input>\n  </div>\n  <div class=\"clearfix\"></div>\n</div>\n\n<div class=\"card\">\n  <div *ngIf=\"dataSource.loading | async\" style=\"position: absolute; left: calc(50% - 25px); top: 0.5rem;\">\n    <mat-spinner [diameter]=\"25\"></mat-spinner>\n  </div>\n  <div class=\"table-responsive\" [ngClass]=\"{'d-none': dataSource.count === 0}\">\n    <table mat-table [dataSource]=\"dataSource\" matSort [matSortActive]=\"sort.active\" [matSortDirection]=\"sort.direction\"\n           matSortDisableClear (window:resize)=\"checkWidth()\" class=\"overflow-auto table table-responsive table-striped table-hover\">\n      @for (column of actualDisplayedColumns(); track column.displayedProperty) {\n        @if (column.displayedProperty !== 'actions') {\n          <ng-container matColumnDef=\"{{column.displayedProperty}}\" *ngIf=\"column.sortable\">\n            <th mat-header-cell *matHeaderCellDef mat-sort-header class=\"mr-2\">\n              <div *ngIf=\"column.name; else noCustomName\">\n                <span *ngIf=\"column.translateHeader\" translate>{{column.name}}</span>\n                <span *ngIf=\"!column.translateHeader\">{{column.name}}</span>\n              </div>\n              <ng-template #noCustomName>\n                {{column.displayedProperty| titlecase}}\n              </ng-template>\n            </th>\n            <td mat-cell (click)=\"show($event, item.id)\" *matCellDef=\"let item\" class=\"mr-2\" [ngClass]=\"{'clickable': showEvent.observed}\">\n              @if (processedData[item.id] && processedData[item.id][column.displayedProperty]() !== undefined) {\n                <span *ngIf=\"column.translate\" translate>{{ processedData[item.id][column.displayedProperty]() }}</span>\n                <span *ngIf=\"!column.translate\" [innerHTML]=\"processedData[item.id][column.displayedProperty]()\"></span>\n              }\n            </td>\n          </ng-container>\n\n          <ng-container matColumnDef=\"{{column.displayedProperty}}\" *ngIf=\"!column.sortable\">\n            <th mat-header-cell *matHeaderCellDef  class=\"mr-2\">\n              <div *ngIf=\"column.name; else noCustomName\">\n                <span *ngIf=\"column.translateHeader\" translate>{{column.name}}</span>\n                <span *ngIf=\"!column.translateHeader\">{{column.name}}</span>\n              </div>\n              <ng-template #noCustomName>\n                {{column.displayedProperty | titlecase}}\n              </ng-template>\n            </th>\n            <td mat-cell (click)=\"show($event, item.id)\" *matCellDef=\"let item\"  class=\"mr-2\" [ngClass]=\"{'clickable': showEvent.observed}\">\n              @if (processedData[item.id] && processedData[item.id][column.displayedProperty]() !== undefined) {\n                <span *ngIf=\"column.translate\" translate>{{ processedData[item.id][column.displayedProperty]() }}</span>\n                <span *ngIf=\"!column.translate\" [innerHTML]=\"processedData[item.id][column.displayedProperty]()\"></span>\n              }\n            </td>\n          </ng-container>\n        }\n      }\n\n      <ng-container matColumnDef=\"actions\">\n        <th mat-header-cell *matHeaderCellDef class=\"col-auto\">\n          <span>&nbsp;</span>\n        </th>\n        <td mat-cell *matCellDef=\"let item\"  class=\"col-auto\">\n          <!-- Primary Actions -->\n          @for (action of customActions(); track action; let i = $index) {\n            @if(action.primaryAction && customActionVisibilityMap[item.id][i]()) {\n              <button (click)=\"emitAction(action, item.id)\" class=\"btn btn-sm\" [ngClass]=\"customActionClassMap[item.id][i]\"\n                      [class.disabled]=\"!customActionActivationMap[item.id][i]()\"\n                      style=\"width: 130px\">{{customActionTextMap[item.id][i] | translate}}</button>\n            }\n          }\n          <!-- Icon Actions -->\n          @for (action of iconActions(); track action; let i = $index) {\n            @if (iconActionVisibilityMap[item.id]?.[i] && iconActionVisibilityMap[item.id][i]()) {\n              <button (click)=\"emitAction(action, item.id)\"\n                      class=\"btn btn-sm me-1 {{action.className}}\"\n                      data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"{{iconActionTextMap[item.id][i] | translate}}\"\n                      [class.disabled]=\"!iconActionActivationMap[item.id][i]()\">\n                    <span class=\"material-symbols-outlined\">{{action.icon}}</span>\n                    <span *ngIf=\"action.secondaryIcon\" class=\"material-symbols-outlined ms-1\">{{action.secondaryIcon}}</span>\n              </button>\n            }\n          }\n          @if (hasActivatedCustomNonPrimaryMap[item.id] && hasActivatedCustomNonPrimaryMap[item.id]()) {\n            <a href=\"#\" role=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" class=\"ms-2\">\n              <span class=\"material-symbols-outlined \">more_vert</span>\n            </a>\n            <ul class=\"dropdown-menu\">\n              <ng-container *ngFor=\"let action of customActions(); index as i\">\n                <ng-container *ngIf=\"!action.primaryAction && customActionVisibilityMap[item.id][i]()\">\n                  <li><a\n                    class=\"dropdown-item\"\n                    (click)=\"emitAction(action, item.id)\"\n                    translate\n                    [class.disabled]=\"!customActionActivationMap[item.id][i]()\"\n                  >{{customActionTextMap[item.id][i] | translate}}</a></li>\n                </ng-container>\n              </ng-container>\n            </ul>\n          }\n        </td>\n      </ng-container>\n\n      <tr mat-header-row *matHeaderRowDef=\"headerDef()\"></tr>\n\n      <tr mat-row *matRowDef=\"let row; columns: headerDef()\"></tr>\n    </table>\n\n    <mat-paginator [ngClass]=\"{'d-none': !showPagination}\" #paginator></mat-paginator>\n  </div>\n\n  <div *ngIf=\"dataSource.count === 0 && (!!dataSource.data || !(dataSource.loading | async))\" class=\"p-4 text-muted justify-content-center text-center align-content-center\">\n    <ng-content></ng-content>\n  </div>\n\n  <app-error [error]=\"error\"></app-error>\n\n</div>\n\n<ng-template #deleteModal>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\" translate>delete?</h4>\n    <button type=\"button\" class=\"btn-close\" (click)=\"modalRef?.hide()\" aria-label=\"Close\"></button>\n  </div>\n  <div class=\"modal-body\">\n    <p translate>delete_question</p>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"modalRef?.hide()\" translate>cancel</button>\n    <button type=\"button\" class=\"btn btn-danger\" (click)=\"delete()\" translate>delete</button>\n  </div>\n</ng-template>\n", styles: ["table{vertical-align:middle}table th{font-weight:700}table .mat-column-actions{text-align:end;width:1%;white-space:nowrap}@media (max-width: 576px){.buttons{width:100%;display:flex;justify-content:center;margin-bottom:1rem}.search{width:100%}}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i6.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i6.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i6.MatColumnDef, selector: "[matColumnDef]", inputs: ["matColumnDef"] }, { kind: "directive", type: i6.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i6.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i6.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i6.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i6.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i6.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "component", type: i7.MatPaginator, selector: "mat-paginator", inputs: ["color", "pageIndex", "length", "pageSize", "pageSizeOptions", "hidePageSize", "showFirstLastButtons", "selectConfig", "disabled"], outputs: ["page"], exportAs: ["matPaginator"] }, { kind: "directive", type: i8.MatSort, selector: "[matSort]", inputs: ["matSortActive", "matSortStart", "matSortDirection", "matSortDisableClear", "matSortDisabled"], outputs: ["matSortChange"], exportAs: ["matSort"] }, { kind: "component", type: i8.MatSortHeader, selector: "[mat-sort-header]", inputs: ["mat-sort-header", "arrowPosition", "start", "disabled", "sortActionDescription", "disableClear"], exportAs: ["matSortHeader"] }, { kind: "component", type: i1$2.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }, { kind: "directive", type: i10.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: ErrorComponent, selector: "app-error", inputs: ["error"] }, { kind: "pipe", type: i5.AsyncPipe, name: "async" }, { kind: "pipe", type: i5.TitleCasePipe, name: "titlecase" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DataTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-datatable', template: "<div class=\"mb-4 mt-2\">\n  <div class=\"buttons float-end\">\n    <button *ngIf=\"actionNew\" class=\"btn btn-nav\" (click)=\"new()\">\n      <span class=\"material-symbols-outlined\">\n        add_box\n      </span>\n      <span translate>\n        new\n      </span>\n    </button>\n\n    <button *ngFor=\"let action of customTableActions(); index as i\" class=\"btn btn-nav ms-3\"\n            (click)=\"action.action.emit()\" [ladda]=\"action.loading\" data-spinner-color=\"#000000\">\n      <span class=\"material-symbols-outlined\">\n      {{ action.icon }}\n      </span>\n      <span translate>\n        {{ customTableActionsText()[i] }}\n      </span>\n    </button>\n  </div>\n  <div [ngClass]=\"{'d-none': !searchEnabled}\" class=\"float-start search\">\n    <input class=\"form-control\" type=\"search\" placeholder=\"{{ 'search' | translate }}\" #input>\n  </div>\n  <div class=\"clearfix\"></div>\n</div>\n\n<div class=\"card\">\n  <div *ngIf=\"dataSource.loading | async\" style=\"position: absolute; left: calc(50% - 25px); top: 0.5rem;\">\n    <mat-spinner [diameter]=\"25\"></mat-spinner>\n  </div>\n  <div class=\"table-responsive\" [ngClass]=\"{'d-none': dataSource.count === 0}\">\n    <table mat-table [dataSource]=\"dataSource\" matSort [matSortActive]=\"sort.active\" [matSortDirection]=\"sort.direction\"\n           matSortDisableClear (window:resize)=\"checkWidth()\" class=\"overflow-auto table table-responsive table-striped table-hover\">\n      @for (column of actualDisplayedColumns(); track column.displayedProperty) {\n        @if (column.displayedProperty !== 'actions') {\n          <ng-container matColumnDef=\"{{column.displayedProperty}}\" *ngIf=\"column.sortable\">\n            <th mat-header-cell *matHeaderCellDef mat-sort-header class=\"mr-2\">\n              <div *ngIf=\"column.name; else noCustomName\">\n                <span *ngIf=\"column.translateHeader\" translate>{{column.name}}</span>\n                <span *ngIf=\"!column.translateHeader\">{{column.name}}</span>\n              </div>\n              <ng-template #noCustomName>\n                {{column.displayedProperty| titlecase}}\n              </ng-template>\n            </th>\n            <td mat-cell (click)=\"show($event, item.id)\" *matCellDef=\"let item\" class=\"mr-2\" [ngClass]=\"{'clickable': showEvent.observed}\">\n              @if (processedData[item.id] && processedData[item.id][column.displayedProperty]() !== undefined) {\n                <span *ngIf=\"column.translate\" translate>{{ processedData[item.id][column.displayedProperty]() }}</span>\n                <span *ngIf=\"!column.translate\" [innerHTML]=\"processedData[item.id][column.displayedProperty]()\"></span>\n              }\n            </td>\n          </ng-container>\n\n          <ng-container matColumnDef=\"{{column.displayedProperty}}\" *ngIf=\"!column.sortable\">\n            <th mat-header-cell *matHeaderCellDef  class=\"mr-2\">\n              <div *ngIf=\"column.name; else noCustomName\">\n                <span *ngIf=\"column.translateHeader\" translate>{{column.name}}</span>\n                <span *ngIf=\"!column.translateHeader\">{{column.name}}</span>\n              </div>\n              <ng-template #noCustomName>\n                {{column.displayedProperty | titlecase}}\n              </ng-template>\n            </th>\n            <td mat-cell (click)=\"show($event, item.id)\" *matCellDef=\"let item\"  class=\"mr-2\" [ngClass]=\"{'clickable': showEvent.observed}\">\n              @if (processedData[item.id] && processedData[item.id][column.displayedProperty]() !== undefined) {\n                <span *ngIf=\"column.translate\" translate>{{ processedData[item.id][column.displayedProperty]() }}</span>\n                <span *ngIf=\"!column.translate\" [innerHTML]=\"processedData[item.id][column.displayedProperty]()\"></span>\n              }\n            </td>\n          </ng-container>\n        }\n      }\n\n      <ng-container matColumnDef=\"actions\">\n        <th mat-header-cell *matHeaderCellDef class=\"col-auto\">\n          <span>&nbsp;</span>\n        </th>\n        <td mat-cell *matCellDef=\"let item\"  class=\"col-auto\">\n          <!-- Primary Actions -->\n          @for (action of customActions(); track action; let i = $index) {\n            @if(action.primaryAction && customActionVisibilityMap[item.id][i]()) {\n              <button (click)=\"emitAction(action, item.id)\" class=\"btn btn-sm\" [ngClass]=\"customActionClassMap[item.id][i]\"\n                      [class.disabled]=\"!customActionActivationMap[item.id][i]()\"\n                      style=\"width: 130px\">{{customActionTextMap[item.id][i] | translate}}</button>\n            }\n          }\n          <!-- Icon Actions -->\n          @for (action of iconActions(); track action; let i = $index) {\n            @if (iconActionVisibilityMap[item.id]?.[i] && iconActionVisibilityMap[item.id][i]()) {\n              <button (click)=\"emitAction(action, item.id)\"\n                      class=\"btn btn-sm me-1 {{action.className}}\"\n                      data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"{{iconActionTextMap[item.id][i] | translate}}\"\n                      [class.disabled]=\"!iconActionActivationMap[item.id][i]()\">\n                    <span class=\"material-symbols-outlined\">{{action.icon}}</span>\n                    <span *ngIf=\"action.secondaryIcon\" class=\"material-symbols-outlined ms-1\">{{action.secondaryIcon}}</span>\n              </button>\n            }\n          }\n          @if (hasActivatedCustomNonPrimaryMap[item.id] && hasActivatedCustomNonPrimaryMap[item.id]()) {\n            <a href=\"#\" role=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" class=\"ms-2\">\n              <span class=\"material-symbols-outlined \">more_vert</span>\n            </a>\n            <ul class=\"dropdown-menu\">\n              <ng-container *ngFor=\"let action of customActions(); index as i\">\n                <ng-container *ngIf=\"!action.primaryAction && customActionVisibilityMap[item.id][i]()\">\n                  <li><a\n                    class=\"dropdown-item\"\n                    (click)=\"emitAction(action, item.id)\"\n                    translate\n                    [class.disabled]=\"!customActionActivationMap[item.id][i]()\"\n                  >{{customActionTextMap[item.id][i] | translate}}</a></li>\n                </ng-container>\n              </ng-container>\n            </ul>\n          }\n        </td>\n      </ng-container>\n\n      <tr mat-header-row *matHeaderRowDef=\"headerDef()\"></tr>\n\n      <tr mat-row *matRowDef=\"let row; columns: headerDef()\"></tr>\n    </table>\n\n    <mat-paginator [ngClass]=\"{'d-none': !showPagination}\" #paginator></mat-paginator>\n  </div>\n\n  <div *ngIf=\"dataSource.count === 0 && (!!dataSource.data || !(dataSource.loading | async))\" class=\"p-4 text-muted justify-content-center text-center align-content-center\">\n    <ng-content></ng-content>\n  </div>\n\n  <app-error [error]=\"error\"></app-error>\n\n</div>\n\n<ng-template #deleteModal>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\" translate>delete?</h4>\n    <button type=\"button\" class=\"btn-close\" (click)=\"modalRef?.hide()\" aria-label=\"Close\"></button>\n  </div>\n  <div class=\"modal-body\">\n    <p translate>delete_question</p>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"modalRef?.hide()\" translate>cancel</button>\n    <button type=\"button\" class=\"btn btn-danger\" (click)=\"delete()\" translate>delete</button>\n  </div>\n</ng-template>\n", styles: ["table{vertical-align:middle}table th{font-weight:700}table .mat-column-actions{text-align:end;width:1%;white-space:nowrap}@media (max-width: 576px){.buttons{width:100%;display:flex;justify-content:center;margin-bottom:1rem}.search{width:100%}}\n"] }]
        }], ctorParameters: () => [{ type: i1$3.BsModalService }, { type: i1$1.Router }, { type: i1$1.ActivatedRoute }, { type: DataTableModuleConfiguration }, { type: LanguageService }], propDecorators: { dataSource: [{
                type: Input
            }], columns: [{
                type: Input
            }], identifier: [{
                type: Input
            }], actionNew: [{
                type: Input
            }], btnClass: [{
                type: Input
            }], loadOnInit: [{
                type: Input
            }], searchEnabled: [{
                type: Input
            }], showPagination: [{
                type: Input
            }], defaultPageSize: [{
                type: Input
            }], defaultSortName: [{
                type: Input
            }], defaultSortDirection: [{
                type: Input
            }], showEvent: [{
                type: Output
            }], newEvent: [{
                type: Output
            }], paginator: [{
                type: ViewChild,
                args: [MatPaginator, { static: true }]
            }], sort: [{
                type: ViewChild,
                args: [MatSort, { static: true }]
            }], input: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }], deleteModal: [{
                type: ViewChild,
                args: ['deleteModal', { static: true }]
            }] } });

marker('error.required');
marker('error.minlength');
marker('error.maxlength');
marker('error.min');
marker('error.max');
marker('error.pattern');
marker('error.not_matching');
marker('error.email');
marker('error.lostupdate');
class InputWithErrorComponent {
    constructor(translationService) {
        this.translationService = translationService;
        this.inputType = 'input';
        this.selectValues = [];
        this.type = 'text';
        this.description = '';
        this.selectDefaultIsDisabled = true;
        this.rows = '4';
        this.keyUpEvent = new EventEmitter();
    }
    keyUp($event) {
        this.keyUpEvent.emit($event);
    }
    getListOfErrors() {
        if (this.control.errors) {
            return Object.keys(this.control.errors).map((field) => this.getMessage(field, this.control.errors[field]));
        }
        return [];
    }
    getMessageWithParams(message, type, params) {
        switch (type) {
            case 'minlength':
            case 'maxlength':
                // eslint-disable-next-line @typescript-eslint/dot-notation
                return message + params['requiredLength'];
            case 'pattern':
                return message + params[`required${type}`];
            case 'min':
            case 'max':
                return message + params[type];
            default:
                return message;
        }
    }
    getMessage(type, params) {
        return this.getMessageWithParams(this.translationService.instant(`error.${type}`), type, params);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: InputWithErrorComponent, deps: [{ token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: InputWithErrorComponent, selector: "app-input-with-error", inputs: { control: "control", inputType: "inputType", selectValues: "selectValues", selectNames: "selectNames", type: "type", description: "description", selectDefaultText: "selectDefaultText", selectDefaultIsDisabled: "selectDefaultIsDisabled", helpText: "helpText", prependIcon: "prependIcon", rows: "rows" }, outputs: { keyUpEvent: "keyUpEvent" }, ngImport: i0, template: "<div class=\"input-group\">\n@if (prependIcon) {\n  <div class=\"input-group-prepend\">\n    <span class=\"input-group-text\">\n      <span class=\"material-symbols-outlined\">\n        {{ prependIcon }}\n      </span>\n    </span>\n  </div>\n}\n\n@if (inputType === 'input') {\n  <input (keyup)=\"keyUp($event)\" [type]=\"type\" [formControl]=\"control\" class=\"form-control\">\n}\n\n@if (inputType === 'date') {\n  <input (keyup)=\"keyUp($event)\" class=\"form-control\" bsDatepicker [bsConfig]=\"{ dateInputFormat: 'DD.MM.YYYY' }\"\n    [formControl]=\"control\">\n}\n\n@if (inputType === 'textarea') {\n  <textarea (keyup)=\"keyUp($event)\" [rows]=\"rows\" [formControl]=\"control\" class=\"form-control\"></textarea>\n}\n\n@if (inputType ==='checkbox') {\n  <div>\n    <input class=\"form-check-input\" type=\"checkbox\" [formControl]=\"control\">\n    @if (description !== undefined) {\n      <label class=\"ps-2 pe-2\">\n        {{ description | translate }}\n      </label>\n    }\n  </div>\n}\n\n@if (inputType === 'select') {\n  <select [formControl]=\"control\" class=\"form-select\">\n    @if (selectDefaultText && (!control.value || !selectDefaultIsDisabled)) {\n      <option [ngValue]=\"null\" [disabled]=\"selectDefaultIsDisabled\">{{selectDefaultText | translate}}</option>\n    }\n    @for (item of selectValues; track item; let i = $index) {\n      <option [value]=\"item\" translate>\n        {{selectNames ? selectNames[i] : selectValues[i]}}\n      </option>\n    }\n  </select>\n}\n\n@if (inputType === 'multi-select') {\n  <select multiple [formControl]=\"control\" class=\"form-select\">\n    @if (selectDefaultText && (!control.value || !selectDefaultIsDisabled)) {\n      <option [ngValue]=\"null\" [disabled]=\"selectDefaultIsDisabled\">{{selectDefaultText | translate}}</option>\n    }\n    @for (item of selectValues; track item; let i = $index) {\n      <option [value]=\"item\" translate>\n        {{selectNames ? selectNames[i] : selectValues[i]}}\n      </option>\n    }\n  </select>\n}\n\n<div class=\"invalid-feedback\" *ngIf=\"control.hasError\">\n  <ul>\n    @for (error of getListOfErrors(); track error) {\n      <li>{{error}}</li>\n    }\n  </ul>\n</div>\n</div>\n@if (helpText) {\n  <div class=\"form-text\" translate>{{helpText}}</div>\n}\n", dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i3.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i3.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i3.SelectMultipleControlValueAccessor, selector: "select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i4$2.BsDatepickerDirective, selector: "[bsDatepicker]", inputs: ["placement", "triggers", "outsideClick", "container", "outsideEsc", "isDisabled", "minDate", "maxDate", "ignoreMinMaxErrors", "minMode", "daysDisabled", "datesDisabled", "datesEnabled", "dateCustomClasses", "dateTooltipTexts", "isOpen", "bsValue", "bsConfig"], outputs: ["onShown", "onHidden", "bsValueChange"], exportAs: ["bsDatepicker"] }, { kind: "directive", type: i4$2.BsDatepickerInputDirective, selector: "input[bsDatepicker]" }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: InputWithErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-input-with-error', template: "<div class=\"input-group\">\n@if (prependIcon) {\n  <div class=\"input-group-prepend\">\n    <span class=\"input-group-text\">\n      <span class=\"material-symbols-outlined\">\n        {{ prependIcon }}\n      </span>\n    </span>\n  </div>\n}\n\n@if (inputType === 'input') {\n  <input (keyup)=\"keyUp($event)\" [type]=\"type\" [formControl]=\"control\" class=\"form-control\">\n}\n\n@if (inputType === 'date') {\n  <input (keyup)=\"keyUp($event)\" class=\"form-control\" bsDatepicker [bsConfig]=\"{ dateInputFormat: 'DD.MM.YYYY' }\"\n    [formControl]=\"control\">\n}\n\n@if (inputType === 'textarea') {\n  <textarea (keyup)=\"keyUp($event)\" [rows]=\"rows\" [formControl]=\"control\" class=\"form-control\"></textarea>\n}\n\n@if (inputType ==='checkbox') {\n  <div>\n    <input class=\"form-check-input\" type=\"checkbox\" [formControl]=\"control\">\n    @if (description !== undefined) {\n      <label class=\"ps-2 pe-2\">\n        {{ description | translate }}\n      </label>\n    }\n  </div>\n}\n\n@if (inputType === 'select') {\n  <select [formControl]=\"control\" class=\"form-select\">\n    @if (selectDefaultText && (!control.value || !selectDefaultIsDisabled)) {\n      <option [ngValue]=\"null\" [disabled]=\"selectDefaultIsDisabled\">{{selectDefaultText | translate}}</option>\n    }\n    @for (item of selectValues; track item; let i = $index) {\n      <option [value]=\"item\" translate>\n        {{selectNames ? selectNames[i] : selectValues[i]}}\n      </option>\n    }\n  </select>\n}\n\n@if (inputType === 'multi-select') {\n  <select multiple [formControl]=\"control\" class=\"form-select\">\n    @if (selectDefaultText && (!control.value || !selectDefaultIsDisabled)) {\n      <option [ngValue]=\"null\" [disabled]=\"selectDefaultIsDisabled\">{{selectDefaultText | translate}}</option>\n    }\n    @for (item of selectValues; track item; let i = $index) {\n      <option [value]=\"item\" translate>\n        {{selectNames ? selectNames[i] : selectValues[i]}}\n      </option>\n    }\n  </select>\n}\n\n<div class=\"invalid-feedback\" *ngIf=\"control.hasError\">\n  <ul>\n    @for (error of getListOfErrors(); track error) {\n      <li>{{error}}</li>\n    }\n  </ul>\n</div>\n</div>\n@if (helpText) {\n  <div class=\"form-text\" translate>{{helpText}}</div>\n}\n" }]
        }], ctorParameters: () => [{ type: i2.TranslateService }], propDecorators: { control: [{
                type: Input
            }], inputType: [{
                type: Input
            }], selectValues: [{
                type: Input
            }], selectNames: [{
                type: Input
            }], type: [{
                type: Input
            }], description: [{
                type: Input
            }], selectDefaultText: [{
                type: Input
            }], selectDefaultIsDisabled: [{
                type: Input
            }], helpText: [{
                type: Input
            }], prependIcon: [{
                type: Input
            }], rows: [{
                type: Input
            }], keyUpEvent: [{
                type: Output
            }] } });

marker('save');
marker('cancel');
marker('close');
marker('confirm_leave_page');
class AppModelModalComponent {
    constructor(modalService, renderer, translateService, document) {
        this.modalService = modalService;
        this.renderer = renderer;
        this.translateService = translateService;
        this.document = document;
        this.editable = false;
        this.loading = false;
        this.shakeTime = 820; // 0.82s is the default duration of our shake animation
        this.saveEvent = new EventEmitter();
        this.secondaryActionText = undefined;
        this.secondaryActionEnabled = true;
        this.secondaryAction = new EventEmitter();
        this.isSaveValid = false;
        this.shouldHide = false;
        this.shakeTimeout = undefined;
    }
    preventTabClose(event) {
        if (!this.canClose()) {
            // eslint-disable-next-line no-param-reassign
            event.returnValue = this.translateService.instant('confirm_leave_page');
            event.preventDefault();
        }
    }
    save() {
        this.saveEvent.emit();
    }
    show() {
        this.shouldHide = false;
        this.modalRef = this.modalService.show(this.modal, {
            class: 'modal-primary modal-lg',
            closeInterceptor: () => new Promise((resolve, reject) => {
                if (this.canClose()) {
                    resolve();
                }
                else {
                    reject();
                    if (!this.childForm?.form?.valid) {
                        // show all errors
                        this.save();
                    }
                    this.shakeModal();
                }
            }),
        });
        return this.modalRef;
    }
    hide() {
        if (this.modalRef) {
            this.shouldHide = true;
            this.modalRef.hide();
        }
    }
    canClose() {
        return this.shouldHide || !this.editable || this.childForm?.form?.pristine === true;
    }
    shakeModal() {
        const modalContent = this.document.querySelector('.modal-content');
        if (modalContent) {
            this.renderer.removeClass(modalContent, 'shake-animation');
            this.renderer.addClass(modalContent, 'shake-animation');
            // Remove the class after the animation duration to ensure it can be re-triggered later
            clearTimeout(this.shakeTimeout);
            this.shakeTimeout = setTimeout(() => {
                this.renderer.removeClass(modalContent, 'shake-animation');
            }, this.shakeTime);
        }
    }
    ngAfterViewInit() {
        if (this.childForm != null) {
            this.isSaveValid = this.childForm.form.valid;
            this.childForm.validityChange.subscribe((status) => {
                this.isSaveValid = status;
            });
            /* this.childForm.form.statusChanges.subscribe(() => {
              console.log('Status Changed', this.childForm.form.valid);
              this.isSaveValid = this.childForm.form.valid;
            }); */
        }
        else {
            this.isSaveValid = true;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AppModelModalComponent, deps: [{ token: i1$3.BsModalService }, { token: i0.Renderer2 }, { token: i2.TranslateService }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: AppModelModalComponent, selector: "app-model-modal", inputs: { title: "title", editable: "editable", loading: "loading", shakeTime: "shakeTime", secondaryActionText: "secondaryActionText", secondaryActionEnabled: "secondaryActionEnabled" }, outputs: { saveEvent: "saveEvent", secondaryAction: "secondaryAction" }, host: { listeners: { "window:beforeunload": "preventTabClose($event)" } }, queries: [{ propertyName: "childForm", first: true, predicate: ["form"], descendants: true }], viewQueries: [{ propertyName: "modal", first: true, predicate: ["modal"], descendants: true, static: true }], ngImport: i0, template: "<ng-template #modal>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\">{{title}}</h4>\n    <button type=\"button\" class=\"btn-close\" (click)=\"hide()\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n  </div>\n  <div class=\"modal-body\">\n    <ng-content></ng-content>\n  </div>\n  <div class=\"modal-footer\">\n    @if (secondaryActionText) {\n    <button [disabled]=\"!secondaryActionEnabled\" class=\"btn btn-warning me-auto\"\n      (click)=\"secondaryAction.emit()\" [ladda]=\"loading\">{{secondaryActionText | translate}}</button>\n    }\n    <button type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"hide()\">\n      @if (editable) {\n      <div translate>cancel</div>\n      } @else {\n      <div translate>close</div>\n      }\n    </button>\n    @if (editable) {\n    <button [disabled]=\"!isSaveValid\" type=\"button\" class=\"btn btn-secondary\" (click)=\"save()\" [ladda]=\"loading\"\n      translate=\"save\"></button>\n    }\n  </div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i10.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AppModelModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-model-modal', template: "<ng-template #modal>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\">{{title}}</h4>\n    <button type=\"button\" class=\"btn-close\" (click)=\"hide()\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n  </div>\n  <div class=\"modal-body\">\n    <ng-content></ng-content>\n  </div>\n  <div class=\"modal-footer\">\n    @if (secondaryActionText) {\n    <button [disabled]=\"!secondaryActionEnabled\" class=\"btn btn-warning me-auto\"\n      (click)=\"secondaryAction.emit()\" [ladda]=\"loading\">{{secondaryActionText | translate}}</button>\n    }\n    <button type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"hide()\">\n      @if (editable) {\n      <div translate>cancel</div>\n      } @else {\n      <div translate>close</div>\n      }\n    </button>\n    @if (editable) {\n    <button [disabled]=\"!isSaveValid\" type=\"button\" class=\"btn btn-secondary\" (click)=\"save()\" [ladda]=\"loading\"\n      translate=\"save\"></button>\n    }\n  </div>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: i1$3.BsModalService }, { type: i0.Renderer2 }, { type: i2.TranslateService }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { title: [{
                type: Input
            }], editable: [{
                type: Input
            }], loading: [{
                type: Input
            }], shakeTime: [{
                type: Input
            }], saveEvent: [{
                type: Output
            }], secondaryActionText: [{
                type: Input
            }], secondaryActionEnabled: [{
                type: Input
            }], secondaryAction: [{
                type: Output
            }], modal: [{
                type: ViewChild,
                args: ['modal', { static: true }]
            }], childForm: [{
                type: ContentChild,
                args: ['form', { static: false }]
            }], preventTabClose: [{
                type: HostListener,
                args: ['window:beforeunload', ['$event']]
            }] } });

class EmptyTableComponent {
    constructor() {
        this.icon = input.required();
        this.emptyText = input.required();
        this.buttonText = input();
        this.btnClick = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: EmptyTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: EmptyTableComponent, selector: "app-empty-table", inputs: { icon: { classPropertyName: "icon", publicName: "icon", isSignal: true, isRequired: true, transformFunction: null }, emptyText: { classPropertyName: "emptyText", publicName: "emptyText", isSignal: true, isRequired: true, transformFunction: null }, buttonText: { classPropertyName: "buttonText", publicName: "buttonText", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { btnClick: "btnClick" }, ngImport: i0, template: "<div class=\"justify-content-center text-center align-content-center\">\n  <span class=\"w-100 mt-4 d-flex align-items-center\">\n    <hr class=\"text-secondary flex-grow-1 wing-line\">\n    <span class=\" material-symbols-outlined text-secondary position-relative z-1 icon\">{{icon()}}</span>\n    <hr class=\"text-secondary flex-grow-1 wing-line\">\n  </span>\n  <h3>{{emptyText()}}</h3>\n  @if (buttonText()) {\n    <button class=\"btn btn-outline-secondary m-auto mt-3 mb-4\" (click)=\"btnClick.emit()\">{{buttonText()}}</button>\n  }\n</div>\n", styles: [".wing-line{border-top:2px solid;opacity:1}.icon{font-size:12rem;padding:0 2rem}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: EmptyTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-empty-table', template: "<div class=\"justify-content-center text-center align-content-center\">\n  <span class=\"w-100 mt-4 d-flex align-items-center\">\n    <hr class=\"text-secondary flex-grow-1 wing-line\">\n    <span class=\" material-symbols-outlined text-secondary position-relative z-1 icon\">{{icon()}}</span>\n    <hr class=\"text-secondary flex-grow-1 wing-line\">\n  </span>\n  <h3>{{emptyText()}}</h3>\n  @if (buttonText()) {\n    <button class=\"btn btn-outline-secondary m-auto mt-3 mb-4\" (click)=\"btnClick.emit()\">{{buttonText()}}</button>\n  }\n</div>\n", styles: [".wing-line{border-top:2px solid;opacity:1}.icon{font-size:12rem;padding:0 2rem}\n"] }]
        }], propDecorators: { btnClick: [{
                type: Output
            }] } });

class DataTableModule {
    static forRoot(configuration) {
        return {
            ngModule: DataTableModule,
            providers: [
                { provide: DataTableModuleConfiguration, useValue: configuration },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DataTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: DataTableModule, declarations: [DataTableComponent, AppModelModalComponent, InputWithErrorComponent, EmptyTableComponent], imports: [CommonModule,
            ReactiveFormsModule,
            MatInputModule,
            MatTableModule,
            MatPaginatorModule,
            MatSortModule,
            MatProgressSpinnerModule,
            BsDatepickerModule,
            MarkdownModule,
            LaddaModule,
            TranslateModule,
            ComponentsModule], exports: [DataTableComponent, AppModelModalComponent, InputWithErrorComponent, EmptyTableComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DataTableModule, imports: [CommonModule,
            ReactiveFormsModule,
            MatInputModule,
            MatTableModule,
            MatPaginatorModule,
            MatSortModule,
            MatProgressSpinnerModule,
            BsDatepickerModule,
            MarkdownModule,
            LaddaModule,
            TranslateModule,
            ComponentsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DataTableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        MatInputModule,
                        MatTableModule,
                        MatPaginatorModule,
                        MatSortModule,
                        MatProgressSpinnerModule,
                        BsDatepickerModule,
                        MarkdownModule,
                        LaddaModule,
                        TranslateModule,
                        ComponentsModule,
                    ],
                    declarations: [DataTableComponent, AppModelModalComponent, InputWithErrorComponent, EmptyTableComponent],
                    exports: [DataTableComponent, AppModelModalComponent, InputWithErrorComponent, EmptyTableComponent],
                }]
        }] });

class IconAction extends CustomAction {
    constructor(text, icon, isDelete = false, isActive, secondaryIcon, className = 'btn-outline-secondary') {
        super(text, false, isDelete, isActive);
        this.icon = icon;
        this.secondaryIcon = secondaryIcon;
        this.className = className;
    }
}

class NimmstaDataSource {
    constructor(dataService) {
        this.dataService = dataService;
        this.dataSubject = new BehaviorSubject([]);
        this.loadingSubject = new BehaviorSubject(true);
        this.loading = this.loadingSubject.asObservable();
        this.count = 0;
        this.data = undefined;
        this.defaultFilter = [];
    }
    connect(_) {
        return this.dataSubject.asObservable();
    }
    disconnect(_) {
        this.dataSubject.complete();
        this.loadingSubject.complete();
    }
    loadData(options = {}) {
        this.loadingSubject.next(true);
        return this.dataService.list({
            ...options,
            filter: options.filter?.concat(this.defaultFilter) || this.defaultFilter,
        }).pipe(finalize(() => {
            this.loadingSubject.next(false);
        }), tap((data) => {
            const transformedData = this.loadedDataTransform(data);
            if (transformedData !== undefined) {
                this.dataSubject.next(transformedData.content);
                this.count = transformedData.totalElements;
                this.data = transformedData;
            }
            else {
                this.dataSubject.next(data.content);
                this.count = data.totalElements;
                this.data = data;
            }
            this.loadingSubject.next(false);
        }));
    }
    // Overwrite this method to transform the loaded data in subclasses
    loadedDataTransform(data) {
        return data;
    }
}

/* eslint-disable max-classes-per-file */
class EnhancedFormControl extends FormControl {
}
class EnhancedFormArray extends FormArray {
    static create(controls) {
        return new EnhancedFormArray(controls);
    }
}
class EnhancedFormGroup extends FormGroup {
    static create(controls) {
        return new EnhancedFormGroup(controls);
    }
    getRawValue() {
        return super.getRawValue();
    }
}

class SaveableFormComponent {
    set editable(val) {
        this._editable = val;
        this.checkEnabled();
    }
    get editable() {
        return this._editable;
    }
    constructor(dataService) {
        this.dataService = dataService;
        this.closeEvent = new EventEmitter();
        this.loadingEvent = new EventEmitter();
        this.validityChange = new EventEmitter();
        this._editable = true;
    }
    onSave() {
        if (this.form.pristine && this.form.valid) {
            this.closeEvent.emit();
            return;
        }
        if (this.form.valid) {
            this.error = undefined;
            this.loadingEvent.emit(true);
            this.value = Object.assign(this.value, this.form.value);
            this.form.disable();
            this.applyCustomValues();
            this.dataService.createOrUpdate(this.value).subscribe({
                next: (value) => {
                    this.value = value;
                    this.closeEvent.emit();
                    this.form.enable();
                    this.form.markAsPristine();
                    this.loadingEvent.emit(false);
                },
                error: (response) => {
                    this.error = response;
                    this.form.enable();
                    this.loadingEvent.emit(false);
                },
            });
        }
        else {
            this.form.markAllAsTouched();
        }
    }
    applyCustomValues() { }
    setValue(value) {
        this.error = undefined;
        this.value = value;
        this.setFormGroup();
        this.checkEnabled();
        this.afterSetup();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.form.updateValueAndValidity(false, true);
        this.validityChange.emit(this.form.valid);
        Object.keys(this.form.controls).forEach((key) => {
            if (this.editable) {
                this.form.controls[key].enable();
            }
            else {
                this.form.controls[key].disable();
            }
        });
        // hack-fix: for some reason form.valid is not correctly set for a split second (even though the form is valid)
        // setTimeout(0) fixes this, but not sure why
        this.form.valueChanges.subscribe(() => {
            setTimeout(() => {
                this.validityChange.emit(this.form.valid);
            }, 0);
        });
    }
    checkEnabled() {
        if (this._editable) {
            this.form.enable();
        }
        else {
            this.form.disable();
        }
    }
    afterSetup() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SaveableFormComponent, deps: [{ token: AbstractDataService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: SaveableFormComponent, selector: "ng-component", inputs: { editable: "editable", value: "value" }, outputs: { closeEvent: "closeEvent", loadingEvent: "loadingEvent", validityChange: "validityChange" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SaveableFormComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                }]
        }], ctorParameters: () => [{ type: AbstractDataService }], propDecorators: { editable: [{
                type: Input
            }], value: [{
                type: Input
            }], closeEvent: [{
                type: Output
            }], loadingEvent: [{
                type: Output
            }], validityChange: [{
                type: Output
            }] } });

class AuthGuard extends KeycloakAuthGuard {
    constructor(router, keycloak) {
        super(router, keycloak);
        this.router = router;
        this.keycloak = keycloak;
    }
    async isAccessAllowed(route, state) {
        if (this.authenticated) {
            return Promise.resolve(true);
        }
        await this.keycloak.login({
            redirectUri: window.location.origin + state.url,
            prompt: 'login',
        });
        return new Promise(noop); // NEVER Promise, will never resolve
    }
    static isAdmin() {
        const auth = inject(AuthService);
        const router = inject(Router);
        const config = inject(NimmstaCommonsModuleConfiguration);
        if (auth === null || router === null || config === null) {
            return false;
        }
        return auth.getCurrentUser().pipe(map$1((user) => {
            if (user.role === UserRole.ADMIN) {
                return true;
            }
            else {
                if (config.applicationUrls.workflow) {
                    window.open(config.applicationUrls.workflow, '_self');
                }
                return false;
            }
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthGuard, deps: [{ token: i1$1.Router }, { token: i2$1.KeycloakService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$1.Router }, { type: i2$1.KeycloakService }] });

class AuthInterceptor {
    constructor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    intercept(req, next) {
        return next.handle(req).pipe(catchError((error) => {
            if (error.status === HttpStatusCode.Unauthorized) {
                // eslint-disable-next-line no-void
                void this.authService.logout(window.location.origin);
                return NEVER;
            }
            // If the user's organization has not been approved, redirect to the waiting list
            if (error.status === HttpStatusCode.PreconditionFailed
                && error.error.error === 'error.custom.user_or_org_not_verified') {
                this.router.navigate(['/waiting-list']);
                return NEVER;
            }
            // rethrow the error, we don't want to handle it here
            return throwError(() => error);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthInterceptor, deps: [{ token: AuthService }, { token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: AuthService }, { type: i1$1.Router }] });

class StatusInterceptor {
    constructor(router, offlineService, configuration) {
        this.router = router;
        this.offlineService = offlineService;
        this.configuration = configuration;
        this.urls = [];
        this.urls = [...Object.values(this.configuration.apiUrls), this.configuration.keycloakUrl];
    }
    intercept(req, next) {
        return next.handle(req).pipe(catchError((error) => {
            // Redirect to offline page if the server is not reachable
            if (error instanceof HttpErrorResponse
                && (this.containsUrl(error.url))
                && (!error.url?.includes('actuator/health'))
                && (error.status === 0
                    || error.status === HttpStatusCode.BadGateway
                    || error.status === HttpStatusCode.ServiceUnavailable
                    || error.status === HttpStatusCode.GatewayTimeout)
                && !this.router.url.includes('/offline')) {
                // // Close all modals (if any)
                // for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
                //   this.modalService.hide(i);
                // }
                // Mark Service as offline
                const findServerUrl = this.urls.find((url) => error.url?.includes(url));
                if (findServerUrl) {
                    this.offlineService.setOffline(findServerUrl);
                }
            }
            return throwError(() => error);
        }));
    }
    containsUrl(url) {
        if (!url) {
            return false;
        }
        return this.urls.some((u) => url.includes(u));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: StatusInterceptor, deps: [{ token: i1$1.Router }, { token: OfflineService }, { token: NimmstaCommonsModuleConfiguration }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: StatusInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: StatusInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.Router }, { type: OfflineService }, { type: NimmstaCommonsModuleConfiguration }] });

class BaseModel {
    constructor() {
        this.id = '';
        this.createdAt = undefined;
        this.lastUpdatedAt = undefined;
    }
}

var SoftwareStatus;
(function (SoftwareStatus) {
    SoftwareStatus["MAINTAINED"] = "MAINTAINED";
    SoftwareStatus["UNMAINTAINED"] = "UNMAINTAINED";
    SoftwareStatus["DEPRECATED"] = "DEPRECATED";
})(SoftwareStatus || (SoftwareStatus = {}));
var SoftwareVisibility;
(function (SoftwareVisibility) {
    SoftwareVisibility["INTERNAL"] = "INTERNAL";
    SoftwareVisibility["HIDDEN"] = "HIDDEN";
    SoftwareVisibility["PREVIEW"] = "PREVIEW";
    SoftwareVisibility["RELEASED"] = "RELEASED";
})(SoftwareVisibility || (SoftwareVisibility = {}));
class Software extends BaseModel {
    constructor() {
        super(...arguments);
        this.name = '';
        this.status = SoftwareStatus.MAINTAINED;
        this.visibility = SoftwareVisibility.INTERNAL;
        this.artifacts = [];
    }
}

var SoftwareArtifactStatus;
(function (SoftwareArtifactStatus) {
    SoftwareArtifactStatus["PREPARED"] = "PREPARED";
    SoftwareArtifactStatus["HIDDEN"] = "HIDDEN";
    SoftwareArtifactStatus["RELEASED"] = "RELEASED";
    SoftwareArtifactStatus["WITHDRAWN"] = "WITHDRAWN";
})(SoftwareArtifactStatus || (SoftwareArtifactStatus = {}));
class SoftwareArtifact extends BaseModel {
    constructor() {
        super(...arguments);
        this.status = SoftwareArtifactStatus.PREPARED;
        this.releaseDate = undefined;
        this.creationDate = undefined;
    }
}

class SoftwareLabel extends BaseModel {
}

class SoftwareArtifactReleaseType extends SoftwareLabel {
}

class SoftwarePlatform extends SoftwareLabel {
}

class SoftwareType extends SoftwareLabel {
}

var ContentVisibility;
(function (ContentVisibility) {
    ContentVisibility["FULL"] = "FULL";
    ContentVisibility["PARTIAL"] = "PARTIAL";
    ContentVisibility["NONE"] = "NONE";
})(ContentVisibility || (ContentVisibility = {}));
var ContentType;
(function (ContentType) {
    ContentType["FOLDER"] = "FOLDER";
    ContentType["PAGE"] = "PAGE";
})(ContentType || (ContentType = {}));
var ContentViewRoles;
(function (ContentViewRoles) {
    ContentViewRoles["ADMIN"] = "ADMIN";
    ContentViewRoles["MANAGER"] = "MANAGER";
    ContentViewRoles["PARTNER"] = "PARTNER";
    ContentViewRoles["CUSTOMER"] = "CUSTOMER";
})(ContentViewRoles || (ContentViewRoles = {}));
var PageType;
(function (PageType) {
    PageType["WYSIWYG"] = "WYSIWYG";
    PageType["HTML"] = "HTML";
})(PageType || (PageType = {}));

var DataConnectionStatus;
(function (DataConnectionStatus) {
    DataConnectionStatus["ACTIVE"] = "ACTIVE";
    DataConnectionStatus["INACTIVE"] = "INACTIVE";
})(DataConnectionStatus || (DataConnectionStatus = {}));
var DataConnectionType;
(function (DataConnectionType) {
    DataConnectionType["CSVDataConnection"] = "CSVDataConnection";
    DataConnectionType["WeclappDataConnection"] = "WeclappDataConnection";
    DataConnectionType["HttpDataConnection"] = "HttpDataConnection";
})(DataConnectionType || (DataConnectionType = {}));

var EndpointMethod;
(function (EndpointMethod) {
    EndpointMethod["GET"] = "GET";
    EndpointMethod["POST"] = "POST";
    EndpointMethod["PUT"] = "PUT";
    EndpointMethod["DELETE"] = "DELETE";
})(EndpointMethod || (EndpointMethod = {}));

var JobStatus;
(function (JobStatus) {
    JobStatus["OPEN"] = "OPEN";
    JobStatus["IN_PROGRESS"] = "IN_PROGRESS";
    JobStatus["COMPLETE"] = "COMPLETE";
    JobStatus["CANCELLED"] = "CANCELLED";
    JobStatus["DELETED"] = "DELETED";
})(JobStatus || (JobStatus = {}));

var LoadType;
(function (LoadType) {
    LoadType["ALL"] = "ALL";
    LoadType["ORGANIZATION"] = "ORGANIZATION";
})(LoadType || (LoadType = {}));

var OrganizationStatus;
(function (OrganizationStatus) {
    OrganizationStatus["ACTIVE"] = "ACTIVE";
    OrganizationStatus["INACTIVE"] = "INACTIVE";
})(OrganizationStatus || (OrganizationStatus = {}));
var OrganizationType;
(function (OrganizationType) {
    OrganizationType["CUSTOMER"] = "CUSTOMER";
    OrganizationType["PARTNER"] = "PARTNER";
})(OrganizationType || (OrganizationType = {}));
class Organization extends BaseModel {
    constructor() {
        super(...arguments);
        this.name = '';
        this.type = OrganizationType.CUSTOMER;
    }
}

class ParentOrganization {
    constructor() {
        this.id = '';
        this.name = '';
    }
}

var WorkerStatus;
(function (WorkerStatus) {
    WorkerStatus["ACTIVE"] = "ACTIVE";
    WorkerStatus["PAIRED"] = "PAIRED";
    WorkerStatus["NOT_PAIRED"] = "NOT_PAIRED";
})(WorkerStatus || (WorkerStatus = {}));

var WorkflowStatus;
(function (WorkflowStatus) {
    WorkflowStatus["INACTIVE"] = "INACTIVE";
    WorkflowStatus["ACTIVE"] = "ACTIVE";
})(WorkflowStatus || (WorkflowStatus = {}));

var RequestVerificationCodeType;
(function (RequestVerificationCodeType) {
    RequestVerificationCodeType["PASSWORD_OR_EMAIL_CHANGE"] = "PASSWORD_OR_EMAIL_CHANGE";
    RequestVerificationCodeType["ACCESS_REQUEST_EMAIL_VERIFICATION"] = "ACCESS_REQUEST_EMAIL_VERIFICATION";
})(RequestVerificationCodeType || (RequestVerificationCodeType = {}));

class UserService extends WorkflowDataService {
    get apiEndpoint() {
        return '/user';
    }
    constructor(http, configuration, authService, nimmstaConfiguration) {
        super(http, configuration);
        this.authService = authService;
        this.nimmstaConfiguration = nimmstaConfiguration;
    }
    getOrgApiEndpoint() {
        return this.authService.getCurrentUser().pipe(map$1((user) => `/organization/${user.organization.id}/user`));
    }
    list(options = {}) {
        const params = this.getParams(options);
        return this.getOrgApiEndpoint().pipe(switchMap((endpoint) => this.http.get(this.baseUrl + endpoint, { params })));
    }
    create(user) {
        const createUser = {
            firstName: user.given_name,
            lastName: user.family_name,
            email: user.email,
            role: user.role,
        };
        if (user.organizationId) {
            return this.http.post(`${this.baseUrl}/organization/${user.organizationId}/user`, createUser);
        }
        else {
            return this.getOrgApiEndpoint().pipe(switchMap((endpoint) => this.http.post(`${this.baseUrl + endpoint}`, createUser)));
        }
    }
    update(user) {
        const editUser = {
            firstName: user.given_name,
            lastName: user.family_name,
            email: user.email,
            organizationId: user.organization?.id,
            role: user.role,
        };
        return this.http.put(`${this.baseUrl + this.apiEndpoint}/${user.id}`, editUser);
    }
    updateProfile(user) {
        const profile = {
            firstName: user.given_name,
            lastName: user.family_name,
            email: user.email,
            ...((user.newPassword !== null)
                ? { newPassword: user.newPassword }
                : {}),
            ...((user.verificationCode !== null)
                ? { verificationCode: user.verificationCode }
                : {}),
        };
        return this.http.post(`${this.baseUrl + this.apiEndpoint}/update-profile`, profile);
    }
    verifyEmail(email, code) {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/verify-email`, {
            params: {
                email,
                code,
            },
        });
    }
    lock(user) {
        return this.http.post(`${this.baseUrl + this.apiEndpoint}/${user.id}/lock`, {});
    }
    unlock(user) {
        return this.http.post(`${this.baseUrl + this.apiEndpoint}/${user.id}/unlock`, {});
    }
    resetPassword(user) {
        return this.http.post(`${this.baseUrl + this.apiEndpoint}/${user.id}/reset-password`, {});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserService, deps: [{ token: i1.HttpClient }, { token: DataTableModuleConfiguration }, { token: AuthService }, { token: NimmstaCommonsModuleConfiguration }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: DataTableModuleConfiguration }, { type: AuthService }, { type: NimmstaCommonsModuleConfiguration }] });

class RequestVerificationService {
    get apiEndpoint() {
        return '/api/v1/request-verification';
    }
    constructor(http, configuration) {
        this.http = http;
        this.configuration = configuration;
        if (!this.configuration.apiUrls.workflow) {
            throw new Error('No workflow API URL configured');
        }
    }
    initiateRequestVerification(type) {
        return this.http.post(`${this.configuration.apiUrls.workflow + this.apiEndpoint}/initiate`, {}, { params: { type } });
    }
    initiateAnonymousRequestVerification(email, type) {
        return this.http.post(`${this.configuration.apiUrls.workflow + this.apiEndpoint}/anonymous/initiate`, {}, { params: { email, type } });
    }
    validate(type, code) {
        return this.http.post(`${this.configuration.apiUrls.workflow + this.apiEndpoint}/verify`, {}, { params: { type, code } });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RequestVerificationService, deps: [{ token: i1.HttpClient }, { token: DataTableModuleConfiguration }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RequestVerificationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RequestVerificationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: DataTableModuleConfiguration }] });

marker('profile.title');
class ProfileComponent {
    constructor(authService, userService, organizationService, requestVerificationService, fb) {
        this.authService = authService;
        this.userService = userService;
        this.organizationService = organizationService;
        this.requestVerificationService = requestVerificationService;
        this.fb = fb;
        this.edit = false;
        this.loading = false;
        this.verificationCodeRequested = false;
        this.verificationCodeRequestLoading = false;
        this.showApiKey = false;
        this.apiKeyCopied = undefined;
        this.isImpersonating = sessionStorage.getItem(IMPERSONATION_SESSION_STORAGE_KEY) !== null;
    }
    ngOnInit() {
        this.authService.getCurrentUser().subscribe((user) => {
            this.user = user;
            this.previousEmail = this.user.email;
            this.setFormGroup(this.user);
        });
        this.authService.getCredentials().subscribe((credentials) => {
            this.otpCredentials = credentials.filter((c) => c.type === 'otp').flatMap((c) => c.userCredentialMetadatas);
        });
        this.organizationService.getApiKey().subscribe((apiKey) => {
            this.apiKey = apiKey;
            this.maskedApiKey = apiKey.replace(/^(.{4}).+(.{4})$/, '$1****-****-****-****-********$2');
        });
        // Check if we have kc_action_status in the session storage
        const kcActionStatus = sessionStorage.getItem('kc_action_status');
        if (kcActionStatus !== null && kcActionStatus !== 'success') {
            // Remove the kc_action_status from the session storage
            sessionStorage.removeItem('kc_action_status');
            // Display the error message
            this.error = new HttpErrorResponse({
                status: 400,
                statusText: 'Bad Request',
                error: {
                    error: `error.custom.kc_action_status.${kcActionStatus}`,
                    error_description: kcActionStatus,
                },
            });
        }
    }
    setFormGroup(user) {
        this.form = this.fb.group({
            id: user.userId,
            email: [user.email, [Validators.email]],
            given_name: [user.given_name, [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
            family_name: [user.family_name, [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
            role: [user.role, [Validators.required]],
            verificationCode: [user.verificationCode, []],
            newPassword: [user.newPassword, []],
        });
    }
    editProfile() {
        this.edit = true;
    }
    cancelEdit() {
        this.edit = false;
        this.setFormGroup(this.user);
    }
    saveProfile() {
        if (this.form.valid) {
            this.error = undefined;
            this.loading = true;
            this.user = Object.assign(this.user, this.form.value);
            this.userService.updateProfile(this.user).subscribe({
                next: async (user) => {
                    this.edit = false;
                    this.loading = false;
                    this.user = user;
                    // If the email was changed, the user needs to login again (and verify the new email)
                    if (this.previousEmail !== this.user.email) {
                        await this.authService.logout();
                    }
                },
                error: (error) => {
                    this.loading = false;
                    this.error = error;
                },
            });
        }
        else {
            this.form.markAllAsTouched();
        }
    }
    add2FADevice() {
        this.authService.add2FADevice();
    }
    remove2FADevice(id) {
        this.authService.remove2FADevice(id);
    }
    requestVerificationCode() {
        this.error = undefined;
        this.verificationCodeRequestLoading = true;
        // Update validators for email and password
        this.form.controls['newPassword'].setValidators([Validators.minLength(8)].concat(AuthService.pwdValidators));
        this.form.controls['verificationCode'].setValidators([Validators.required]);
        this.form.controls['email'].setValidators([Validators.required, Validators.email]);
        // Request verification code
        this.requestVerificationService
            .initiateRequestVerification(RequestVerificationCodeType.PASSWORD_OR_EMAIL_CHANGE)
            .subscribe({
            next: () => {
                this.verificationCodeRequestLoading = false;
                this.verificationCodeRequested = true;
            },
            error: (error) => {
                this.verificationCodeRequestLoading = false;
                this.error = error;
            },
        });
    }
    get apiKeyCopyIcon() {
        if (this.apiKeyCopied?.success)
            return 'check';
        if (this.apiKeyCopied?.error)
            return 'close';
        return 'content_copy';
    }
    copyApiKey() {
        if (!this.apiKey) {
            return;
        }
        // Copies the API key to the clipboard
        navigator.clipboard.writeText(this.apiKey).then(() => {
            this.apiKeyCopied = { success: true };
            setTimeout(() => {
                this.apiKeyCopied = undefined;
            }, 2000);
        }).catch(() => {
            this.apiKeyCopied = { error: true };
            setTimeout(() => {
                this.apiKeyCopied = undefined;
            }, 2000);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ProfileComponent, deps: [{ token: AuthService }, { token: UserService }, { token: OrganizationService }, { token: RequestVerificationService }, { token: i3.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: ProfileComponent, selector: "app-profile", ngImport: i0, template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'profile'\"></app-header-bar>\n  </div>\n  <div class=\"box-row content mt-2\">\n    <div class=\"container\">\n      <app-error [error]=\"error\"></app-error>\n      @if (user && !edit) {\n        <div class=\"row\">\n          <div class=\"col-md-6\">\n            <div class=\"card mb-3\">\n              <div class=\"card-body\">\n                <div class=\"d-flex justify-content-between align-items-center\">\n                  <h5 class=\"card-title fw-bold\">Profile Information</h5>\n                  @if (!isImpersonating) {\n                    <button class=\"btn btn-primary\" (click)=\"editProfile()\" translate>\n                      <span class=\"material-symbols-outlined\">\n                        edit_note\n                      </span>\n                    </button>\n                  }\n                </div>\n                <div class=\"form-group mb-3\">\n                  <label class=\"fw-bold\" translate>user.email</label>\n                  <p>{{user.email}}</p>\n                </div>\n                <div class=\"form-group mb-3\">\n                  <label class=\"fw-bold\" translate>user.given_name</label>\n                  <p>{{user.given_name}}</p>\n                </div>\n                <div class=\"form-group mb-3\">\n                  <label class=\"fw-bold\" translate>user.family_name</label>\n                  <p>{{user.family_name}}</p>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"card\">\n              <div class=\"card-body\">\n                <h5 class=\"card-title fw-bold\" translate>user.2fa_devices</h5>\n                <div class=\"list-group mt-3\">\n                  @if ((otpCredentials?.length || 0) > 0) {\n                    @for (device of otpCredentials; track device.credential.id) {\n                      <div class=\"list-group-item d-flex justify-content-between align-items-center\">\n                        <div>\n                          <p class=\"mb-0 fw-bold\">{{ device.credential.userLabel }}</p>\n                          <small class=\"text-muted\"><span translate>job.createdAt</span>: {{ device.credential.createdDate | dateTime }}</small>\n                        </div>\n                      </div>\n                    }\n                  } @else {\n                    <p class=\"text-muted\" translate>user.no_2fa_devices</p>\n                  }\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"col-md-6\">\n            <div class=\"card mb-3\">\n              <div class=\"card-body\">\n                <h5 class=\"card-title fw-bold\">Organization & Role</h5>\n                <div class=\"form-group mb-3\">\n                  <label class=\"fw-bold\" translate>organization</label>\n                  @if (user.organization) {\n                    <p>{{user.organization.name}}</p>\n                  }\n                  @if (!user.organization) {\n                    <p class=\"text-muted\" translate>user.no_organization</p>\n                  }\n                </div>\n                <div class=\"form-group mb-3\">\n                  <label class=\"fw-bold\" translate>user.role</label>\n                  <p>{{user.role | titlecase }}</p>\n                </div>\n                <div class=\"form-group mb-3\">\n                  <label class=\"fw-bold\" translate>user.date</label>\n                  <p>{{user.created_at | dateTime }}</p>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"card shadow-sm border-0\">\n              <div class=\"card-body\">\n                <h5 class=\"card-title fw-bold\" translate>organizations.api_key</h5>\n                <p class=\"card-text text-muted\" translate>organizations.api_key_description</p>\n                <div class=\"input-group\">\n                  <div class=\"form-control bg-light text-dark border-0 text-monospace d-flex align-items-center\">\n                    <span id=\"apiKey\" class=\"flex-grow-1\">\n                      {{ showApiKey ? apiKey : maskedApiKey }}\n                    </span>\n\n                    <button *ngIf=\"showApiKey && apiKey\" class=\"btn border-0 ms-2\" type=\"button\" [disabled]=\"apiKeyCopied?.success || apiKeyCopied?.error\" (click)=\"copyApiKey()\"\n                      [ngClass]=\"{\n                        'btn-outline-primary': !apiKeyCopied,\n                        'btn-outline-success': apiKeyCopied?.success,\n                        'btn-outline-danger': apiKeyCopied?.error\n                      }\"\n                    >\n                      <span class=\"material-icons-outlined\">{{ apiKeyCopyIcon }}</span>\n                    </button>\n\n                    <button class=\"btn btn-outline-primary border-0\" type=\"button\" (click)=\"showApiKey = !showApiKey\">\n                      <span class=\"material-icons-outlined\">\n                        {{ showApiKey ? 'visibility_off' : 'visibility' }}\n                      </span>\n                    </button>\n\n                    <!-- <button class=\"btn btn-outline-primary border-0 ms-2\" type=\"button\" (click)=\"rotateApiKey()\">\n                      <span class=\"material-icons-outlined\">autorenew</span>\n                    </button> -->\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      }\n      @if (user && form && edit) {\n        <form [formGroup]=\"form\">\n          <div class=\"row\">\n            <div class=\"col-md-6\">\n              <div class=\"card mb-3\">\n                <div class=\"card-body\">\n                  <h5 class=\"card-title fw-bold\" translate>user.personal_information</h5>\n                  <label class=\"mt-3\" translate>user.given_name</label>\n                  <app-input-with-error [control]=\"this.form.controls['given_name']\"></app-input-with-error>\n                  <label class=\"mt-3\" translate>user.family_name</label>\n                  <app-input-with-error [control]=\"this.form.controls['family_name']\"></app-input-with-error>\n                </div>\n              </div>\n\n              <div class=\"card mb-3\">\n                <div class=\"card-body\">\n                  <h5 class=\"card-title fw-bold\" translate>user.configure_2fa</h5>\n                  <p class=\"card-text text-muted\" translate>user.configure_2fa_info</p>\n                  <div class=\"list-group mt-3\">\n                    @for (device of otpCredentials; track device.credential.id) {\n                      <div class=\"list-group-item d-flex justify-content-between align-items-center\">\n                        <div>\n                          <p class=\"mb-0 fw-bold\">{{ device.credential.userLabel }}</p>\n                          <small class=\"text-muted\"><span translate>job.createdAt</span>: {{ device.credential.createdDate | dateTime }}</small>\n                        </div>\n                        <button class=\"btn btn-danger\" (click)=\"remove2FADevice(device.credential.id)\">\n                          <span class=\"material-icons-outlined\">delete</span>\n                        </button>\n                      </div>\n                    }\n                  </div>\n                  <div class=\"mt-3\">\n                    <button class=\"btn btn-primary\" (click)=\"add2FADevice()\">\n                      <span translate>user.configure_2fa_add_button</span>\n                    </button>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"col-md-6\">\n              <div class=\"card mb-3\">\n                <div class=\"card-body\">\n                  <h5 class=\"card-title fw-bold\" translate>user.change_password_or_mail</h5>\n                  @if (!verificationCodeRequested) {\n                    <div>\n                      <p class=\"card-text text-muted\" translate>user.change_password_verify</p>\n                      <button class=\"btn btn-primary\" (click)=\"requestVerificationCode()\" [ladda]=\"verificationCodeRequestLoading\">\n                        <span translate>user.change_password_verify_button</span>\n                      </button>\n                    </div>\n                  }\n                  @if (verificationCodeRequested) {\n                    <div>\n                      <p class=\"card-text text-muted\" translate>user.enter_verification_code_and_password</p>\n                      <label translate>user.verification_code</label>\n                      <app-input-with-error [control]=\"this.form.controls['verificationCode']\"></app-input-with-error>\n                      <label class=\"mt-3\" translate>user.new_password</label>\n                      <label class=\"form-text ms-1\">(optional)</label>\n                      <app-input-with-error [control]=\"this.form.controls['newPassword']\" [type]=\"'password'\"></app-input-with-error>\n                      <label translate>user.email</label>\n                      <app-input-with-error [control]=\"this.form.controls['email']\"></app-input-with-error>\n                    </div>\n                  }\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"d-flex justify-content-end mt-2\">\n            <button class=\"btn btn-outline-primary me-2\" (click)=\"cancelEdit()\" translate=\"cancel\"></button>\n            <button class=\"btn btn-primary\" (click)=\"saveProfile()\" translate=\"save\" [ladda]=\"loading\"></button>\n          </div>\n        </form>\n      }\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: InputWithErrorComponent, selector: "app-input-with-error", inputs: ["control", "inputType", "selectValues", "selectNames", "type", "description", "selectDefaultText", "selectDefaultIsDisabled", "helpText", "prependIcon", "rows"], outputs: ["keyUpEvent"] }, { kind: "component", type: HeaderBarComponent, selector: "app-header-bar", inputs: ["title", "backRoute", "showDefaultBackButton", "date"] }, { kind: "component", type: ErrorComponent, selector: "app-error", inputs: ["error"] }, { kind: "directive", type: i10.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "pipe", type: i5.TitleCasePipe, name: "titlecase" }, { kind: "pipe", type: DateTimePipe, name: "dateTime" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ProfileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-profile', template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'profile'\"></app-header-bar>\n  </div>\n  <div class=\"box-row content mt-2\">\n    <div class=\"container\">\n      <app-error [error]=\"error\"></app-error>\n      @if (user && !edit) {\n        <div class=\"row\">\n          <div class=\"col-md-6\">\n            <div class=\"card mb-3\">\n              <div class=\"card-body\">\n                <div class=\"d-flex justify-content-between align-items-center\">\n                  <h5 class=\"card-title fw-bold\">Profile Information</h5>\n                  @if (!isImpersonating) {\n                    <button class=\"btn btn-primary\" (click)=\"editProfile()\" translate>\n                      <span class=\"material-symbols-outlined\">\n                        edit_note\n                      </span>\n                    </button>\n                  }\n                </div>\n                <div class=\"form-group mb-3\">\n                  <label class=\"fw-bold\" translate>user.email</label>\n                  <p>{{user.email}}</p>\n                </div>\n                <div class=\"form-group mb-3\">\n                  <label class=\"fw-bold\" translate>user.given_name</label>\n                  <p>{{user.given_name}}</p>\n                </div>\n                <div class=\"form-group mb-3\">\n                  <label class=\"fw-bold\" translate>user.family_name</label>\n                  <p>{{user.family_name}}</p>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"card\">\n              <div class=\"card-body\">\n                <h5 class=\"card-title fw-bold\" translate>user.2fa_devices</h5>\n                <div class=\"list-group mt-3\">\n                  @if ((otpCredentials?.length || 0) > 0) {\n                    @for (device of otpCredentials; track device.credential.id) {\n                      <div class=\"list-group-item d-flex justify-content-between align-items-center\">\n                        <div>\n                          <p class=\"mb-0 fw-bold\">{{ device.credential.userLabel }}</p>\n                          <small class=\"text-muted\"><span translate>job.createdAt</span>: {{ device.credential.createdDate | dateTime }}</small>\n                        </div>\n                      </div>\n                    }\n                  } @else {\n                    <p class=\"text-muted\" translate>user.no_2fa_devices</p>\n                  }\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"col-md-6\">\n            <div class=\"card mb-3\">\n              <div class=\"card-body\">\n                <h5 class=\"card-title fw-bold\">Organization & Role</h5>\n                <div class=\"form-group mb-3\">\n                  <label class=\"fw-bold\" translate>organization</label>\n                  @if (user.organization) {\n                    <p>{{user.organization.name}}</p>\n                  }\n                  @if (!user.organization) {\n                    <p class=\"text-muted\" translate>user.no_organization</p>\n                  }\n                </div>\n                <div class=\"form-group mb-3\">\n                  <label class=\"fw-bold\" translate>user.role</label>\n                  <p>{{user.role | titlecase }}</p>\n                </div>\n                <div class=\"form-group mb-3\">\n                  <label class=\"fw-bold\" translate>user.date</label>\n                  <p>{{user.created_at | dateTime }}</p>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"card shadow-sm border-0\">\n              <div class=\"card-body\">\n                <h5 class=\"card-title fw-bold\" translate>organizations.api_key</h5>\n                <p class=\"card-text text-muted\" translate>organizations.api_key_description</p>\n                <div class=\"input-group\">\n                  <div class=\"form-control bg-light text-dark border-0 text-monospace d-flex align-items-center\">\n                    <span id=\"apiKey\" class=\"flex-grow-1\">\n                      {{ showApiKey ? apiKey : maskedApiKey }}\n                    </span>\n\n                    <button *ngIf=\"showApiKey && apiKey\" class=\"btn border-0 ms-2\" type=\"button\" [disabled]=\"apiKeyCopied?.success || apiKeyCopied?.error\" (click)=\"copyApiKey()\"\n                      [ngClass]=\"{\n                        'btn-outline-primary': !apiKeyCopied,\n                        'btn-outline-success': apiKeyCopied?.success,\n                        'btn-outline-danger': apiKeyCopied?.error\n                      }\"\n                    >\n                      <span class=\"material-icons-outlined\">{{ apiKeyCopyIcon }}</span>\n                    </button>\n\n                    <button class=\"btn btn-outline-primary border-0\" type=\"button\" (click)=\"showApiKey = !showApiKey\">\n                      <span class=\"material-icons-outlined\">\n                        {{ showApiKey ? 'visibility_off' : 'visibility' }}\n                      </span>\n                    </button>\n\n                    <!-- <button class=\"btn btn-outline-primary border-0 ms-2\" type=\"button\" (click)=\"rotateApiKey()\">\n                      <span class=\"material-icons-outlined\">autorenew</span>\n                    </button> -->\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      }\n      @if (user && form && edit) {\n        <form [formGroup]=\"form\">\n          <div class=\"row\">\n            <div class=\"col-md-6\">\n              <div class=\"card mb-3\">\n                <div class=\"card-body\">\n                  <h5 class=\"card-title fw-bold\" translate>user.personal_information</h5>\n                  <label class=\"mt-3\" translate>user.given_name</label>\n                  <app-input-with-error [control]=\"this.form.controls['given_name']\"></app-input-with-error>\n                  <label class=\"mt-3\" translate>user.family_name</label>\n                  <app-input-with-error [control]=\"this.form.controls['family_name']\"></app-input-with-error>\n                </div>\n              </div>\n\n              <div class=\"card mb-3\">\n                <div class=\"card-body\">\n                  <h5 class=\"card-title fw-bold\" translate>user.configure_2fa</h5>\n                  <p class=\"card-text text-muted\" translate>user.configure_2fa_info</p>\n                  <div class=\"list-group mt-3\">\n                    @for (device of otpCredentials; track device.credential.id) {\n                      <div class=\"list-group-item d-flex justify-content-between align-items-center\">\n                        <div>\n                          <p class=\"mb-0 fw-bold\">{{ device.credential.userLabel }}</p>\n                          <small class=\"text-muted\"><span translate>job.createdAt</span>: {{ device.credential.createdDate | dateTime }}</small>\n                        </div>\n                        <button class=\"btn btn-danger\" (click)=\"remove2FADevice(device.credential.id)\">\n                          <span class=\"material-icons-outlined\">delete</span>\n                        </button>\n                      </div>\n                    }\n                  </div>\n                  <div class=\"mt-3\">\n                    <button class=\"btn btn-primary\" (click)=\"add2FADevice()\">\n                      <span translate>user.configure_2fa_add_button</span>\n                    </button>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"col-md-6\">\n              <div class=\"card mb-3\">\n                <div class=\"card-body\">\n                  <h5 class=\"card-title fw-bold\" translate>user.change_password_or_mail</h5>\n                  @if (!verificationCodeRequested) {\n                    <div>\n                      <p class=\"card-text text-muted\" translate>user.change_password_verify</p>\n                      <button class=\"btn btn-primary\" (click)=\"requestVerificationCode()\" [ladda]=\"verificationCodeRequestLoading\">\n                        <span translate>user.change_password_verify_button</span>\n                      </button>\n                    </div>\n                  }\n                  @if (verificationCodeRequested) {\n                    <div>\n                      <p class=\"card-text text-muted\" translate>user.enter_verification_code_and_password</p>\n                      <label translate>user.verification_code</label>\n                      <app-input-with-error [control]=\"this.form.controls['verificationCode']\"></app-input-with-error>\n                      <label class=\"mt-3\" translate>user.new_password</label>\n                      <label class=\"form-text ms-1\">(optional)</label>\n                      <app-input-with-error [control]=\"this.form.controls['newPassword']\" [type]=\"'password'\"></app-input-with-error>\n                      <label translate>user.email</label>\n                      <app-input-with-error [control]=\"this.form.controls['email']\"></app-input-with-error>\n                    </div>\n                  }\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"d-flex justify-content-end mt-2\">\n            <button class=\"btn btn-outline-primary me-2\" (click)=\"cancelEdit()\" translate=\"cancel\"></button>\n            <button class=\"btn btn-primary\" (click)=\"saveProfile()\" translate=\"save\" [ladda]=\"loading\"></button>\n          </div>\n        </form>\n      }\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: AuthService }, { type: UserService }, { type: OrganizationService }, { type: RequestVerificationService }, { type: i3.FormBuilder }] });

marker('profile-session.title');
class ProfileSessionComponent {
    constructor(sessionService, authService, router, configuration) {
        this.sessionService = sessionService;
        this.authService = authService;
        this.router = router;
        this.configuration = configuration;
        this.isLoading = true;
        this.isImpersonating = sessionStorage.getItem(IMPERSONATION_SESSION_STORAGE_KEY) !== null;
    }
    ngOnInit() {
        this.loadDevices();
    }
    loadDevices() {
        this.isLoading = true;
        this.sessionService.getActiveDevices().subscribe({
            next: (devices) => {
                this.isLoading = false;
                this.devices = devices;
            },
            error: (error) => {
                this.isLoading = false;
                this.error = error;
            },
        });
    }
    deviceSessions(device) {
        // Show only sessions for the platform client
        const sessions = device.sessions.filter((session) => session.clients.some((client) => client.clientId === this.configuration.keycloakClientId));
        // Move the current session to the front of the list
        const currentSession = sessions.find((session) => session.current);
        if (currentSession) {
            sessions.splice(sessions.indexOf(currentSession), 1);
            sessions.unshift(currentSession);
        }
        return sessions;
    }
    terminateSession(session) {
        if (this.isImpersonating) {
            return;
        }
        this.sessionService.terminate(session.id).subscribe({
            next: () => {
                if (session.current) {
                    this.devices = undefined;
                    return this.authService.logout(this.router.url.split('?')[0]);
                }
                this.loadDevices();
                return Promise.resolve();
            },
            error: (error) => {
                this.error = error;
            },
        });
    }
    terminateAllSessions() {
        if (this.isImpersonating) {
            return;
        }
        this.sessionService.terminateAll().subscribe({
            next: () => {
                this.authService.logout(window.location.origin);
            },
            error: (error) => {
                this.error = error;
            },
        });
    }
    clientNames(session) {
        return session.clients.map((client) => client.clientId).join(', ');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ProfileSessionComponent, deps: [{ token: KeycloakSessionService }, { token: AuthService }, { token: i1$1.Router }, { token: NimmstaCommonsModuleConfiguration }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: ProfileSessionComponent, selector: "app-profile-session", ngImport: i0, template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'profile-session.title'\"></app-header-bar>\n  </div>\n  <div class=\"content mt-2 mb-3 pt-3\">\n    <app-loading-indicator [loading]=\"isLoading\"></app-loading-indicator>\n    <app-error [error]=\"error\"></app-error>\n    <div class=\"row\" *ngIf=\"!isLoading\">\n      <div class=\"d-flex justify-content-end\" *ngIf=\"!isImpersonating\">\n        <button class=\"btn btn-danger btn-sm mb-3\" (click)=\"terminateAllSessions()\" translate>\n          profile-session.revoke-all\n        </button>\n      </div>\n      @for (device of devices; track device) {\n        <div>\n          @for (session of deviceSessions(device); track session.id) {\n            <div class=\"card mb-3\">\n              <div class=\"card-body\">\n                <div class=\"d-flex justify-content-between\">\n                  <h6 class=\"card-title fw-bold\">\n                    {{ device.os }} {{ device.osVersion }} - {{ session.browser }}\n                    @if (session.current) {\n                      <span class=\"badge rounded-pill badge-outline bg-secondary ms-2\" translate>\n                        profile-session.current-session\n                      </span>\n                    }\n                  </h6>\n                  @if (!session.current && !isImpersonating) {\n                    <button class=\"btn btn-sm btn-outline-secondary mb-3\" style=\"margin-top: -0.5rem;\"\n                      (click)=\"terminateSession(session)\" translate>\n                      profile-session.revoke\n                    </button>\n                  }\n                </div>\n                <div class=\"row mt-2\">\n                  <div class=\"col-md-6\">\n                    <h6 class=\"fw-bold\" translate>profile-session.ip</h6>\n                    <p class=\"card-text\">{{ session.ipAddress }}</p>\n                    <h6 class=\"fw-bold\" translate>profile-session.last-activity</h6>\n                    <p class=\"card-text\" [innerHTML]=\"session.lastAccess | timeAgo\"></p>\n                  </div>\n                  <div class=\"col-md-6\">\n                    <h6 class=\"fw-bold\" translate>profile-session.started</h6>\n                    <p class=\"card-text\">{{ session.started | dateTime }}</p>\n                    <h6 class=\"fw-bold\" translate>profile-session.expires</h6>\n                    <p class=\"card-text\">{{ session.expires | dateTime }}</p>\n                  </div>\n                </div>\n              </div>\n            </div>\n          }\n        </div>\n      }\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: HeaderBarComponent, selector: "app-header-bar", inputs: ["title", "backRoute", "showDefaultBackButton", "date"] }, { kind: "component", type: LoadingIndicatorComponent, selector: "app-loading-indicator", inputs: ["loading"] }, { kind: "component", type: ErrorComponent, selector: "app-error", inputs: ["error"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "pipe", type: DateTimePipe, name: "dateTime" }, { kind: "pipe", type: NimmstaTimeAgoPipe, name: "timeAgo" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ProfileSessionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-profile-session', template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'profile-session.title'\"></app-header-bar>\n  </div>\n  <div class=\"content mt-2 mb-3 pt-3\">\n    <app-loading-indicator [loading]=\"isLoading\"></app-loading-indicator>\n    <app-error [error]=\"error\"></app-error>\n    <div class=\"row\" *ngIf=\"!isLoading\">\n      <div class=\"d-flex justify-content-end\" *ngIf=\"!isImpersonating\">\n        <button class=\"btn btn-danger btn-sm mb-3\" (click)=\"terminateAllSessions()\" translate>\n          profile-session.revoke-all\n        </button>\n      </div>\n      @for (device of devices; track device) {\n        <div>\n          @for (session of deviceSessions(device); track session.id) {\n            <div class=\"card mb-3\">\n              <div class=\"card-body\">\n                <div class=\"d-flex justify-content-between\">\n                  <h6 class=\"card-title fw-bold\">\n                    {{ device.os }} {{ device.osVersion }} - {{ session.browser }}\n                    @if (session.current) {\n                      <span class=\"badge rounded-pill badge-outline bg-secondary ms-2\" translate>\n                        profile-session.current-session\n                      </span>\n                    }\n                  </h6>\n                  @if (!session.current && !isImpersonating) {\n                    <button class=\"btn btn-sm btn-outline-secondary mb-3\" style=\"margin-top: -0.5rem;\"\n                      (click)=\"terminateSession(session)\" translate>\n                      profile-session.revoke\n                    </button>\n                  }\n                </div>\n                <div class=\"row mt-2\">\n                  <div class=\"col-md-6\">\n                    <h6 class=\"fw-bold\" translate>profile-session.ip</h6>\n                    <p class=\"card-text\">{{ session.ipAddress }}</p>\n                    <h6 class=\"fw-bold\" translate>profile-session.last-activity</h6>\n                    <p class=\"card-text\" [innerHTML]=\"session.lastAccess | timeAgo\"></p>\n                  </div>\n                  <div class=\"col-md-6\">\n                    <h6 class=\"fw-bold\" translate>profile-session.started</h6>\n                    <p class=\"card-text\">{{ session.started | dateTime }}</p>\n                    <h6 class=\"fw-bold\" translate>profile-session.expires</h6>\n                    <p class=\"card-text\">{{ session.expires | dateTime }}</p>\n                  </div>\n                </div>\n              </div>\n            </div>\n          }\n        </div>\n      }\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: KeycloakSessionService }, { type: AuthService }, { type: i1$1.Router }, { type: NimmstaCommonsModuleConfiguration }] });

class ProfileModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ProfileModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: ProfileModule, declarations: [ProfileComponent,
            ProfileSessionComponent], imports: [CommonModule,
            ReactiveFormsModule,
            DataTableModule,
            ComponentsModule,
            LaddaModule,
            TranslateModule,
            BasicCommonsModule], exports: [ProfileComponent,
            ProfileSessionComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ProfileModule, imports: [CommonModule,
            ReactiveFormsModule,
            DataTableModule,
            ComponentsModule,
            LaddaModule,
            TranslateModule,
            BasicCommonsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ProfileModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        DataTableModule,
                        ComponentsModule,
                        LaddaModule,
                        TranslateModule,
                        BasicCommonsModule,
                    ],
                    declarations: [
                        ProfileComponent,
                        ProfileSessionComponent,
                    ],
                    exports: [
                        ProfileComponent,
                        ProfileSessionComponent,
                    ],
                }]
        }] });

class SoftwareService extends WorkflowDataService {
    get apiEndpoint() {
        return '/software';
    }
    getLatestPublicDownloadLink(id) {
        return this.http.get(`${this.apiEndpoint}/${id}/latest-download`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SoftwareService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SoftwareService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SoftwareService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class VersionService {
    constructor(http) {
        this.http = http;
    }
    setBaseURL(baseUrl) {
        this.url = `${baseUrl}/info/version`;
    }
    getBackendVersion() {
        if (this.url) {
            return this.http.get(this.url);
        }
        else {
            throw new Error('Base URL not set');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: VersionService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: VersionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: VersionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

class WorkflowService extends WorkflowDataService {
    get apiEndpoint() {
        return '/workflow';
    }
    simpleList() {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/simple`);
    }
    getRunningJobs(workflow) {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/${workflow.id}/running`);
    }
    getOpenJobs(workflow) {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/${workflow.id}/open`);
    }
    getResults(workflow, size = 1000, page = 0) {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/${workflow.id}/results?size=${size}&page=${page}&sort=lastUpdatedAt,desc`);
    }
    getDefinition(workflow) {
        return this.http.get(`${this.baseUrl + this.apiEndpoint}/${workflow.id}/definition`);
    }
    updateDefinition(workflow, definition) {
        return this.http.put(`${this.baseUrl + this.apiEndpoint}/${workflow.id}/definition`, definition);
    }
    activateDeactivateWorkflow(workflow) {
        if (workflow.status === WorkflowStatus.ACTIVE) {
            return this.disable(workflow);
        }
        else {
            return this.activate(workflow);
        }
    }
    activate(workflow) {
        return this.http.post(`${this.baseUrl + this.apiEndpoint}/${workflow.id}/activate`, {});
    }
    disable(workflow) {
        return this.http.post(`${this.baseUrl + this.apiEndpoint}/${workflow.id}/disable`, {});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkflowService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkflowService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkflowService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/* eslint-disable @typescript-eslint/no-explicit-any */
// Source: https://stackoverflow.com/a/37154736/11259799
/* eslint-disable no-restricted-globals */
const evalWorkerCode = (_this) => {
    // Create a reference to the original postMessage and addEventListener functions before deleting everything unallowed
    const origPostMessage = postMessage;
    const origAddEventListener = addEventListener;
    // encapasulate the delete operation in a function to avoid leaking the original this object
    ((obj) => {
        let current = obj;
        const keepProperties = [
            // Required
            'Object', 'Function', 'Infinity', 'NaN', 'undefined', 'caches', 'TEMPORARY', 'PERSISTENT',
            // Optional, but trivial to get back
            'Array', 'Boolean', 'Number', 'String', 'Symbol',
            // Optional
            'Map', 'Math', 'Set', 'JSON', 'console',
        ];
        do {
            // eslint-disable-next-line @typescript-eslint/no-loop-func
            Object.getOwnPropertyNames(current).forEach((name) => {
                if (keepProperties.indexOf(name) === -1) {
                    delete current[name];
                }
            });
            current = Object.getPrototypeOf(current);
        } while (current !== Object.prototype);
    })(_this);
    origAddEventListener('message', (e) => {
        const values = Object.values(e.data.context);
        // eslint-disable-next-line @typescript-eslint/no-implied-eval
        const f = (new Function(...Object.keys(e.data.context), e.data.code));
        origPostMessage(f(...values));
    });
};
function safeEvalWithParams(untrustedCode, context) {
    return from(new Promise((resolve, reject) => {
        // Prepare a blob containing the function to execute
        const blobURL = URL.createObjectURL(new Blob(['(', evalWorkerCode.toString(), ')(this)'], { type: 'application/javascript' }));
        // create a worker
        const worker = new Worker(blobURL);
        URL.revokeObjectURL(blobURL);
        // listen for messages from the worker
        worker.onmessage = (evt) => {
            worker.terminate();
            resolve(evt.data);
        };
        worker.onerror = (evt) => {
            // eslint-disable-next-line no-alert
            reject(new Error(evt.message));
        };
        // send the code to the worker
        worker.postMessage({ code: untrustedCode, context });
        // kill the worker if it takes too long
        setTimeout(() => {
            worker.terminate();
            reject(new Error('RuntimeError: The worker timed out.'));
        }, 1000);
    }));
}

class TabComponent {
    constructor(route, router, identifier, initialTab) {
        this.route = route;
        this.router = router;
        this.identifier = identifier;
        this.initialTab = initialTab;
        this.currentTab = signal('');
        this.loadedTabs = signal([]);
    }
    // eslint-disable-next-line @angular-eslint/contextual-lifecycle
    ngOnInit() {
        const params = this.route.snapshot.queryParams;
        const queryTab = params['tab'];
        if (queryTab) {
            this.currentTab.set(queryTab);
        }
        else {
            this.currentTab.set(this.getLastTab());
            this.changeQuery(this.currentTab());
        }
        this.loadedTabs.set([this.currentTab()]);
    }
    selectTab(tab) {
        this.currentTab.set(tab);
        const loadedTabs = this.loadedTabs();
        if (!loadedTabs.includes(tab)) {
            loadedTabs.push(tab);
            this.loadedTabs.set(loadedTabs);
        }
        this.changeQuery(tab);
    }
    changeQuery(tab) {
        const queryParams = {};
        queryParams['tab'] = tab;
        this.currentTab.set(tab);
        this.setLastTab(tab);
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams,
            queryParamsHandling: 'merge',
            replaceUrl: true,
        });
    }
    setLastTab(tab) {
        localStorage.setItem(`lastTab_${this.identifier}`, tab);
    }
    getLastTab() {
        return localStorage.getItem(`lastTab_${this.identifier}`) || this.initialTab;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TabComponent, deps: "invalid", target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TabComponent }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TabComponent, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.ActivatedRoute }, { type: i1$1.Router }, { type: undefined }, { type: undefined }] });

/* eslint-disable max-classes-per-file */
const defaultToolbarBuilder = (config) => [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ size: [false, 'large'] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ align: [] }],
    ['link', 'image', 'video', ...(config?.allowPdf ? ['pdf'] : [])],
    ...(config?.useTables
        ? [[
                'table_insert', 'table_append_row', 'table_append_column',
                'table_delete_row', 'table_delete_column', 'table_delete_table'
            ]]
        : []),
];
const defaultToolbar = defaultToolbarBuilder();
class IndentAttributor extends Parchment.StyleAttributor {
    add(node, value) {
        if (value === 0) {
            this.remove(node);
            return true;
        }
        else {
            return super.add(node, `${value}em`);
        }
    }
}
const IndentStyle = new IndentAttributor('indent', 'text-indent', {
    scope: Parchment.Scope.BLOCK,
    whitelist: ['1em', '2em', '3em', '4em', '5em', '6em', '7em', '8em', '9em'],
});
class SizeAttributor extends Parchment.StyleAttributor {
    add(node, value) {
        if (value === 'default') {
            this.remove(node);
            return true;
        }
        else {
            return super.add(node, value);
        }
    }
    value(node) {
        return super.value(node) || 'default';
    }
}
const SizeStyle = new SizeAttributor('size', 'font-size', {
    scope: Parchment.Scope.INLINE,
    whitelist: ['small', 'medium', 'large', 'huge'],
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const BlockEmbed = Quill.import('blots/block/embed');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ImageEmbed = Quill.import('formats/image');
class PDFBlot extends BlockEmbed {
    static { this.blotName = 'pdf'; }
    static { this.tagName = 'embed'; }
    static create(value) {
        const isObject = typeof value === 'object' && !Array.isArray(value) && value !== null;
        if (isObject) {
            const { src, key } = value;
            const node = super.create(value);
            node.setAttribute('src', src);
            node.setAttribute('data-file-key', key);
            node.setAttribute('type', 'application/pdf');
            node.setAttribute('width', '100%');
            node.setAttribute('height', '1000px');
            return node;
        }
        return super.create(value);
    }
    static value(node) {
        const fileSrc = node.getAttribute('src') ?? undefined;
        const fileKey = node.getAttribute('data-file-key') ?? undefined;
        return { src: fileSrc, key: fileKey };
    }
}
class ImageBlot extends ImageEmbed {
    static { this.blotName = 'image'; }
    static { this.tagName = 'img'; }
    static create(value) {
        const isObject = typeof value === 'object' && !Array.isArray(value) && value !== null;
        if (isObject) {
            const { src, key } = value;
            const node = super.create(value);
            node.setAttribute('src', src);
            node.setAttribute('data-file-key', key);
            return node;
        }
        return super.create(value);
    }
    static value(node) {
        const fileSrc = node.getAttribute('src') ?? undefined;
        const fileKey = node.getAttribute('data-file-key') ?? undefined;
        if (!fileKey) {
            return fileSrc;
        }
        return { src: fileSrc, key: fileKey };
    }
}
const icons = Quill.import('ui/icons');
/* eslint-disable max-len */
icons['pdf'] = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-pdf" viewBox="0 0 16 16"><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/><path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/></svg>';
// Tables icons
icons['table_insert'] = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-table" viewBox="0 0 16 16"><path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm15 2h-4v3h4zm0 4h-4v3h4zm0 4h-4v3h3a1 1 0 0 0 1-1zm-5 3v-3H6v3zm-5 0v-3H1v2a1 1 0 0 0 1 1zm-4-4h4V8H1zm0-4h4V4H1zm5-3v3h4V4zm4 4H6v3h4z"/></svg>';
icons['table_append_row'] = '<svg xmlns="http://www.w3.org/2000/svg" width="18px" height="16px" viewBox="0 -960 960 960" fill="currentColor"><path d="M200-560h560v-240H200v240Zm-80 400v-720h720v720H680v-80h80v-240H200v240h80v80H120Zm360-320Zm0-80v80-80Zm0 0ZM440-80v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80Z"/></svg>';
icons['table_append_column'] = '<svg xmlns="http://www.w3.org/2000/svg" width="18px" height="16px" viewBox="0 -960 960 960" fill="currentColor"><path d="M160-760v560h240v-560H160ZM80-120v-720h720v160h-80v-80H480v560h240v-80h80v160H80Zm400-360Zm-80 0h80-80Zm0 0Zm320 120v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80Z"/></svg>';
icons['table_delete_row'] = '<svg xmlns="http://www.w3.org/2000/svg" width="16px" height="20px" viewBox="371.296 -185.47 720.004 720.0031" fill="currentColor"><path d="M 451.296 134.533 L 1011.3 134.533 L 1011.3 -105.47 L 451.296 -105.47 L 451.296 134.533 Z M 371.296 534.533 L 371.296 -185.47 L 1091.3 -185.47 L 1091.3 534.533 L 931.296 534.533 L 931.296 454.533 L 1011.3 454.533 L 1011.3 214.533 L 451.296 214.533 L 451.296 454.533 L 531.296 454.533 L 531.296 534.533 L 371.296 534.533 Z M 731.296 214.533 Z M 731.296 134.533 L 731.296 214.533 L 731.296 134.533 Z M 731.296 134.533 Z M 771.296 386.533 L 691.296 386.533 L 611.296 386.533 L 611.296 306.533 L 691.296 306.533 L 771.296 306.533 L 851.296 306.533 L 851.296 386.533 L 771.296 386.533 Z" style="stroke-width: 1;"/></svg>';
icons['table_delete_column'] = '<svg xmlns="http://www.w3.org/2000/svg" width="16px" height="20px" viewBox="109.337 152.896 242.293 218.064" fill="currentColor"><path d="M 133.565 177.124 L 133.565 346.73 L 206.248 346.73 L 206.248 177.124 L 133.565 177.124 Z M 109.337 370.96 L 109.337 152.896 L 327.401 152.896 L 327.401 201.351 L 303.171 201.351 L 303.171 177.124 L 230.476 177.124 L 230.476 346.73 L 303.171 346.73 L 303.171 322.501 L 327.401 322.501 L 327.401 370.96 L 109.337 370.96 Z M 230.476 261.929 Z M 206.248 261.929 L 230.476 261.929 L 206.248 261.929 Z M 206.248 261.929 Z M 327.401 274.05 L 303.171 274.05 L 278.947 274.05 L 278.947 249.807 L 303.171 249.807 L 327.401 249.807 L 351.63 249.807 L 351.63 274.05 L 327.401 274.05 Z" style="stroke-width: 1;" transform="matrix(1, 0, 0, 1, 5.684341886080802e-14, 0)"/></svg>';
icons['table_delete_table'] = '<svg xmlns="http://www.w3.org/2000/svg" width="18px" height="32px" viewBox="0 -960 960 960" fill="currentColor"><path d="M333-200v-133H200v133h133Zm214 0v-100l-33-33H413v133h134Zm80 0Zm116-133Zm-410-80v-101l-33-33H200v134h133Zm80 0Zm347 0v-134H627v99l35 35h98ZM529-547Zm-329-80Zm347 0v-133H413v98l35 35h99Zm213 0v-133H627v133h133ZM316-760Zm524 525L235-840h525q33 0 56.5 23.5T840-760v525ZM200-120q-33 0-56.5-23.5T120-200v-640l720 720H200Zm619 92L28-820l56-56L876-84l-57 56Z"/></svg>';
/* eslint-enable max-len */
function initQuill() {
    ImageResizor.Quill = Quill;
    Quill.register('modules/imageResizor', ImageResizor);
    Quill.register(AlignStyle, true);
    Quill.register(BackgroundStyle, true);
    Quill.register(ColorStyle, true);
    Quill.register(DirectionStyle, true);
    Quill.register(FontStyle, true);
    Quill.register(IndentStyle, true);
    Quill.register(SizeStyle, true);
    Quill.register(PDFBlot, true);
    Quill.register(ImageBlot, true);
    Quill.register('table_insert', true);
    Quill.register('table_append_row', true);
    Quill.register('table_append_column', true);
    Quill.register('table_delete_row', true);
    Quill.register('table_delete_column', true);
    Quill.register('table_delete_table', true);
}

const IMPERSONATION_VERIFICATION_MAGIC = 'nimmsta.impersonation';
const IMPERSONATION_ORIGIN_QUERY_PARAM = 'imp-origin';
/**
 * Tries to get the impersonation data from local storage or through a broadcast channel.
 * If the impersonation data is found, it will be passed to the callback function.
 * If no impersonation data is found, the callback function will be called with null.
 *
 * @param configuration - The configuration object for the Nimmsta Commons module.
 * @param callback - The callback function to be called with the impersonation data.
 */
const tryGetImpersonationData = () => {
    // Check if we have impersonation data in session storage
    const impersonationData = sessionStorage.getItem(IMPERSONATION_SESSION_STORAGE_KEY);
    if (impersonationData) {
        return Promise.resolve(JSON.parse(impersonationData));
    }
    // Check if postMessage impersonation is enabled (via query parameter)
    const url = new URL(window.location.href);
    const impersonationOrigin = url.searchParams.get(IMPERSONATION_ORIGIN_QUERY_PARAM);
    if (impersonationOrigin !== null) {
        return new Promise((resolve, reject) => {
            // Remove the query parameter from the URL
            url.searchParams.delete(IMPERSONATION_ORIGIN_QUERY_PARAM);
            window.history.replaceState({}, '', url.toString());
            // Check if we have an opener window
            if (window.opener) {
                let timeout;
                // Define the message listener
                const messageListener = (event) => {
                    // Ensure the message is from the expected origin
                    if (event.origin !== impersonationOrigin) {
                        // eslint-disable-next-line no-console
                        console.error('Keycloak error: Data received from unexpected origin.');
                        return;
                    }
                    // Ensure the message is from "us"
                    if (event.data.source !== IMPERSONATION_VERIFICATION_MAGIC) {
                        // eslint-disable-next-line no-console
                        console.error('Keycloak error: Data received from unexpected source.');
                        return;
                    }
                    // Remove the event listener and clear the timeout
                    window.removeEventListener('message', messageListener);
                    clearTimeout(timeout);
                    // Ensure the message contains the impersonation data
                    if (event.data.access_token === undefined) {
                        reject(new Error('Keycloak error: Invalid impersonation data received.'));
                        return;
                    }
                    // Call the callback function with the impersonation data
                    resolve(event.data);
                };
                window.addEventListener('message', messageListener);
                // Set a timeout to remove the listener if no message is received
                timeout = setTimeout(() => {
                    window.removeEventListener('message', messageListener);
                    // Call the callback with null and hand back control to the caller
                    reject(new Error('Keycloak error: Impersonation data not received in time.'));
                }, 10_000); // 10 seconds
                // Notify the other tab that we are ready to receive the impersonation data
                window.opener.postMessage('ready', impersonationOrigin);
                // Print a message to the console to indicate that we are waiting for the impersonation data
                // eslint-disable-next-line no-console
                console.log('Info: Waiting for impersonation data. Timeout in 10s.');
            }
            else {
                // eslint-disable-next-line no-console
                reject(new Error('Keycloak error: No opener window found for impersonation.'));
            }
        });
    }
    // No impersonation data found
    return Promise.resolve(null);
};
/**
 * Launches the given page in a new tab and sends the impersonation data to it.
 * @param configuration configuration of the NimmstaCommonsModule
 * @param data impersonation data
 * @returns an error if the new tab could not be opened
 */
const launchImpersonationInNewTab = (authService, data, targetUrl = new URL(window.location.origin)) => {
    // Add timeout to close the listener in case the new tab is not opened
    let timeout;
    let newTab;
    // Define the message listener function
    const messageListener = (event) => {
        // Ensure the message is from the expected origin
        if (event.origin !== targetUrl.origin) {
            return;
        }
        // Check if the message is the ready message
        if (event.data !== 'ready') {
            return;
        }
        // Clear the timeout
        clearTimeout(timeout);
        // Remove the listener since it's no longer needed
        window.removeEventListener('message', messageListener);
        // Send the impersonation data to the new tab
        authService.getCurrentUser().subscribe({
            next: (user) => {
                newTab.postMessage({ ...data, source: IMPERSONATION_VERIFICATION_MAGIC, actor: user.email }, targetUrl.origin);
            },
            error: () => {
                newTab.postMessage({ ...data, source: IMPERSONATION_VERIFICATION_MAGIC }, targetUrl.origin);
            },
        });
    };
    window.addEventListener('message', messageListener);
    // Open the new tab
    targetUrl.searchParams.append(IMPERSONATION_ORIGIN_QUERY_PARAM, window.location.origin);
    newTab = window.open(targetUrl.toString(), '_blank');
    if (!newTab) {
        window.removeEventListener('message', messageListener);
        return new Error('Failed to open new tab, please verify popup are allowed on this page.');
    }
    // Set a timeout to remove the listener if the new tab is not opened
    timeout = setTimeout(() => {
        window.removeEventListener('message', messageListener);
        // eslint-disable-next-line no-console
        console.error('Keycloak error: Impersonation data request not received in time.');
    }, 5000);
    return null;
};

const noTokenPaths = [
    'assets/',
];
function initializeKeycloak(keycloak, configuration, router) {
    // wrap the initialization in a function to be able to use async/await
    return async () => {
        try {
            // Try to get the impersonation data
            const impersonationData = await tryGetImpersonationData();
            // If we have impersonation data, set in sessionStorage a property to allow for full-page reloads
            if (impersonationData) {
                sessionStorage.setItem(IMPERSONATION_SESSION_STORAGE_KEY, JSON.stringify(impersonationData));
                // register a listener when the user closes the browser tab to trigger a beacon call (which terminates the session)
                // unfortunately, this also triggers when the user reloads the page, as we can't distinguish between the two
                window.addEventListener('pagehide', (event) => {
                    if (!event.persisted) {
                        sessionStorage.removeItem(IMPERSONATION_SESSION_STORAGE_KEY);
                        sessionStorage.setItem(IMPERSONATION_SESSION_ENDED, 'true');
                        keycloak.getToken().then((token) => {
                            const tokenPayload = JSON.parse(atob(token.split('.')[1]));
                            navigator.sendBeacon(`${configuration.apiUrls.workflow}/api/v1/keycloak/session/${tokenPayload.sid}/terminate`, new URLSearchParams({ access_token: token }));
                        });
                    }
                });
            }
            // Parse the state fragment to get the kc_action_status (if present)
            const state = window.location.hash;
            const stateParams = new URLSearchParams(state);
            const kcActionStatus = stateParams.get('kc_action_status');
            const kcError = stateParams.get('error');
            if (kcActionStatus !== null) {
                // Set the kc_action_status in sessionStorage to allow other components to react to it
                sessionStorage.setItem('kc_action_status', kcActionStatus);
            }
            if (kcError !== null) {
                // Set the kc_error in sessionStorage to allow other components to react to it
                sessionStorage.setItem('kc_error', kcError);
            }
            const usedBackendUrls = Object.values(configuration.apiUrls).filter((url) => !!url);
            // Initialize Keycloak
            await keycloak.init({
                config: {
                    url: configuration.keycloakUrl,
                    realm: configuration.keycloakRealm,
                    clientId: configuration.keycloakClientId,
                },
                initOptions: {
                    onLoad: 'check-sso',
                    checkLoginIframe: false,
                    // See https://www.npmjs.com/package/keycloak-angular#setup
                    silentCheckSsoRedirectUri: `${window.location.origin}/assets/keycloak/silent-check-sso.html`,
                    // If impersonation data is present, use it to login
                    token: impersonationData?.access_token,
                    refreshToken: impersonationData?.refresh_token,
                    idToken: impersonationData?.id_token,
                },
                shouldAddToken: ({ url }) => usedBackendUrls.some((backendUrl) => url.startsWith(backendUrl))
                    && !noTokenPaths.some((path) => url.includes(path)),
            });
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error initializing Keycloak', error);
            router.navigate(['/500']);
        }
    };
}

class MultiTranslateHttpLoader extends TranslateHttpLoader {
    constructor(httpClient, translationFiles) {
        super(httpClient);
        this.httpClient = httpClient;
        this.translationFiles = translationFiles;
    }
    getTranslation(lang) {
        const resources = this.translationFiles.map((file) => ({ prefix: file, suffix: '.json' }));
        return forkJoin(resources.map((config) => this.httpClient.get(`${config.prefix}${lang}${config.suffix}`))).pipe(map((responses) => responses.reduce((merged, current) => this.deepMerge(merged, current), {})));
    }
    deepMerge(target, source) {
        const result = { ...target };
        Object.keys(source).forEach((key) => {
            const targetValue = target[key];
            const sourceValue = source[key];
            if (!sourceValue) {
                return;
            }
            else if (!targetValue) {
                result[key] = sourceValue;
                return;
            }
            // sourceValue and targetValue are both defined
            if (this.isTranslationObject(sourceValue) && this.isTranslationObject(targetValue)) {
                result[key] = this.deepMerge(targetValue, sourceValue);
            }
            else if (this.isTranslationObject(sourceValue)) {
                result[key] = sourceValue;
            }
            else {
                result[key] = targetValue;
            }
        });
        return result;
    }
    isTranslationObject(value) {
        return (value !== null
            && typeof value === 'object'
            && !(value instanceof Array)
            && !this.isPrimitive(value));
    }
    isPrimitive(value) {
        const type = typeof value;
        return value === null
            || type === 'string'
            || type === 'number'
            || type === 'boolean';
    }
}

let translationFiles = [];
dayjs.extend(localizedFormat);
function httpLoaderFactory(http) {
    return new MultiTranslateHttpLoader(http, translationFiles);
}
function getDefaultLanguage() {
    const userLanguage = navigator.language;
    if (userLanguage.startsWith('de')) {
        return 'de';
    }
    return 'en';
}
class NimmstaCommonsModule {
    constructor(intl) {
        if (getDefaultLanguage() === 'de') {
            // eslint-disable-next-line no-param-reassign
            intl.strings = strings$1;
        }
        else {
            // eslint-disable-next-line no-param-reassign
            intl.strings = strings;
        }
        intl.changes.next();
    }
    static forRoot(configuration) {
        translationFiles = configuration.translationFiles || ['assets/i18n/'];
        registerLocaleData(de.default);
        return {
            ngModule: NimmstaCommonsModule,
            providers: [
                { provide: NimmstaCommonsModuleConfiguration, useValue: configuration },
                {
                    provide: DataTableModuleConfiguration,
                    useValue: {
                        defaultPageSizeOptions: configuration.defaultPageSizeOptions,
                        defaultPageSize: configuration.defaultPageSize,
                        apiUrls: configuration.apiUrls,
                    },
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NimmstaCommonsModule, deps: [{ token: i3$1.TimeagoIntl }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: NimmstaCommonsModule, imports: [CommonModule,
            ReactiveFormsModule,
            RouterModule, i10.LaddaModule, i3$1.TimeagoModule, i2.TranslateModule, DataTableModule,
            ProfileModule,
            ComponentsModule,
            BasicCommonsModule], exports: [CommonModule,
            ReactiveFormsModule,
            LaddaModule,
            TranslateModule,
            DataTableModule,
            ComponentsModule,
            BasicCommonsModule,
            ProfileModule,
            NimmstaTimeAgoPipe,
            TimePipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NimmstaCommonsModule, providers: [
            { provide: HTTP_INTERCEPTORS, useClass: StatusInterceptor, multi: true },
            { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
            {
                provide: LOCALE_ID,
                deps: [TranslateService],
                useFactory: (translateService) => translateService.getBrowserCultureLang(),
            },
            {
                provide: APP_INITIALIZER,
                useFactory: initializeKeycloak,
                multi: true,
                deps: [KeycloakService, NimmstaCommonsModuleConfiguration, Router],
            },
            TimeagoPipe,
            PercentPipe,
            NimmstaTimeAgoPipe,
            TimePipe,
            DateTimePipe,
            provideAnimationsAsync(),
            providePrimeNG({
                theme: {
                    preset: definePreset(Lara, {
                        primitive: {
                            blue: {
                                50: '#f2f9fc',
                                100: '#c2e4ef',
                                200: '#91cfe3',
                                300: '#61bad6',
                                400: '#30a5ca',
                                500: '#0090bd',
                                600: '#007aa1',
                                700: '#006584',
                                800: '#004f68',
                                900: '#003a4c',
                            },
                            green: {
                                50: '#f6fbf6',
                                100: '#d4ecd5',
                                200: '#b2ddb4',
                                300: '#90cd93',
                                400: '#6ebe71',
                                500: '#4caf50',
                                600: '#419544',
                                700: '#357b38',
                                800: '#2a602c',
                                900: '#1e4620',
                            },
                            yellow: {
                                50: '#fffcf5',
                                100: '#fef0cd',
                                200: '#fde4a5',
                                300: '#fdd87d',
                                400: '#fccc55',
                                500: '#fbc02d',
                                600: '#d5a326',
                                700: '#b08620',
                                800: '#8a6a19',
                                900: '#644d12',
                            },
                            cyan: {
                                50: '#f2fcfd',
                                100: '#c2eff5',
                                200: '#91e2ed',
                                300: '#61d5e4',
                                400: '#30c9dc',
                                500: '#00bcd4',
                                600: '#00a0b4',
                                700: '#008494',
                                800: '#006775',
                                900: '#004b55',
                            },
                            pink: {
                                50: '#fef4f7',
                                100: '#fac9da',
                                200: '#f69ebc',
                                300: '#f1749e',
                                400: '#ed4981',
                                500: '#e91e63',
                                600: '#c61a54',
                                700: '#a31545',
                                800: '#801136',
                                900: '#5d0c28',
                            },
                            indigo: {
                                50: '#f5f6fb',
                                100: '#d1d5ed',
                                200: '#acb4df',
                                300: '#8893d1',
                                400: '#6372c3',
                                500: '#3f51b5',
                                600: '#36459a',
                                700: '#2c397f',
                                800: '#232d64',
                                900: '#192048',
                            },
                            teal: {
                                50: '#f2faf9',
                                100: '#c2e6e2',
                                200: '#91d2cc',
                                300: '#61beb5',
                                400: '#30aa9f',
                                500: '#009688',
                                600: '#008074',
                                700: '#00695f',
                                800: '#00534b',
                                900: '#003c36',
                            },
                            orange: {
                                50: '#fff8f2',
                                100: '#fde0c2',
                                200: '#fbc791',
                                300: '#f9ae61',
                                400: '#f79530',
                                500: '#f57c00',
                                600: '#d06900',
                                700: '#ac5700',
                                800: '#874400',
                                900: '#623200',
                            },
                            bluegray: {
                                50: '#f7f9f9',
                                100: '#d9e0e3',
                                200: '#bbc7cd',
                                300: '#9caeb7',
                                400: '#7e96a1',
                                500: '#607d8b',
                                600: '#526a76',
                                700: '#435861',
                                800: '#35454c',
                                900: '#263238',
                            },
                            purple: {
                                50: '#faf4fb',
                                100: '#e7cbec',
                                200: '#d4a2dd',
                                300: '#c279ce',
                                400: '#af50bf',
                                500: '#9c27b0',
                                600: '#852196',
                                700: '#6d1b7b',
                                800: '#561561',
                                900: '#3e1046',
                            },
                            red: {
                                50: '#fff5f5',
                                100: '#ffd1ce',
                                200: '#ffada7',
                                300: '#ff8980',
                                400: '#ff6459',
                                500: '#ff4032',
                                600: '#d9362b',
                                700: '#b32d23',
                                800: '#8c231c',
                                900: '#661a14',
                            },
                        },
                        semantic: {
                            primary: {
                                50: '#f2f9fc',
                                100: '#c2e4ef',
                                200: '#91cfe3',
                                300: '#61bad6',
                                400: '#30a5ca',
                                500: '#0090bd',
                                600: '#007aa1',
                                700: '#006584',
                                800: '#004f68',
                                900: '#003a4c',
                            },
                            focusRing: {
                                width: '0.2rem',
                                color: '#bfd1f6',
                            },
                            surface: {
                                ground: '#f8f9fa',
                                section: '#ffffff',
                                card: '#ffffff',
                                overlay: '#ffffff',
                                border: '#dee2e6',
                                hover: '#e9ecef',
                                a: '#ffffff',
                                b: '#f8f9fa',
                                c: '#e9ecef',
                                d: '#dee2e6',
                                e: '#ffffff',
                                f: '#ffffff',
                            },
                        },
                        colorScheme: {
                            light: {
                                primary: {
                                    color: '#2196f3',
                                },
                                highlight: {
                                    background: '#0090bd',
                                    color: '#000000',
                                },
                                surface: {
                                    0: '#ffffff',
                                    50: '#fafafa',
                                    100: '#f5f5f5',
                                    200: '#eeeeee',
                                    300: '#e0e0e0',
                                    400: '#bdbdbd',
                                    500: '#9e9e9e',
                                    600: '#757575',
                                    700: '#616161',
                                    800: '#424242',
                                    900: '#212121',
                                },
                            },
                        },
                    }),
                    options: {
                        darkModeSelector: 'none',
                    },
                },
            }),
        ], imports: [CommonModule,
            ReactiveFormsModule,
            RouterModule,
            LaddaModule.forRoot({
                style: 'zoom-out',
            }),
            TimeagoModule.forRoot({
                formatter: { provide: TimeagoFormatter, useClass: TimeagoCustomFormatter },
                intl: { provide: TimeagoIntl, useClass: TimeagoIntl },
            }),
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: httpLoaderFactory,
                    deps: [HttpClient],
                },
                defaultLanguage: getDefaultLanguage(),
            }),
            DataTableModule,
            ProfileModule,
            ComponentsModule,
            BasicCommonsModule, CommonModule,
            ReactiveFormsModule,
            LaddaModule,
            TranslateModule,
            DataTableModule,
            ComponentsModule,
            BasicCommonsModule,
            ProfileModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NimmstaCommonsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        RouterModule,
                        LaddaModule.forRoot({
                            style: 'zoom-out',
                        }),
                        TimeagoModule.forRoot({
                            formatter: { provide: TimeagoFormatter, useClass: TimeagoCustomFormatter },
                            intl: { provide: TimeagoIntl, useClass: TimeagoIntl },
                        }),
                        TranslateModule.forRoot({
                            loader: {
                                provide: TranslateLoader,
                                useFactory: httpLoaderFactory,
                                deps: [HttpClient],
                            },
                            defaultLanguage: getDefaultLanguage(),
                        }),
                        DataTableModule,
                        ProfileModule,
                        ComponentsModule,
                        BasicCommonsModule,
                    ],
                    providers: [
                        { provide: HTTP_INTERCEPTORS, useClass: StatusInterceptor, multi: true },
                        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
                        {
                            provide: LOCALE_ID,
                            deps: [TranslateService],
                            useFactory: (translateService) => translateService.getBrowserCultureLang(),
                        },
                        {
                            provide: APP_INITIALIZER,
                            useFactory: initializeKeycloak,
                            multi: true,
                            deps: [KeycloakService, NimmstaCommonsModuleConfiguration, Router],
                        },
                        TimeagoPipe,
                        PercentPipe,
                        NimmstaTimeAgoPipe,
                        TimePipe,
                        DateTimePipe,
                        provideAnimationsAsync(),
                        providePrimeNG({
                            theme: {
                                preset: definePreset(Lara, {
                                    primitive: {
                                        blue: {
                                            50: '#f2f9fc',
                                            100: '#c2e4ef',
                                            200: '#91cfe3',
                                            300: '#61bad6',
                                            400: '#30a5ca',
                                            500: '#0090bd',
                                            600: '#007aa1',
                                            700: '#006584',
                                            800: '#004f68',
                                            900: '#003a4c',
                                        },
                                        green: {
                                            50: '#f6fbf6',
                                            100: '#d4ecd5',
                                            200: '#b2ddb4',
                                            300: '#90cd93',
                                            400: '#6ebe71',
                                            500: '#4caf50',
                                            600: '#419544',
                                            700: '#357b38',
                                            800: '#2a602c',
                                            900: '#1e4620',
                                        },
                                        yellow: {
                                            50: '#fffcf5',
                                            100: '#fef0cd',
                                            200: '#fde4a5',
                                            300: '#fdd87d',
                                            400: '#fccc55',
                                            500: '#fbc02d',
                                            600: '#d5a326',
                                            700: '#b08620',
                                            800: '#8a6a19',
                                            900: '#644d12',
                                        },
                                        cyan: {
                                            50: '#f2fcfd',
                                            100: '#c2eff5',
                                            200: '#91e2ed',
                                            300: '#61d5e4',
                                            400: '#30c9dc',
                                            500: '#00bcd4',
                                            600: '#00a0b4',
                                            700: '#008494',
                                            800: '#006775',
                                            900: '#004b55',
                                        },
                                        pink: {
                                            50: '#fef4f7',
                                            100: '#fac9da',
                                            200: '#f69ebc',
                                            300: '#f1749e',
                                            400: '#ed4981',
                                            500: '#e91e63',
                                            600: '#c61a54',
                                            700: '#a31545',
                                            800: '#801136',
                                            900: '#5d0c28',
                                        },
                                        indigo: {
                                            50: '#f5f6fb',
                                            100: '#d1d5ed',
                                            200: '#acb4df',
                                            300: '#8893d1',
                                            400: '#6372c3',
                                            500: '#3f51b5',
                                            600: '#36459a',
                                            700: '#2c397f',
                                            800: '#232d64',
                                            900: '#192048',
                                        },
                                        teal: {
                                            50: '#f2faf9',
                                            100: '#c2e6e2',
                                            200: '#91d2cc',
                                            300: '#61beb5',
                                            400: '#30aa9f',
                                            500: '#009688',
                                            600: '#008074',
                                            700: '#00695f',
                                            800: '#00534b',
                                            900: '#003c36',
                                        },
                                        orange: {
                                            50: '#fff8f2',
                                            100: '#fde0c2',
                                            200: '#fbc791',
                                            300: '#f9ae61',
                                            400: '#f79530',
                                            500: '#f57c00',
                                            600: '#d06900',
                                            700: '#ac5700',
                                            800: '#874400',
                                            900: '#623200',
                                        },
                                        bluegray: {
                                            50: '#f7f9f9',
                                            100: '#d9e0e3',
                                            200: '#bbc7cd',
                                            300: '#9caeb7',
                                            400: '#7e96a1',
                                            500: '#607d8b',
                                            600: '#526a76',
                                            700: '#435861',
                                            800: '#35454c',
                                            900: '#263238',
                                        },
                                        purple: {
                                            50: '#faf4fb',
                                            100: '#e7cbec',
                                            200: '#d4a2dd',
                                            300: '#c279ce',
                                            400: '#af50bf',
                                            500: '#9c27b0',
                                            600: '#852196',
                                            700: '#6d1b7b',
                                            800: '#561561',
                                            900: '#3e1046',
                                        },
                                        red: {
                                            50: '#fff5f5',
                                            100: '#ffd1ce',
                                            200: '#ffada7',
                                            300: '#ff8980',
                                            400: '#ff6459',
                                            500: '#ff4032',
                                            600: '#d9362b',
                                            700: '#b32d23',
                                            800: '#8c231c',
                                            900: '#661a14',
                                        },
                                    },
                                    semantic: {
                                        primary: {
                                            50: '#f2f9fc',
                                            100: '#c2e4ef',
                                            200: '#91cfe3',
                                            300: '#61bad6',
                                            400: '#30a5ca',
                                            500: '#0090bd',
                                            600: '#007aa1',
                                            700: '#006584',
                                            800: '#004f68',
                                            900: '#003a4c',
                                        },
                                        focusRing: {
                                            width: '0.2rem',
                                            color: '#bfd1f6',
                                        },
                                        surface: {
                                            ground: '#f8f9fa',
                                            section: '#ffffff',
                                            card: '#ffffff',
                                            overlay: '#ffffff',
                                            border: '#dee2e6',
                                            hover: '#e9ecef',
                                            a: '#ffffff',
                                            b: '#f8f9fa',
                                            c: '#e9ecef',
                                            d: '#dee2e6',
                                            e: '#ffffff',
                                            f: '#ffffff',
                                        },
                                    },
                                    colorScheme: {
                                        light: {
                                            primary: {
                                                color: '#2196f3',
                                            },
                                            highlight: {
                                                background: '#0090bd',
                                                color: '#000000',
                                            },
                                            surface: {
                                                0: '#ffffff',
                                                50: '#fafafa',
                                                100: '#f5f5f5',
                                                200: '#eeeeee',
                                                300: '#e0e0e0',
                                                400: '#bdbdbd',
                                                500: '#9e9e9e',
                                                600: '#757575',
                                                700: '#616161',
                                                800: '#424242',
                                                900: '#212121',
                                            },
                                        },
                                    },
                                }),
                                options: {
                                    darkModeSelector: 'none',
                                },
                            },
                        }),
                    ],
                    exports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LaddaModule,
                        TranslateModule,
                        DataTableModule,
                        ComponentsModule,
                        BasicCommonsModule,
                        ProfileModule,
                        NimmstaTimeAgoPipe,
                        TimePipe,
                    ],
                }]
        }], ctorParameters: () => [{ type: i3$1.TimeagoIntl }] });

/*
 * Public API Surface of nimmsta-angular-commons-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractDataService, AppModelModalComponent, AuthGuard, AuthInterceptor, AuthService, B2bDataService, BaseModel, BasicCommonsModule, BooleanIconPipe, Column, ComponentsModule, ConfigurationDataService, ConfirmationDialogComponent, ContentType, ContentViewRoles, ContentVisibility, ContentsService, CountdownTimerPipe, CustomAction, CustomTableAction, CustomValidators, DataConnectionStatus, DataConnectionType, DataTableComponent, DataTableModule, DataTableModuleConfiguration, DateEvalPipe, DatePipe, DateTimeFormat, DateTimePipe, DefaultLayoutComponent, DefaultMenuComponent, EditorComponent, EmptyTableComponent, EndpointMethod, EnhancedFormArray, EnhancedFormControl, EnhancedFormGroup, Environment, ErrorComponent, FeatureFlag, FileSizePipe, HeaderBarComponent, IMPERSONATION_SESSION_ENDED, IMPERSONATION_SESSION_STORAGE_KEY, IconAction, InputWithErrorComponent, JobStatus, KeycloakSessionService, LOWEST_USER_ROLE, LanguageService, LanguageSwitcherComponent, LoadType, LoadingIndicatorComponent, NAV_ITEM_SERVICE, NavItem, NimmstaCommonsModule, NimmstaCommonsModuleConfiguration, NimmstaDataSource, NimmstaTimeAgoPipe, OfflineToastComponent, OrdinalDatePipe, Organization, OrganizationService, OrganizationStatus, OrganizationType, P404Component, P500Component, PageType, ParentOrganization, ProfileComponent, ProfileModule, ProfileSessionComponent, RequestVerificationCodeType, RequestVerificationService, SaveableFormComponent, ServiceType, Software, SoftwareArtifact, SoftwareArtifactReleaseType, SoftwareArtifactStatus, SoftwareLabel, SoftwarePlatform, SoftwareService, SoftwareStatus, SoftwareType, SoftwareVisibility, StatusBadgePipe, StatusInterceptor, TabComponent, TimePipe, UserRole, UserService, UserStatus, VersionService, WaitingListComponent, WorkerStatus, WorkflowDataService, WorkflowService, WorkflowStatus, defaultToolbar, defaultToolbarBuilder, evalWorkerCode, httpLoaderFactory, initQuill, launchImpersonationInNewTab, safeEvalWithParams };
